/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "////front.tiyushe.com/dist/shangou_new/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = avalon;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
    var tool = __webpack_require__(16),
        $ = __webpack_require__(3);

    return tool.init($);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var $ = __webpack_require__(3),
        dialog = __webpack_require__(4),
        gRequest = null;

    $.ajaxSetup({
        dataType: 'json',
        beforeSend: function beforeSend(request) {
            gRequest = request;
        }
    });

    function addDeferred(func, withFail, args) {
        var dtd = $.Deferred();
        func.apply($, args).done(function (response, statusText, jqXHR) {
            if (response.message) {
                response.msg = response.message;
            }
            if (withFail) {
                if (response.type === 'success' || response.type === 'succ') {
                    dtd.resolveWith(this, [response, statusText, jqXHR]);
                } else if (response.type === 'error' || response.type === 'err') {
                    dtd.rejectWith(this, [response, statusText, jqXHR]);
                }
            } else {
                dtd.resolveWith(this, [response, statusText, jqXHR]);
            }
        }).fail(function (jqXHR, statusText, error) {
            if (error !== 'abort') {
                dialog.alert(error);
            }
            dtd.rejectWith(this, [error, statusText, jqXHR]);
        });

        dtd.fail(function (response, statusText, jqXHR) {
            if (withFail && (typeof response === 'undefined' ? 'undefined' : (0, _typeof3.default)(response)) === 'object' && (response.type === 'error' || response.type === 'err')) {
                if (response.code === 302) {
                    window.location.href = response.url;
                } else {
                    dialog.alert(response.message || response.msg);
                }
            }
            dtd.rejectWith(this, [response, statusText, jqXHR]);
        });

        dtd.request = gRequest;

        return dtd;
    }

    var ajax = {
        get: function get() {
            return addDeferred($.get, false, arguments);
        },
        getWithFail: function getWithFail() {
            return addDeferred($.get, true, arguments);
        },
        getJSON: function getJSON() {
            return addDeferred($.getJSON, false, arguments);
        },
        getJSONWithFail: function getJSONWithFail() {
            return addDeferred($.getJSON, true, arguments);
        },
        post: function post() {
            return addDeferred($.post, false, arguments);
        },
        postWithFail: function postWithFail() {
            return addDeferred($.post, true, arguments);
        },
        ajax: function ajax() {
            return addDeferred($.ajax, false, arguments);
        },
        ajaxWithFail: function ajaxWithFail() {
            return addDeferred($.ajax, true, arguments);
        },
        pjax: function pjax(url, container, data) {
            if ($.support.pjax) {
                container = container || '#pjax-container';
                data = data || {};
                $.pjax({ url: url, container: container, data: data });
            } else {
                this.jump(url);
            }
        },
        jump: function jump(url) {
            window.location.href = url;
        },
        newPage: function newPage(url) {
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
        }
    };

    window.ajax = ajax;

    return ajax;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    function tmplFunc(string, data) {
        var _str = string;
        $.each(data, function (key, value) {
            _str = _str.replace(new RegExp('{{' + key + '}}', 'g'), value);
        });
        return _str;
    }

    var $ = __webpack_require__(3),
        ie6 = !-[1] && !window.XMLHttpRequest,
        body = $('body'),
        headerHeight = 50,
        tmpl = ["<div id='dialog'>", "<div class='d-header'>", "<h1 class='d-title'>{{title}}</h1>", "<a href='javascript:void(0)' class='d-h-btn iconfont d-h-btn-close' title='关闭'>&#xe618;</a>", '</div>', "<div class='d-body'>{{html}}</div>", '</div>'].join(''),
        allDialogs = {},
        defaultOptions = {
        width: 500,
        height: 400,
        title: '这是title',
        html: '这是测试', //  弹出层内容
        destroyOnClose: false, //  如果为TRUE则在点击关闭的时候销毁弹出层对象，否则隐藏弹出层
        onOpen: null, //	弹出层事件，在显示前触发
        onClose: null, //  弹出层事件，在关闭前触发
        onInit: null //  弹出层事件，在初始化完成之后触发
    },
        baseIndex = 1000;

    function zIndex() {
        return baseIndex++;
    }

    function Dialog(options) {
        var that = this;
        that.cache = {};
        that.id = new Date().getTime();
        that.isDetroyed = false;
        that.options = $.extend(false, defaultOptions, options);
        that.overlay = $("<div class='overlay'>").appendTo(body);
        // IE6 需要加一个iframe 的层来阻挡 IE6 select 穿透的问题
        if (ie6) {
            that.overlay2 = $("<iframe class='overlay'>").appendTo(body);
        }
        that.domDialog = $(tmplFunc(tmpl, that.options)).appendTo(body);
        that.domBody = that.domDialog.find('.d-body');
        that.domClose = that.domDialog.find('.d-h-btn-close');
        that.domDialog.css({
            width: that.options.width,
            height: that.options.height,
            marginLeft: -(that.options.width / 2),
            marginTop: -(that.options.height / 2)
        });
        that.domBody.css({
            height: that.options.height - headerHeight
        });

        that.domClose.on('click', function () {
            if (that.destroyOnClose) {
                that.destroy();
            } else {
                that.close();
            }
        });

        if (typeof that.options.onInit === 'function') {
            that.options.onInit.call(that, that, that.domBody);
        }

        allDialogs[that.id] = that;
    }

    Dialog.prototype = {
        /*
        弹出层显示
        */
        open: function open() {
            // onOpen 事件存在就执行， 如果执行返回为false， 则拒绝打开弹出层
            if (typeof this.options.onOpen === 'function' && this.options.onOpen.call(this, this, this.domBody) === false) {
                return;
            }
            var that = this;
            that.goTop();
            that.overlay.show();
            that.domDialog.css('top', '50%');
            ie6 && this.overlay2.show();
            body.addClass('scrub');
        },
        /*
        弹出层隐藏
        */
        close: function close() {
            var that = this;

            // onclose 事件存在就执行， 如果执行返回为false， 则拒绝关闭弹出层
            if (typeof that.options.onClose === 'function' && that.options.onClose.call(that, that, that.domBody) === false) {
                return;
            }

            that.overlay.hide();
            that.domDialog.css('top', '-100%');
            ie6 && this.overlay2.hide();
            body.removeClass('scrub');
        },
        onlyClose: function onlyClose() {
            var that = this;

            that.overlay.hide();
            that.domDialog.css('top', '-100%');
            ie6 && this.overlay2.hide();
            body.removeClass('scrub');
        },
        /*
        弹出层销毁DOM
        */
        destroy: function destroy() {
            if (this.isDetroyed === false) {
                var that = this;
                // onclose 事件存在就执行， 如果执行返回为false， 则拒绝关闭弹出层
                if (typeof that.options.onClose === 'function' && that.options.onClose.call(that, that, that.domBody) === false) {
                    return;
                }

                this.overlay.remove();
                this.domDialog.remove();
                if (ie6) {
                    this.overlay2.remove();
                }
                this.clean();
                this.isDetroyed = true;
                delete allDialogs[this.id];
            }
        },
        onlyDestroy: function onlyDestroy() {
            if (this.isDetroyed === false) {
                this.overlay.remove();
                this.domDialog.remove();
                if (ie6) {
                    this.overlay2.remove();
                }
                this.clean();
                this.isDetroyed = true;
                delete allDialogs[this.id];
            }
        },
        /*
        弹出层销毁对象
        */
        clean: function clean() {
            var that = this;
            $.each(that, function (key, val) {
                if (Object.hasOwnProperty.call(that, key)) {
                    delete that[key];
                }
            });
        },
        /*
        重新设置标题
        */
        setTitle: function setTitle(title) {
            this.domDialog.find('.d-title').text(title);
        },
        /*
        重新设置内容
        */
        setHtml: function setHtml(html) {
            this.domBody.html(html);
        },
        /*
        重新设置弹出层的zIndex，让它浮在最前
        */
        goTop: function goTop() {
            this.overlay.css({ zIndex: zIndex() });
            ie6 && this.overlay2.css({ zIndex: zIndex() });
            this.domDialog.css({ zIndex: zIndex() });
        }
    };

    return {
        /*
        @param:options 	弹出层初始化的必须参数
        @return 		弹出层对象
        */
        init: function init(options) {
            return new Dialog(options);
        },
        /*
        @param:text 提示内容
        @param:onOK 点击确定时触发
        */
        alert: function () {
            var dialog = null;
            var tmpl = ["<div class='d-b-alert'>", "<div class='d-text'><p>{{text}}</p></div>", "<div class='d-operate'><a href='javascript:void(0)' class='btn d-custom-ok' style>确定</a></div>", '</div>'].join('');
            return function (text, title, onOK, onCancel) {
                if (typeof title !== 'string') {
                    onOK = title;
                    onCancel = onOK;
                }
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 420,
                        height: 245,
                        title: typeof title === 'string' ? title : '提示',
                        onClose: function onClose(dialog, body) {
                            if (typeof dialog.cache.onCancel === 'function' && dialog.cache.onCancel.call(dialog, dialog, body) === false) {}
                        },
                        onInit: function onInit(dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if (typeof dialog.cache.onOK === 'function' && dialog.cache.onOK.call(dialog, dialog, body) === false) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onOK = onOK;
                dialog.cache.onCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, { text: text }));
                dialog.open();
                return dialog;
            };
        }(),
        /*
        @param:text 		提示内容
        @param:onOK 		点击确定时触发
        @param:onCancel 	点击取消和关闭时触发
        */
        confirm: function () {
            var dialog = null,
                tmpl = ["<div class='d-b-confirm'>", "<div class='d-text'><p>{{text}}</p></div>", "<div class='d-operate'>", "<a href='javascript:void(0)' class='btn d-custom-cancel'>{{cancelText}}</a>", "<a href='javascript:void(0)' class='btn d-custom-ok' style='background-color: 	#DC143C;'>{{okText}}</a>", '</div>', '</div>'].join(''),
                defaultOptions = {
                cancelText: '取消',
                okText: '确认'
            };
            return function (text, onOK, onCancel, options) {
                var _options = $.extend(true, { text: text }, defaultOptions, options);
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 350,
                        height: 248,
                        title: '提示',
                        onClose: function onClose(dialog, body) {
                            if (typeof dialog.cache.onConfirmCancel === 'function' && dialog.cache.onConfirmCancel.call(dialog, dialog, body) === false) {
                                return false;
                            }
                        },
                        onInit: function onInit(dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if (typeof dialog.cache.onConfirmOK === 'function' && dialog.cache.onConfirmOK.call(dialog, dialog, body) === false) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                            body.on('click', '.d-custom-cancel', function () {
                                if (typeof dialog.cache.onConfirmCancel === 'function' && dialog.cache.onConfirmCancel.call(dialog, dialog, body) === false) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onConfirmOK = onOK;
                dialog.cache.onConfirmCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, _options));
                dialog.open();
                return dialog;
            };
        }(),
        /*
        @param:label 		输入内容的标题
        @param:title 		输入弹出层的标题
        @param:placeholder 	输入弹出层的标题
        @param:onOK 		点击确定时触发
        @param:onCancel 	点击取消和关闭时触发
        */
        prompt: function () {
            var dialog = null;
            var tmpl = ["<div class='d-b-prompt'>", "<div class='d-form form-small'>", "<p class='label'>{{label}}</p>", "<div class='text-wrap'><textarea type='text' class='d-b-prompt-input' placeholder='{{placeholder}}'></textarea></div>", "<div class='row'><p class='error'></p></div>", '</div>', "<div class='d-operate'>", "<a href='javascript:void(0)' class='btn d-custom-cancel'>取消</a>", "<a href='javascript:void(0)' class='btn d-custom-ok'>确定</a>", '</div>', '</div>'].join('');
            function setErrorText(text) {
                dialog.domBody.find('.error').html(text);
            }
            return function (label, placeholder, onOK, onCancel) {
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 350,
                        height: 270,
                        title: '提示',
                        onClose: function onClose(dialog, body) {
                            if (typeof dialog.cache.onPromptCancel === 'function' && dialog.cache.onPromptCancel.call(dialog, dialog, body, setErrorText) === false) {
                                return false;
                            }
                        },
                        onInit: function onInit(dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if ($(this).hasClass('disable')) {
                                    return;
                                }
                                var value = body.find('.d-b-prompt-input').val();
                                if (typeof dialog.cache.onPromptOK === 'function' && dialog.cache.onPromptOK.call(dialog, value, dialog, body, setErrorText) === false) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                            body.on('click', '.d-custom-cancel', function () {
                                if ($(this).hasClass('disable')) {
                                    return;
                                }
                                if (typeof dialog.cache.onPromptCancel === 'function') {
                                    if (dialog.cache.onPromptCancel.call(dialog, dialog, body, setErrorText) === false) {
                                        return;
                                    }
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onPromptOK = onOK;
                dialog.cache.onPromptCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, {
                    label: label,
                    placeholder: placeholder || ''
                }));
                dialog.open();
                return dialog;
            };
        }(),
        /*
        全局显示 加载中的蒙版
        */
        mask: function () {
            var overlay = null;
            var mask = null;
            return {
                // 显示蒙版
                show: function show() {
                    if (overlay === null) {
                        overlay = $("<div class='overlay'>").appendTo(body);
                        mask = $("<div class='mask'><i></i>正在努力加载中...</div>").appendTo(body);
                    }
                    overlay.css({ zIndex: zIndex() });
                    mask.css({ zIndex: zIndex() });
                    overlay.show();
                    mask.show();
                },
                // 隐藏蒙版
                hide: function hide() {
                    if (overlay === null) {
                        overlay = $("<div class='overlay'>").appendTo(body);
                        mask = $("<div class='mask'><i></i>正在努力加载中...</div>").appendTo(body);
                    }
                    overlay.fadeOut();
                    mask.fadeOut();
                }
            };
        }(),
        /*
        pjax 全局进度条
        */
        progress: function () {
            var progress = null;
            return {
                show: function show(percent) {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(body);
                    }
                    progress.show();
                    setTimeout(function () {
                        progress.css({
                            zIndex: zIndex(),
                            width: percent + '%',
                            opacity: 1
                        });
                    }, 0);
                },
                width: function width(percent) {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(body);
                    }
                    progress.css({ width: percent + '%' });
                },
                hide: function hide() {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(body);
                    }
                    progress.hide();
                    progress.css({ width: '0%' });
                },
                fadeOut: function fadeOut() {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(body);
                    }
                    progress.css({ opacity: 0 });
                },
                fadeIn: function fadeIn() {
                    progress.css({ opacity: 1 });
                }
            };
        }(),
        /*
        liushengjie新增的全局显示窗口,为中羽联用户绑定而写
        @param:text 提示内容
        @param:onOK 点击确定时触发
        */
        zylBind: function () {
            var dialog = null;
            var tmpl = ["<div class='d-b-alert'>", "<div class='d-text'><p>{{text}}</p></div>", '</div>'].join('');
            return function (text, onOK, onCancel) {
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 480,
                        height: 480,
                        title: '请确认你的密码',
                        onClose: function onClose(dialog, body) {
                            if (typeof dialog.cache.onCancel === 'function' && dialog.cache.onCancel.call(dialog, dialog, body) === false) {
                                return '';
                            }
                        },
                        onInit: function onInit(dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if (typeof dialog.cache.onOK === 'function' && dialog.cache.onOK.call(dialog, dialog, body) === false) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onOK = onOK;
                dialog.cache.onCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, { text: text }));
                dialog.open();
                return dialog;
            };
        }(),
        /*
        @return			获取全局zIndex计数
        */
        zIndex: zIndex,
        /*
        清理所有的弹出层对象
        */
        clear: function clear() {
            $.each(allDialogs, function (id, _dialog) {
                _dialog.destroy();
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(42);
var toPrimitive = __webpack_require__(33);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var createDesc = __webpack_require__(21);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(95);
var defined = __webpack_require__(23);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(31)('wks');
var uid = __webpack_require__(22);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(82);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(81);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var tool = __webpack_require__(16);

    function generate(total, page, count) {
        total = tool.toNumber(total);
        page = tool.toNumber(page);
        count = tool.toNumber(count);

        if (total === 0) {
            return [];
        }

        var res = [],
            pageCount = Math.ceil(total / count),
            start = Math.max(page - 4, 1),
            end = Math.min(start + 8, pageCount),
            dis = end - start,
            _end = Math.min(page + 4, pageCount),
            _start = Math.max(_end - 8, 1),
            _dis = _end - _start;

        if (_dis > dis) {
            start = _start;
            end = _end;
        }

        // 如果起始页不为1页，则显示首页
        if (start !== 1) {
            res.push({
                text: '首页',
                target: 1,
                disable: false,
                cur: false
            });
        }

        // 如果当前页不为1，则有上一页
        if (page !== 1) {
            res.push({
                text: '上一页',
                target: page - 1,
                disable: false,
                cur: false
            });
        }

        for (var i = start; i <= end; i++) {
            res.push({
                text: '' + i,
                target: i,
                disable: i === page,
                cur: i === page
            });
        }

        // 如果当前页不为最后一页，则有下一页
        if (page !== pageCount) {
            res.push({
                text: '下一页',
                target: page + 1,
                disable: false,
                cur: false
            });
        }

        // 如果结尾页不为最后一页，则有最后一页
        if (end !== pageCount) {
            res.push({
                text: '尾页',
                target: pageCount,
                disable: false,
                cur: false
            });
        }

        return res;
    }

    return {
        /**
         * 分页初始化
         * @param {Number} total 总条数
         * @param {Number} page	 当前页
         * @param {Number} count 每页的条数
         */
        init: function init(total, page, count) {
            return generate(total, page, count);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
    var _tool;

    var $ = null,
        appHelper = {},
        beforeLoadHTML = '<span>下拉刷新</span>',
        releaseLoadHTML = '<span>释放立即刷新</span>',
        loadSuccessHTML = '<span>加载成功</span>',
        loadErrorHTML = '<span>加载失败，请稍后再试</span>',
        noMoreHTML = '<span>没有更多了,请稍后再试</span>',
        noMoreNoStartHTML = '<span>没有更多了</span>',
        LoadingHTML = "<i class='icon'></i><span>正在加载中...</span>",
        tool = (_tool = {
        init: function init(jquery, _appHelper) {
            $ = jquery;

            if (_appHelper) {
                var option = ['bindGlobalFunc', 'checkApp', 'checkLogin', 'checkAppLogin', 'checkTYSNAV', 'alert', 'showConfirm', 'showLoading', 'hideLoading', 'onAppEvent', 'offAppEvent', 'onAppReady', 'reloadPage', 'pipe'];
                for (var i = 0; i < option.length; i++) {
                    tool[option[i]] = _appHelper[option[i]];
                }
            }

            return tool;
        },

        /**
         * wait时间之内只执行一次
         * @param url
         * @param data
         * @returns {string}
         */
        debounce: function () {
            var time = new Date().getTime();
            return function (func, wait) {
                var ctime = new Date().getTime();
                if (ctime - time > wait) {
                    func();
                    time = ctime;
                }
            };
        }(),

        debounce2: function debounce2(func, wait) {
            // 获取初始化时间戳
            var then = new Date().getTime();
            // 返回函数
            return function () {
                var now = new Date().getTime();
                // 如果
                if (now - then > wait) {
                    func.apply(null, arguments);
                    then = now;
                }
            };
        },

        debounce3: function debounce3(action, wait) {
            var last;
            return function () {
                var ctx = this,
                    args = arguments;
                clearTimeout(last);
                last = setTimeout(function () {
                    action.apply(ctx, args);
                }, wait);
            };
        },

        tmpl: function tmpl(string, data) {
            var _str = string;
            $.each(data, function (key, value) {
                _str = _str.replace(new RegExp('{{' + key + '}}', 'g'), value);
            });
            return _str;
        },

        getType: function getType(data) {
            return Object.prototype.toString.call(data).replace(/(^\[object )|(\]$)/g, '');
        },

        stopDefault: function stopDefault(e) {
            //阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) e.preventDefault();else
                //IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            return false;
        },

        stopBubble: function stopBubble(e) {
            //如果提供了事件对象，则这是一个非IE浏览器
            if (e && e.stopPropagation)
                //因此它支持W3C的stopPropagation()方法
                e.stopPropagation();else
                //否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
        },

        /**
         * 打印一个对象到控制台
         * @param {Object} target
         */
        log: function log(target) {
            var _res = [];
            if (tool.getType(target) === 'array' || tool.getType(target) === 'object') {
                $.each(target, function (key, val) {
                    _res.push(key + ':' + key);
                });
                _res = _res.join(',');
            } else {
                _res = target;
            }
            console && typeof console.log === 'function' && console.log(_res);
        },

        // 对Date的扩展，将 Date 转化为指定格式的String
        // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
        // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
        // 例子：
        // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
        // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
        formatDate: function formatDate(date, fmt) {
            //author: meizz
            var d = new Date(date);
            fmt = fmt || 'yyyy-MM-dd';
            var o = {
                'M+': d.getMonth() + 1, //月份
                'd+': d.getDate(), //日
                'h+': d.getHours(), //小时
                'm+': d.getMinutes(), //分
                's+': d.getSeconds(), //秒
                'q+': Math.floor((d.getMonth() + 3) / 3), //季度
                S: d.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }return fmt;
        },

        isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1, //android终端

        isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端

        isPhone: function isPhone() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os';
            var bIsMidp = sUserAgent.match(/midp/i) == 'midp';
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
            var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb';
            var bIsAndroid = sUserAgent.match(/android/i) == 'android';
            var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
            var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
            if (bIsIpad || bIsMidp || bIsIphoneOs || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                return true;
            } else {
                return false;
            }
        },

        /**
         * 获取显示宽度
         */
        getClientWidth: function getClientWidth() {
            return document.documentElement.clientWidth || document.body.clientWidth;
        },

        /**
         * 获取显示高度
         */
        getClientHeight: function getClientHeight() {
            return document.documentElement.clientHeight || document.body.clientHeight;
        },

        /**
         * 获取文档高度
         */
        getScrollHeight: function getScrollHeight() {
            return document.documentElement.scrollHeight || document.body.scrollHeight;
        },

        /**
         * 获取隐藏域的值
         * @param {String} selector 隐藏域集合的选择器
         */
        getHiddenValues: function getHiddenValues(selector) {
            var res = {};
            var container = $(selector);
            container.find('input[type=hidden]').each(function (i, input) {
                var $input = $(input);
                res[$input.attr('name')] = $input.val();
            });
            container.find('textarea').each(function (i, input) {
                var $input = $(input);
                res[$input.attr('name')] = $.parseJSON($input.val());
            });
            return res;
        },

        /**
         * 将数字转化为金钱的显示方式
         * @param {number} money
         */
        toMoney: function toMoney(money) {
            if (money === 0) {
                return '0.00';
            }
            money = Math.round(money * 100);
            money = '' + money;
            if (money.length === 1) {
                return '0.0' + money;
            } else if (money.length === 2) {
                return '0.' + money;
            } else {
                return money.slice(0, money.length - 2) + '.' + money.slice(money.length - 2, money.length);
            }
        },

        /**
         * 将字符串转化为数字
         * @param {String} str
         */
        toNumber: function toNumber(str) {
            return parseFloat(str);
        },

        parseJson: function parseJson(str, init) {
            try {
                return JSON.parse(str) || init;
            } catch (e) {
                return init;
            }
        },

        /**
         *
         */
        onWindowScroll: function () {
            var funcs = {},
                $win = null,
                started = false;

            function start() {
                if (started) {
                    return;
                }
                $win = $(window);
                started = true;
                $win.on('scroll', function (e) {
                    var scrollTop = $win.scrollTop();
                    $.each(funcs, function (k, func) {
                        func.call(e, e, scrollTop);
                    });
                });
            }
            return {
                on: function on(func) {
                    start();
                    var key = new Date().getTime();
                    funcs[key] = func;
                    $win.trigger('scroll');
                },
                off: function off(key) {
                    start();
                    delete funcs[key];
                },
                clear: function clear() {
                    start();
                    funcs = {};
                },
                trigger: function trigger() {
                    start();
                    $win.trigger('scroll');
                }
            };
        }(),

        scrollTo: function () {
            var body = null,
                win = null;
            return function (target, offsetTop) {
                if (offsetTop === undefined) {
                    offsetTop = 40;
                }
                body = body || $('body');
                win = win || $(window);
                var currentTop = win.scrollTop();
                if (typeof target === 'number') {
                    var targetTop = target;
                } else {
                    var position = target.offset(),
                        targetTop = position.top - offsetTop;
                }

                body.css({ defineTop: 0 });
                body.animate({
                    defineTop: targetTop - currentTop
                }, {
                    speed: 500,
                    easing: 'swing',
                    queue: false,
                    step: function step(top) {
                        win.scrollTop(currentTop + top);
                    }
                });
            };
        }(),

        fixNum: function fixNum(num) {
            return num < 10 ? '0' + num : num;
        },

        funTransitionHeight: function funTransitionHeight(element, time) {
            // time, 数值，可缺省
            if (typeof window.getComputedStyle == 'undefined') return;

            var height = window.getComputedStyle(element).height;
            element.style.height = 'auto';
            var targetHeight = window.getComputedStyle(element).height;
            element.style.height = height;
            setTimeout(function () {
                if (time) element.style.transition = 'height ' + time + 'ms';
                element.style.height = targetHeight;
            }, 15);
            return tool;
        },

        fixHeight: function fixHeight(el1, el2) {
            el2.css('height', el1.height());
            return tool;
        },

        fixTitle: function fixTitle(data) {
            if (data.title) {
                document.title = data.title;
            }
            return tool;
        },

        max: function max(array) {
            if (array.length === 0) {
                return NaN;
            } else if (array.length === 1) {
                return array[0];
            } else {
                var _max = array[0];
                for (var i = 1, j = array.length; i < j; i++) {
                    _max = Math.max(_max, array[i]);
                }
                return _max;
            }
        },

        min: function min(array) {
            if (array.length === 0) {
                return NaN;
            } else if (array.length === 1) {
                return array[0];
            } else {
                var _min = array[0];
                for (var i = 1, j = array.length; i < j; i++) {
                    _min = Math.min(_min, array[i]);
                }
                return _min;
            }
        },

        /*
         * 把一段事件格式化为多少天多少小时多少秒
         * @param 需要格式化的时间段  为毫秒数
         * @param 返回数据的前缀
         */
        formatTime: function formatTime(time, prefix) {
            var miniSeconds = 1,
                dayTime = miniSeconds * 60 * 60 * 24,
                days = 0,
                hourTime = miniSeconds * 60 * 60,
                hours = 0,
                minuteTime = miniSeconds * 60,
                minutes = 0,
                secondTime = miniSeconds,
                seconds = 0,
                res = [prefix || ''];

            if (time >= dayTime) {
                days = Math.floor(time / dayTime);
                res.push(tool.fixNum(days) + '天');
                time -= days * dayTime;
            } else {
                res.push('00天');
            }
            if (time >= hourTime) {
                hours = Math.floor(time / hourTime);
                res.push(tool.fixNum(hours) + '时');
                time -= hours * hourTime;
            } else {
                res.push('00时');
            }
            if (time >= minuteTime) {
                minutes = Math.floor(time / minuteTime);
                res.push(tool.fixNum(minutes) + '分');
                time -= minutes * minuteTime;
            } else {
                res.push('00分');
            }
            if (time >= secondTime) {
                seconds = Math.floor(time / secondTime);
                res.push(tool.fixNum(seconds) + '秒');
                time -= seconds * secondTime;
            } else {
                res.push('00秒');
            }
            return res.join('');
        },

        checkJSON: function checkJSON(data) {
            if (typeof data === 'string') {
                data = $.parseJSON(data);
            }
            return data;
        },

        /*
         * 批量设置avalon的vmodel里面的值
         * @param vm avalon的vmodel
         * @param target 需要插入的值
         */
        setVMValues: function setVMValues(vm, target, key) {
            var _key = '',
                _obj = null;

            if (key) {
                vm = eval('vm.' + key);
            }

            for (var name in target) {
                _obj = target[name];
                if (vm[name] !== undefined) {
                    _key = name;
                }
                if (vm['$' + name] !== undefined) {
                    _key = '$' + name;
                }
                if (_key !== '') {
                    if ((0, _typeof3.default)(vm[_key]) === 'object' && (0, _typeof3.default)(target[name]) !== 'object') {
                        _obj = $.parseJSON(target[name]);
                    }
                    vm[_key] = _obj;
                }
                _obj = null;
                _key = '';
            }

            return tool;
        },

        /**
         * 单例的方法，同一时间只能运行一次，除非触发了完成
         */
        singleWay: function () {
            var fgs = {},
                kit = {
                resolve: function resolve(key) {
                    fgs[key] = false;
                }
            };

            return function (key, func) {
                if (fgs[key] === true) {
                    return;
                } else {
                    fgs[key] = true;
                    func.call(kit, key);
                }
            };
        }(),

        /**
         * 延时500毫秒执行函数
         */
        delay: function delay(func) {
            return setTimeout(function () {
                func && func();
            }, 500);
        },

        /**
         * 检查数据里面是否存在该节点
         * @param {Array} array 需要检查的数组
         * @param {Object} target 需要检查的对象或者简单数据类型
         * @param {String} key 如果需要检查的对象只需匹配某个属性的值相同则认为对象相等
         * @return {boolean} 存在返回true 不存在返回false
         */
        checkExistInArray: function checkExistInArray(array, target, key) {
            if (array.length > 0) {
                var res = false;
                for (var i in array) {
                    if (key) {
                        if (array[i][key] === target[key]) {
                            return true;
                        }
                    } else {
                        if (array[i] === target) {
                            return true;
                        }
                    }
                }
                return false;
            } else {
                return false;
            }
        },

        /**
         * 向北京的统计服务器发送埋点的统计，目前仅统计商城
         * @param {String} type app => 访问的app链接  pc => 访问的pc链接
         * @param {String} action 操作，由北京定义 (如step100，step200)
         * @param {String} userid 用户id
         * @param {Object} param 某些特定的action需要增加的参数
         * @param {String} from 统计的网站： mall=>商城  (默认为mall)
         */
        sendEventTracking: function sendEventTracking(type, action, param, userid, from) {
            // if(typeof userid == "undefined"){
            // 	userid = $("[name='userid']").val();
            // }
            // var data = {
            // 	type: type,
            // 	action: action,
            // 	userid: userid
            // };
            // for(var i in param){
            // 	data[i] = param[i];
            // }
            // $.ajax({
            // 	url: "http://210.14.143.210/",
            // 	data: data,
            // 	dataType: "jsonp"
            // }).done(function(response){
            // 	//console.log(response);
            // });
        },

        /**
         *	获取浏览器所带的参数
         * @returns {}
         */
        getUrlParams: function getUrlParams() {
            var url = window.location.href;
            var indexQ = url.indexOf('?');
            var indexJ = url.indexOf('#');
            if (indexJ === -1) {
                indexJ = url.length;
            }
            var url2 = url.slice(indexQ + 1, indexJ);
            var url3 = url.slice(indexJ + 1);

            function toParam(str) {
                var _param = str.split('&'),
                    _res = {};
                $.each(_param, function (i, _str) {
                    var key = _str.split('=')[0];
                    var value = _str.split('=')[1];
                    _res[key] = value;
                });
                return _res;
            }

            var res = {};
            if (indexQ !== -1) {
                res = toParam(url2);
            }
            if (indexJ !== -1) {
                res = $.extend(true, res, toParam(url3));
            }
            return res;
        },

        /**
         * 给链接添加参数
         * @param url
         * @param data
         * @returns {string}
         */
        addParamToUrl: function addParamToUrl(url, data) {
            var res = [];
            $.each(data, function (key, val) {
                res.push(key + '=' + val);
            });
            res = res.join('&');
            if (url.indexOf('?') !== -1) {
                url += '&' + res;
            } else {
                url += '?' + res;
            }
            return url;
        }
    }, (0, _defineProperty3.default)(_tool, 'debounce', function () {
        var time = new Date().getTime();
        return function (func, wait) {
            var ctime = new Date().getTime();
            if (ctime - time > wait) {
                func();
                time = ctime;
            }
        };
    }()), (0, _defineProperty3.default)(_tool, 'debounce2', function debounce2(func, wait) {
        // 获取初始化时间戳
        var then = new Date().getTime();
        // 返回函数
        return function () {
            var now = new Date().getTime();
            // 如果
            if (now - then > wait) {
                func.apply(null, arguments);
                then = now;
            }
        };
    }), (0, _defineProperty3.default)(_tool, 'bindGlobalFunc', appHelper.bindGlobalFunc), (0, _defineProperty3.default)(_tool, 'checkApp', appHelper.checkApp), (0, _defineProperty3.default)(_tool, 'checkLogin', appHelper.checkLogin), (0, _defineProperty3.default)(_tool, 'checkAppLogin', appHelper.checkAppLogin), (0, _defineProperty3.default)(_tool, 'checkTYSNAV', appHelper.checkTYSNAV), (0, _defineProperty3.default)(_tool, 'alert', appHelper.alert), (0, _defineProperty3.default)(_tool, 'showConfirm', appHelper.showConfirm), (0, _defineProperty3.default)(_tool, 'showLoading', appHelper.showLoading), (0, _defineProperty3.default)(_tool, 'hideLoading', appHelper.hideLoading), (0, _defineProperty3.default)(_tool, 'onAppEvent', appHelper.onAppEvent), (0, _defineProperty3.default)(_tool, 'offAppEvent', appHelper.offAppEvent), (0, _defineProperty3.default)(_tool, 'onAppReady', appHelper.onAppReady), (0, _defineProperty3.default)(_tool, 'reloadPage', appHelper.reloadPage), (0, _defineProperty3.default)(_tool, 'onScrollBottom', function onScrollBottom(callback, firstLoad) {
        tool.onWindowScroll.on(function () {
            var array = [].slice.call(arguments),
                st = array[1],
                sh = tool.getScrollHeight(),
                ch = tool.getClientHeight();

            if (sh - (st + ch) < 30) {
                array.push(sh);
                array.push(ch);
                callback.apply(document, array);
            }
        });

        if (firstLoad) {
            callback.apply(document);
        }

        return tool;
    }), (0, _defineProperty3.default)(_tool, 'fixBody', function fixBody(fixing, time, defaultWidth) {
        var scrollTop,
            defaultWidth = defaultWidth || 550;
        if (fixing) {
            var fix = function fix() {
                scrollTop = $(document).scrollTop();
                window.FIXSCROLLTOP = scrollTop;
                $('body').css({
                    position: 'fixed',
                    top: -scrollTop,
                    width: window.screen.width > defaultWidth ? defaultWidth : window.screen.width,
                    left: window.screen.width > defaultWidth ? (window.screen.width - defaultWidth) / 2 : 0
                });
            };time && setTimeout(fix, time) || fix();
        } else {
            scrollTop = window.FIXSCROLLTOP || 0;
            $('body').css({
                position: 'static',
                top: 0,
                width: 'auto',
                left: 0
            });
            $(document).scrollTop(scrollTop);
        }

        return tool;
    }), (0, _defineProperty3.default)(_tool, 'scrollUtil', function () {
        var _dis = 10,
            // 离底部x像素就算到底部了
        _res = {
            isBottom: function isBottom(bottomHeight) {
                bottomHeight = typeof bottomHeight === 'undefined' ? 0 : bottomHeight;
                var st = $(window).scrollTop(),
                    sh = tool.getScrollHeight(),
                    ch = tool.getClientHeight();

                //							tool.log({
                //								st: st,
                //								sh: sh,
                //								ch: ch,
                //								'st+ch': st+ch,
                //								'sh-bottomHeight': sh-bottomHeight
                //							});

                // 当内容高度小于等于屏幕高度
                if (sh <= ch) {
                    return true;
                } else {
                    if (st + ch > sh - bottomHeight - _dis) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            /**
             *
             * @param {Number} bottomHeight
             * @param {Function} callback
             */
            onBottom: function onBottom(bottomHeight, callback) {
                tool.onWindowScroll.on(function () {
                    if (_res.isBottom(bottomHeight)) {
                        callback && callback();
                    }
                });
            },
            /**
             * 通过windowscroll事件判断加载更多
             * @param {Number} bottomHeight
             * @param {Object} vmodel
             * @param {String} htmlKey
             * @param {Function} callback
             */
            addLoadMore: function addLoadMore(bottomHeight, vmodel, htmlKey, callback) {
                var _loading = false,
                    _nomore = false,
                    _timer = 0,
                    _request = null,
                    _kit = {
                    success: function success() {
                        clearTimeout(_timer);
                        _loading = false;
                        vmodel[htmlKey] = loadSuccessHTML;
                    },
                    error: function error() {
                        clearTimeout(_timer);
                        vmodel[htmlKey] = loadErrorHTML;
                        _timer = setTimeout(function () {
                            vmodel[htmlKey] = LoadingHTML;
                            _request = callback();
                        }, 5000);
                    },
                    noMoreNoStart: function noMoreNoStart() {
                        clearTimeout(_timer);
                        _nomore = true;
                        _loading = false;
                        vmodel[htmlKey] = noMoreNoStartHTML;
                    },
                    nomore: function nomore() {
                        clearTimeout(_timer);
                        vmodel[htmlKey] = noMoreHTML;
                        setTimeout(function () {
                            _loading = false;
                        }, 5000);
                    },
                    reset: function reset() {
                        clearTimeout(_timer);
                        _loading = false;
                        _nomore = false;
                        vmodel[htmlKey] = LoadingHTML;
                        _request && _request.abort && _request.abort();
                    },
                    loadMore: function loadMore() {
                        _callback();
                    }
                },
                    _callback = function _callback() {
                    if (_loading) {
                        return;
                    } else if (_nomore === false) {
                        vmodel[htmlKey] = LoadingHTML;
                        _loading = true;
                        _request = callback();
                    } else {
                        vmodel[htmlKey] = noMoreNoStartHTML;
                    }
                };

                _res.onBottom(bottomHeight, function () {
                    setTimeout(function () {
                        _callback();
                    }, 10);
                });
                return _kit;
            },
            clear: function clear() {
                tool.onWindowScroll.clear();
            }
        };

        return _res;
    }()), (0, _defineProperty3.default)(_tool, 'picLayout', function () {
        var winWidth = document.documentElement.clientWidth || document.body.clientWidth,
            displayWidth = winWidth - 10 - 20,
            imgMargin = 5,
            config = {
            1: {
                width: displayWidth,
                height: (displayWidth - imgMargin) / 2
            },
            2: {
                width: (displayWidth - imgMargin) / 2,
                height: (displayWidth - imgMargin) / 2
            },
            3: {
                width: (displayWidth - imgMargin * 2) / 3,
                height: (displayWidth - imgMargin * 2) / 3
            }
        };

        return {
            /**
             * 给imgs设计出图片显示宽高
             * @param {Array} target
             * @param {String} key
             */
            fix: function fix(target, key) {
                $.each(target, function (i, obj) {
                    var _config = null;
                    if (obj[key].length === 1) {
                        _config = config[1];
                    } else if (obj[key].length === 2) {
                        _config = config[2];
                    } else if (obj[key].length === 3) {
                        _config = config[3];
                    }

                    if (_config) {
                        obj.displayWidth = _config.width;
                        obj.displayHeight = _config.height;
                    }
                });
            },
            getConfig: function getConfig(borderWidth, imgMargin) {
                displayWidth = winWidth - borderWidth;
                return {
                    1: {
                        width: displayWidth,
                        height: (displayWidth - imgMargin) / 2
                    },
                    2: {
                        width: (displayWidth - imgMargin) / 2,
                        height: (displayWidth - imgMargin) / 2
                    },
                    3: {
                        width: (displayWidth - imgMargin * 2) / 3,
                        height: (displayWidth - imgMargin * 2) / 3
                    }
                };
            }
        };
    }()), (0, _defineProperty3.default)(_tool, 'iscrollKit', function () {
        return {
            addRefresh: function addRefresh(scrollInstance, vmodel, htmlKey, displayKey, loadingKey, callback) {
                var timer = 0;
                var kit = {
                    loadSuccess: function loadSuccess() {
                        vmodel[htmlKey] = loadSuccessHTML;
                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            scrollInstance.scrollTo(0, 0, 600, scrollInstance.options.bounceEasing);
                            vmodel[htmlKey] = '';
                            vmodel[displayKey] = false;
                            vmodel[loadingKey] = false;
                            scrollInstance.offsetY = 0;
                        }, 1000);
                    },
                    loadError: function loadError() {
                        vmodel[htmlKey] = loadErrorHTML;
                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            scrollInstance.scrollTo(0, 0, 600, scrollInstance.options.bounceEasing);
                            vmodel[htmlKey] = '';
                            vmodel[displayKey] = false;
                            vmodel[loadingKey] = false;
                            scrollInstance.offsetY = 0;
                        }, 1000);
                    },
                    loadEmpty: this.loadSuccess,
                    release: function release() {
                        scrollInstance.scrollTo(0, 0);
                        vmodel[htmlKey] = '';
                        vmodel[displayKey] = false;
                        vmodel[loadingKey] = false;
                        scrollInstance.offsetY = 0;
                    }
                };

                scrollInstance.on('scroll', function () {
                    if (!vmodel[loadingKey]) {
                        if (this.y > 0 && this.y < 50) {
                            vmodel[displayKey] = true;
                            vmodel[htmlKey] = beforeLoadHTML;
                        } else if (this.y >= 50) {
                            vmodel[htmlKey] = releaseLoadHTML;
                        }
                    }
                });

                scrollInstance.on('touchEnd', function () {
                    if (this.y >= 50 && !vmodel[loadingKey]) {
                        vmodel[htmlKey] = LoadingHTML;
                        scrollInstance.offsetY = 50;
                        vmodel[loadingKey] = true;
                        callback && callback.call(kit);
                    }
                });

                return {
                    refresh: function refresh() {
                        vmodel[displayKey] = true;
                        vmodel[loadingKey] = true;
                        vmodel[htmlKey] = LoadingHTML;
                        scrollInstance.offsetY = 50;
                        scrollInstance.scrollTo(0, 50);
                        callback && callback.call(kit);
                    }
                };
            },
            addLoadMore: function addLoadMore(scrollInstance, vmodel, htmlKey, displayKey, loadingKey, callback) {
                var timer = 0;
                var kit = {
                    loadSuccess: function loadSuccess() {
                        vmodel[htmlKey] = loadSuccessHTML;
                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            vmodel[htmlKey] = '';
                            vmodel[displayKey] = false;
                            vmodel[loadingKey] = false;
                            scrollInstance.refresh();
                        }, 1000);
                    },
                    loadEmpty: function loadEmpty() {
                        vmodel[htmlKey] = noMoreHTML;
                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            vmodel[htmlKey] = '';
                            vmodel[displayKey] = false;
                            vmodel[loadingKey] = false;
                            scrollInstance.refresh();
                        }, 1000);
                    },
                    loadError: function loadError() {
                        vmodel[htmlKey] = loadErrorHTML;
                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            vmodel[htmlKey] = '';
                            vmodel[displayKey] = false;
                            vmodel[loadingKey] = false;
                            scrollInstance.refresh();
                        }, 1000);
                    },
                    release: function release() {
                        scrollInstance.scrollTo(0, 0);
                        vmodel[htmlKey] = '';
                        vmodel[displayKey] = false;
                        vmodel[loadingKey] = false;
                    }
                };

                scrollInstance.on('scroll', function () {
                    if (this.maxScrollY - this.y > 10 && !vmodel[loadingKey]) {
                        vmodel[htmlKey] = LoadingHTML;
                        vmodel[loadingKey] = true;
                        vmodel[displayKey] = true;
                        callback && callback.call(kit);
                        scrollInstance.refresh();
                    }
                });

                //						scrollInstance.on('touchEnd', function(){
                //							if (this.y >= 50 && !vmodel[loadingKey]) {
                //								vmodel[htmlKey] = LoadingHTML;
                //								scrollInstance.offsetY = 50;
                //								vmodel[loadingKey] = true;
                //								callback && callback.call(kit);
                //							}
                //						});
            }
        };
    }()), _tool);

    return tool;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(6);
var ctx = __webpack_require__(92);
var hide = __webpack_require__(10);
var has = __webpack_require__(8);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(17);
var dPs = __webpack_require__(100);
var enumBugKeys = __webpack_require__(24);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(41)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(94).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(46);
var enumBugKeys = __webpack_require__(24);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(9).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(31)('keys');
var uid = __webpack_require__(22);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(6);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(20) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(6);
var LIBRARY = __webpack_require__(20);
var wksExt = __webpack_require__(35);
var defineProperty = __webpack_require__(9).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*
 * LightBox 1.0
 * Copyright (c) 2015 小坏 http://tnnyang.cnblogs.com
 * 仅用于PC端
 * 图片放大以后还可以左右切换
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    var $ = __webpack_require__(3);

    function imgobj(obj1, obj2) {
        //imgObj.height是通过img对象获取的图片的实际高度
        var imgObj = new Image();
        imgObj.src = obj1.attr("src");

        var body = $('body'),
            width = imgObj.width,
            height = imgObj.height,
            margintop;
        //如果图片宽高小于浏览器宽高
        if (height < body.height() * 0.95 && width < body.width() * 0.95) {
            margintop = 0 - height / 2;
        } else if (width / height < body.width() / body.height()) {
            //如果图片宽高比小于浏览器宽高比
            height = body.height() * 0.95;
            width = imgObj.width * height / imgObj.height;
            margintop = 0 - height / 2;
        } else {
            width = body.width() * 0.95;
            height = imgObj.height * width / imgObj.width;
            margintop = 0 - height / 2;
        }
        obj2.css("margin-top", margintop);
        obj1.attr("width", width);
        obj1.attr("height", height);
    }

    var numpic = 0,
        num = 0;

    return {
        //初始化PC图片大图查看 创建一个div
        init: function init() {
            var lb_wrap = '<div class="lb_wrap"><div class="lightbox_bg"></div><div class="lightbox"><img src="" class="lg_img"></div></div>';
            $("body").append(lb_wrap);

            $(".lightbox").append('<p class="prev"></p><p class="next"></p>');
        },

        /**
         * 查看大图
         * @param {String} imgs 图片数组
         * @param {String} index 当前放大图片索引
         */
        show: function show(imgs, index) {
            //显示图片
            numpic = imgs.length;
            num = index; //获取当前图片的父元素的索引并赋给num为后边点击上一张、下一张服务

            var src = imgs[index];
            $(".lg_img").attr("src", src);
            imgobj($(".lg_img"), $(".lightbox"));

            $(".lb_wrap").fadeIn();
            $(".lg_img").fadeIn();
            $(".prev").fadeIn().siblings(".next").fadeIn();

            //上一张
            $(".prev").click(function () {
                if (num == 0) {
                    num = numpic;
                }
                var src = imgs[num - 1];
                $(".lg_img").attr("src", src);
                imgobj($(".lg_img"), $(".lightbox"));

                num--;
            });

            //下一张
            $(".next").click(function () {
                if (num == numpic - 1) {
                    num = -1;
                }
                var src = imgs[num + 1];
                $(".lg_img").attr("src", src);
                imgobj($(".lg_img"), $(".lightbox"));

                num++;
            });

            //点击除了上一张、下一张之外的其他地方隐藏
            $(".lb_wrap").click(function (e) {
                var e = e || window.event;
                var elem = e.target || e.srcElement;
                while (elem) {
                    if (elem.className && elem.className.indexOf('prev') > -1) {
                        return;
                    }
                    if (elem.className && elem.className.indexOf('next') > -1) {
                        return;
                    }
                    elem = elem.parentNode;
                }
                $(this).find("img").attr("src", "loading.gif").hide(); //隐藏后，再将默认的图片赋给lightbox中图片的src
                $(this).find(".prev").hide().siblings(".next").hide();
                $(this).fadeOut();
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	var $ = __webpack_require__(3);

	var defaultOptions = {
		width: 400,
		height: 400,
		auto: true,
		timer: 5000,
		imgs: [],
		forBg: false,
		pagination: {
			currentLeft: 0,
			width: 420,
			height: 80,
			itemWidth: 84,
			maxItemLength: 5,
			itemCss: {
				width: 80,
				height: 80,
				margin: '0 2px'
			}
		},
		onClick: null
	};

	function Slider(options) {
		var that = this;
		that.options = $.extend(true, {}, defaultOptions, options);
		that.dom = $(that.options.selector);
		that.window = that.dom.find('.slider-window');
		that.collection = that.window.find('.slider-collection');

		that.window.css({
			width: that.options.width,
			height: that.options.height
		});

		that.window.on('click', '.slider-item', function () {
			var $me = $(this),
			    index = $me.data('index');
			that.options.onClick && that.options.onClick.call(this, index);
		});

		that.setImgs(that.options.imgs);
	}

	Slider.prototype = {
		start: function start() {
			var that = this;
			that.timer = setTimeout(function () {
				that.moveLeft();
			}, that.options.timer);
		},
		setImgs: function setImgs(list) {
			var that = this;
			clearTimeout(that.timer);
			var html = [];
			if (that.options.forBg) {
				$.each(list, function (i, src) {
					html.push("<li class='slider-item' data-index='" + (i + 1) + "' style='background-image:url(" + src + ")'></li>");
				});
			} else {
				$.each(list, function (i, src) {
					html.push("<li class='slider-item' data-index='" + (i + 1) + "'><img src='" + src + "'></li>");
				});
			}

			that.collection.html(html.join(''));
			that.items = that.collection.find('.slider-item');
			that.itemsLength = list.length;
			that.curIndex = 1;

			that.items.css({
				width: that.options.width,
				height: that.options.height
			});

			that._renderPagination();

			if (that.options.auto && that.itemsLength > 1) {
				that.start();
			}
		},
		onAfterMove: function onAfterMove() {
			var that = this;
			if (that.options.auto) {
				that.start();
			}
		},
		moveLeft: function moveLeft() {
			var that = this,
			    curIndex = that.curIndex,
			    nextIndex = curIndex === that.itemsLength ? 1 : curIndex + 1;
			that.move(nextIndex);
		},
		move: function move(index) {
			if (this.itemsLength <= 1) {
				return;
			} else {
				var that = this,
				    targetIndex = index,
				    targetDom = this.collection.find('li:eq(' + (targetIndex - 1) + ')'),
				    curIndex = that.curIndex,
				    curDom = this.collection.find('li:eq(' + (curIndex - 1) + ')'),
				    opposite = targetIndex > curIndex ? 1 : -1,
				    itemWidth = 0;

				if (that.options.width === '100%') {
					itemWidth = that.window.width();
				} else {
					itemWidth = that.options.width;
				}

				targetDom.css({ left: opposite * itemWidth, sliderLeft: 0 });
				targetDom.stop(true).animate({
					sliderLeft: itemWidth
				}, {
					speed: 500,
					easing: 'swing',
					queue: false,
					step: function step(sliderLeft) {
						curDom.css({ left: -opposite * (sliderLeft / itemWidth * Math.max(1920, itemWidth)) });
						targetDom.css({ left: opposite * (itemWidth - sliderLeft) });
						if (sliderLeft === itemWidth) {
							that.onAfterMove();
						}
					}
				});

				clearTimeout(that.timer);
				that._setCurIndex(targetIndex);
			}
		},
		_setCurIndex: function _setCurIndex(index) {

			var that = this,
			    _paginationOption = that.options.pagination;

			if (that.items.length > _paginationOption.maxItemLength) {
				var _start = Math.abs(_paginationOption.currentLeft / _paginationOption.itemWidth) + 1;
				if (index - _start >= _paginationOption.maxItemLength || index < _start) {
					_paginationOption.currentLeft = -_paginationOption.itemWidth * Math.min(index - 1, that.itemsLength - _paginationOption.maxItemLength);
					that.pagiCollection.css('margin-left', _paginationOption.currentLeft);
					that._hidepaginationBtn();
				}
			}
			that.curIndex = index;
			that.pagiCollection.find('li.cur').removeClass('cur');
			that.pagiCollection.find('li[data-index=' + that.curIndex + ']').addClass('cur');
		},
		_renderPagination: function _renderPagination() {
			var that = this;

			that.pagination = $(that.options.pagination.selector);

			if (that.pagination.length) {
				that.pagination.css({
					width: that.options.pagination.width,
					height: that.options.pagination.height
				});

				var html = ["<ul class='slider-pagination-collection clearfix'>"];
				that.items.each(function (index, dom) {
					var $item = $(dom);
					$item.attr({ 'data-index': index + 1 });
					html.push('<li class="slider-pagination-item ' + (index == 0 ? 'cur' : '') + '" data-index=' + (index + 1) + '>' + that.options.pagination.render($item) + '</li>');
				});
				html.push('</ul>');
				html.push('<div class="slider-pagination-left"></div>');
				html.push('<div class="slider-pagination-right"></div>');
				that.pagination.html(html.join(''));
				that.pagiCollection = that.pagination.find('.slider-pagination-collection');
				that.pagiCollection.css({ width: that.options.pagination.itemWidth * that.items.length });
				that.pagiCollection.find('li').css(that.options.pagination.itemCss);
				that.paginationLeft = that.pagination.find('.slider-pagination-left');
				that.paginationRight = that.pagination.find('.slider-pagination-right');
				if (that.items.length > that.options.pagination.maxItemLength) {
					that._hidepaginationBtn();
				}
				that.pagiCollection.on('click', 'li', function () {
					var $this = $(this);
					var index = parseInt($this.data('index'));
					if (that.curIndex !== index) {
						that.move(index);
					}
				});

				var _paginationOption = that.options.pagination;

				that.paginationLeft.on('click', function () {
					if (_paginationOption.currentLeft < 0) {
						_paginationOption.currentLeft += _paginationOption.itemWidth;
						that.pagiCollection.css('margin-left', _paginationOption.currentLeft);
					}
					that._hidepaginationBtn();
				});
				that.paginationRight.on('click', function () {
					if (_paginationOption.currentLeft > -(_paginationOption.itemWidth * (that.items.length - _paginationOption.maxItemLength))) {
						_paginationOption.currentLeft -= _paginationOption.itemWidth;
						that.pagiCollection.css('margin-left', _paginationOption.currentLeft);
					}
					that._hidepaginationBtn();
				});
			}
		},
		_hidepaginationBtn: function _hidepaginationBtn() {
			var that = this,
			    _paginationOption = that.options.pagination;
			if (_paginationOption.currentLeft === 0) {
				that.paginationLeft.hide();
			} else {
				that.paginationLeft.show();
			}

			if (_paginationOption.currentLeft === -(_paginationOption.itemWidth * (that.items.length - _paginationOption.maxItemLength))) {
				that.paginationRight.hide();
			} else {
				that.paginationRight.show();
			}
		}
	};

	return {
		init: function init(options) {
			return new Slider(options);
		}
	};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _create = __webpack_require__(79);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* WebUploader 0.1.8-alpha */!function (a, b) {
  var c,
      d = {},
      e = function e(a, b) {
    var c, d, e;if ("string" == typeof a) return h(a);for (c = [], d = a.length, e = 0; d > e; e++) {
      c.push(h(a[e]));
    }return b.apply(null, c);
  },
      f = function f(a, b, c) {
    2 === arguments.length && (c = b, b = null), e(b || [], function () {
      g(a, c, arguments);
    });
  },
      g = function g(a, b, c) {
    var f,
        g = { exports: b };"function" == typeof b && (c.length || (c = [e, g.exports, g]), f = b.apply(null, c), void 0 !== f && (g.exports = f)), d[a] = g.exports;
  },
      h = function h(b) {
    var c = d[b] || a[b];if (!c) throw new Error("`" + b + "` is undefined");return c;
  },
      i = function i(a) {
    var b, c, e, f, g, h;h = function h(a) {
      return a && a.charAt(0).toUpperCase() + a.substr(1);
    };for (b in d) {
      if (c = a, d.hasOwnProperty(b)) {
        for (e = b.split("/"), g = h(e.pop()); f = h(e.shift());) {
          c[f] = c[f] || {}, c = c[f];
        }c[g] = d[b];
      }
    }return a;
  },
      j = function j(c) {
    return a.__dollar = c, i(b(a, f, e));
  };"object" == ( false ? "undefined" : (0, _typeof3.default)(module)) && "object" == (0, _typeof3.default)(module.exports) ? module.exports = j() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (j),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (c = a.WebUploader, a.WebUploader = j(), a.WebUploader.noConflict = function () {
    a.WebUploader = c;
  });
}(window, function (a, b, c) {
  return b("dollar-third", [], function () {
    var b = a.require,
        c = a.__dollar || a.jQuery || a.Zepto || b("jquery") || b("zepto");if (!c) throw new Error("jQuery or Zepto not found!");return c;
  }), b("dollar", ["dollar-third"], function (a) {
    return a;
  }), b("promise-third", ["dollar"], function (a) {
    return { Deferred: a.Deferred, when: a.when, isPromise: function isPromise(a) {
        return a && "function" == typeof a.then;
      } };
  }), b("promise", ["promise-third"], function (a) {
    return a;
  }), b("base", ["dollar", "promise"], function (b, c) {
    function d(a) {
      return function () {
        return h.apply(a, arguments);
      };
    }function e(a, b) {
      return function () {
        return a.apply(b, arguments);
      };
    }function f(a) {
      var b;return _create2.default ? (0, _create2.default)(a) : (b = function b() {}, b.prototype = a, new b());
    }var g = function g() {},
        h = Function.call;return { version: "0.1.8-alpha", $: b, Deferred: c.Deferred, isPromise: c.isPromise, when: c.when, browser: function (a) {
        var b = {},
            c = a.match(/WebKit\/([\d.]+)/),
            d = a.match(/Chrome\/([\d.]+)/) || a.match(/CriOS\/([\d.]+)/),
            e = a.match(/MSIE\s([\d\.]+)/) || a.match(/(?:trident)(?:.*rv:([\w.]+))?/i),
            f = a.match(/Firefox\/([\d.]+)/),
            g = a.match(/Safari\/([\d.]+)/),
            h = a.match(/OPR\/([\d.]+)/);return c && (b.webkit = parseFloat(c[1])), d && (b.chrome = parseFloat(d[1])), e && (b.ie = parseFloat(e[1])), f && (b.firefox = parseFloat(f[1])), g && (b.safari = parseFloat(g[1])), h && (b.opera = parseFloat(h[1])), b;
      }(navigator.userAgent), os: function (a) {
        var b = {},
            c = a.match(/(?:Android);?[\s\/]+([\d.]+)?/),
            d = a.match(/(?:iPad|iPod|iPhone).*OS\s([\d_]+)/);return c && (b.android = parseFloat(c[1])), d && (b.ios = parseFloat(d[1].replace(/_/g, "."))), b;
      }(navigator.userAgent), inherits: function inherits(a, c, d) {
        var e;return "function" == typeof c ? (e = c, c = null) : e = c && c.hasOwnProperty("constructor") ? c.constructor : function () {
          return a.apply(this, arguments);
        }, b.extend(!0, e, a, d || {}), e.__super__ = a.prototype, e.prototype = f(a.prototype), c && b.extend(!0, e.prototype, c), e;
      }, noop: g, bindFn: e, log: function () {
        return a.console ? e(console.log, console) : g;
      }(), nextTick: function () {
        return function (a) {
          setTimeout(a, 1);
        };
      }(), slice: d([].slice), guid: function () {
        var a = 0;return function (b) {
          for (var c = (+new Date()).toString(32), d = 0; 5 > d; d++) {
            c += Math.floor(65535 * Math.random()).toString(32);
          }return (b || "wu_") + c + (a++).toString(32);
        };
      }(), formatSize: function formatSize(a, b, c) {
        var d;for (c = c || ["B", "K", "M", "G", "TB"]; (d = c.shift()) && a > 1024;) {
          a /= 1024;
        }return ("B" === d ? a : a.toFixed(b || 2)) + d;
      } };
  }), b("mediator", ["base"], function (a) {
    function b(a, b, c, d) {
      return f.grep(a, function (a) {
        return !(!a || b && a.e !== b || c && a.cb !== c && a.cb._cb !== c || d && a.ctx !== d);
      });
    }function c(a, b, c) {
      f.each((a || "").split(h), function (a, d) {
        c(d, b);
      });
    }function d(a, b) {
      for (var c, d = !1, e = -1, f = a.length; ++e < f;) {
        if (c = a[e], c.cb.apply(c.ctx2, b) === !1) {
          d = !0;break;
        }
      }return !d;
    }var e,
        f = a.$,
        g = [].slice,
        h = /\s+/;return e = { on: function on(a, b, d) {
        var e,
            f = this;return b ? (e = this._events || (this._events = []), c(a, b, function (a, b) {
          var c = { e: a };c.cb = b, c.ctx = d, c.ctx2 = d || f, c.id = e.length, e.push(c);
        }), this) : this;
      }, once: function once(a, b, d) {
        var e = this;return b ? (c(a, b, function (a, b) {
          var c = function c() {
            return e.off(a, c), b.apply(d || e, arguments);
          };c._cb = b, e.on(a, c, d);
        }), e) : e;
      }, off: function off(a, d, e) {
        var g = this._events;return g ? a || d || e ? (c(a, d, function (a, c) {
          f.each(b(g, a, c, e), function () {
            delete g[this.id];
          });
        }), this) : (this._events = [], this) : this;
      }, trigger: function trigger(a) {
        var c, e, f;return this._events && a ? (c = g.call(arguments, 1), e = b(this._events, a), f = b(this._events, "all"), d(e, c) && d(f, arguments)) : this;
      } }, f.extend({ installTo: function installTo(a) {
        return f.extend(a, e);
      } }, e);
  }), b("uploader", ["base", "mediator"], function (a, b) {
    function c(a) {
      this.options = d.extend(!0, {}, c.options, a), this._init(this.options);
    }var d = a.$;return c.options = {}, b.installTo(c.prototype), d.each({ upload: "start-upload", stop: "stop-upload", getFile: "get-file", getFiles: "get-files", addFile: "add-file", addFiles: "add-file", sort: "sort-files", removeFile: "remove-file", cancelFile: "cancel-file", skipFile: "skip-file", retry: "retry", isInProgress: "is-in-progress", makeThumb: "make-thumb", md5File: "md5-file", getDimension: "get-dimension", addButton: "add-btn", predictRuntimeType: "predict-runtime-type", refresh: "refresh", disable: "disable", enable: "enable", reset: "reset" }, function (a, b) {
      c.prototype[a] = function () {
        return this.request(b, arguments);
      };
    }), d.extend(c.prototype, { state: "pending", _init: function _init(a) {
        var b = this;b.request("init", a, function () {
          b.state = "ready", b.trigger("ready");
        });
      }, option: function option(a, b) {
        var c = this.options;return arguments.length > 1 ? (d.isPlainObject(b) && d.isPlainObject(c[a]) ? d.extend(c[a], b) : c[a] = b, void 0) : a ? c[a] : c;
      }, getStats: function getStats() {
        var a = this.request("get-stats");return a ? { successNum: a.numOfSuccess, progressNum: a.numOfProgress, cancelNum: a.numOfCancel, invalidNum: a.numOfInvalid, uploadFailNum: a.numOfUploadFailed, queueNum: a.numOfQueue, interruptNum: a.numofInterrupt } : {};
      }, trigger: function trigger(a) {
        var c = [].slice.call(arguments, 1),
            e = this.options,
            f = "on" + a.substring(0, 1).toUpperCase() + a.substring(1);return b.trigger.apply(this, arguments) === !1 || d.isFunction(e[f]) && e[f].apply(this, c) === !1 || d.isFunction(this[f]) && this[f].apply(this, c) === !1 || b.trigger.apply(b, [this, a].concat(c)) === !1 ? !1 : !0;
      }, destroy: function destroy() {
        this.request("destroy", arguments), this.off();
      }, request: a.noop }), a.create = c.create = function (a) {
      return new c(a);
    }, a.Uploader = c, c;
  }), b("runtime/runtime", ["base", "mediator"], function (a, b) {
    function c(b) {
      this.options = d.extend({ container: document.body }, b), this.uid = a.guid("rt_");
    }var d = a.$,
        e = {},
        f = function f(a) {
      for (var b in a) {
        if (a.hasOwnProperty(b)) return b;
      }return null;
    };return d.extend(c.prototype, { getContainer: function getContainer() {
        var a,
            b,
            c = this.options;return this._container ? this._container : (a = d(c.container || document.body), b = d(document.createElement("div")), b.attr("id", "rt_" + this.uid), b.css({ position: "absolute", top: "0px", left: "0px", width: "1px", height: "1px", overflow: "hidden" }), a.append(b), a.addClass("webuploader-container"), this._container = b, this._parent = a, b);
      }, init: a.noop, exec: a.noop, destroy: function destroy() {
        this._container && this._container.remove(), this._parent && this._parent.removeClass("webuploader-container"), this.off();
      } }), c.orders = "html5,flash", c.addRuntime = function (a, b) {
      e[a] = b;
    }, c.hasRuntime = function (a) {
      return !!(a ? e[a] : f(e));
    }, c.create = function (a, b) {
      var g, h;if (b = b || c.orders, d.each(b.split(/\s*,\s*/g), function () {
        return e[this] ? (g = this, !1) : void 0;
      }), g = g || f(e), !g) throw new Error("Runtime Error");return h = new e[g](a);
    }, b.installTo(c.prototype), c;
  }), b("runtime/client", ["base", "mediator", "runtime/runtime"], function (a, b, c) {
    function d(b, d) {
      var f,
          g = a.Deferred();this.uid = a.guid("client_"), this.runtimeReady = function (a) {
        return g.done(a);
      }, this.connectRuntime = function (b, h) {
        if (f) throw new Error("already connected!");return g.done(h), "string" == typeof b && e.get(b) && (f = e.get(b)), f = f || e.get(null, d), f ? (a.$.extend(f.options, b), f.__promise.then(g.resolve), f.__client++) : (f = c.create(b, b.runtimeOrder), f.__promise = g.promise(), f.once("ready", g.resolve), f.init(), e.add(f), f.__client = 1), d && (f.__standalone = d), f;
      }, this.getRuntime = function () {
        return f;
      }, this.disconnectRuntime = function () {
        f && (f.__client--, f.__client <= 0 && (e.remove(f), delete f.__promise, f.destroy()), f = null);
      }, this.exec = function () {
        if (f) {
          var c = a.slice(arguments);return b && c.unshift(b), f.exec.apply(this, c);
        }
      }, this.getRuid = function () {
        return f && f.uid;
      }, this.destroy = function (a) {
        return function () {
          a && a.apply(this, arguments), this.trigger("destroy"), this.off(), this.exec("destroy"), this.disconnectRuntime();
        };
      }(this.destroy);
    }var e;return e = function () {
      var a = {};return { add: function add(b) {
          a[b.uid] = b;
        }, get: function get(b, c) {
          var d;if (b) return a[b];for (d in a) {
            if (!c || !a[d].__standalone) return a[d];
          }return null;
        }, remove: function remove(b) {
          delete a[b.uid];
        } };
    }(), b.installTo(d.prototype), d;
  }), b("lib/dnd", ["base", "mediator", "runtime/client"], function (a, b, c) {
    function d(a) {
      a = this.options = e.extend({}, d.options, a), a.container = e(a.container), a.container.length && c.call(this, "DragAndDrop");
    }var e = a.$;return d.options = { accept: null, disableGlobalDnd: !1 }, a.inherits(c, { constructor: d, init: function init() {
        var a = this;a.connectRuntime(a.options, function () {
          a.exec("init"), a.trigger("ready");
        });
      } }), b.installTo(d.prototype), d;
  }), b("widgets/widget", ["base", "uploader"], function (a, b) {
    function c(a) {
      if (!a) return !1;var b = a.length,
          c = e.type(a);return 1 === a.nodeType && b ? !0 : "array" === c || "function" !== c && "string" !== c && (0 === b || "number" == typeof b && b > 0 && b - 1 in a);
    }function d(a) {
      this.owner = a, this.options = a.options;
    }var e = a.$,
        f = b.prototype._init,
        g = b.prototype.destroy,
        h = {},
        i = [];return e.extend(d.prototype, { init: a.noop, invoke: function invoke(a, b) {
        var c = this.responseMap;return c && a in c && c[a] in this && e.isFunction(this[c[a]]) ? this[c[a]].apply(this, b) : h;
      }, request: function request() {
        return this.owner.request.apply(this.owner, arguments);
      } }), e.extend(b.prototype, { _init: function _init() {
        var a = this,
            b = a._widgets = [],
            c = a.options.disableWidgets || "";return e.each(i, function (d, e) {
          (!c || !~c.indexOf(e._name)) && b.push(new e(a));
        }), f.apply(a, arguments);
      }, request: function request(b, d, e) {
        var f,
            g,
            i,
            j,
            k = 0,
            l = this._widgets,
            m = l && l.length,
            n = [],
            o = [];for (d = c(d) ? d : [d]; m > k; k++) {
          f = l[k], g = f.invoke(b, d), g !== h && (a.isPromise(g) ? o.push(g) : n.push(g));
        }return e || o.length ? (i = a.when.apply(a, o), j = i.pipe ? "pipe" : "then", i[j](function () {
          var b = a.Deferred(),
              c = arguments;return 1 === c.length && (c = c[0]), setTimeout(function () {
            b.resolve(c);
          }, 1), b.promise();
        })[e ? j : "done"](e || a.noop)) : n[0];
      }, destroy: function destroy() {
        g.apply(this, arguments), this._widgets = null;
      } }), b.register = d.register = function (b, c) {
      var f,
          g = { init: "init", destroy: "destroy", name: "anonymous" };return 1 === arguments.length ? (c = b, e.each(c, function (a) {
        return "_" === a[0] || "name" === a ? ("name" === a && (g.name = c.name), void 0) : (g[a.replace(/[A-Z]/g, "-$&").toLowerCase()] = a, void 0);
      })) : g = e.extend(g, b), c.responseMap = g, f = a.inherits(d, c), f._name = g.name, i.push(f), f;
    }, b.unRegister = d.unRegister = function (a) {
      if (a && "anonymous" !== a) for (var b = i.length; b--;) {
        i[b]._name === a && i.splice(b, 1);
      }
    }, d;
  }), b("widgets/filednd", ["base", "uploader", "lib/dnd", "widgets/widget"], function (a, b, c) {
    var d = a.$;return b.options.dnd = "", b.register({ name: "dnd", init: function init(b) {
        if (b.dnd && "html5" === this.request("predict-runtime-type")) {
          var e,
              f = this,
              g = a.Deferred(),
              h = d.extend({}, { disableGlobalDnd: b.disableGlobalDnd, container: b.dnd, accept: b.accept });return this.dnd = e = new c(h), e.once("ready", g.resolve), e.on("drop", function (a) {
            f.request("add-file", [a]);
          }), e.on("accept", function (a) {
            return f.owner.trigger("dndAccept", a);
          }), e.init(), g.promise();
        }
      }, destroy: function destroy() {
        this.dnd && this.dnd.destroy();
      } });
  }), b("lib/filepaste", ["base", "mediator", "runtime/client"], function (a, b, c) {
    function d(a) {
      a = this.options = e.extend({}, a), a.container = e(a.container || document.body), c.call(this, "FilePaste");
    }var e = a.$;return a.inherits(c, { constructor: d, init: function init() {
        var a = this;a.connectRuntime(a.options, function () {
          a.exec("init"), a.trigger("ready");
        });
      } }), b.installTo(d.prototype), d;
  }), b("widgets/filepaste", ["base", "uploader", "lib/filepaste", "widgets/widget"], function (a, b, c) {
    var d = a.$;return b.register({ name: "paste", init: function init(b) {
        if (b.paste && "html5" === this.request("predict-runtime-type")) {
          var e,
              f = this,
              g = a.Deferred(),
              h = d.extend({}, { container: b.paste, accept: b.accept });return this.paste = e = new c(h), e.once("ready", g.resolve), e.on("paste", function (a) {
            f.owner.request("add-file", [a]);
          }), e.init(), g.promise();
        }
      }, destroy: function destroy() {
        this.paste && this.paste.destroy();
      } });
  }), b("lib/blob", ["base", "runtime/client"], function (a, b) {
    function c(a, c) {
      var d = this;d.source = c, d.ruid = a, this.size = c.size || 0, this.type = !c.type && this.ext && ~"jpg,jpeg,png,gif,bmp".indexOf(this.ext) ? "image/" + ("jpg" === this.ext ? "jpeg" : this.ext) : c.type || "application/octet-stream", b.call(d, "Blob"), this.uid = c.uid || this.uid, a && d.connectRuntime(a);
    }return a.inherits(b, { constructor: c, slice: function slice(a, b) {
        return this.exec("slice", a, b);
      }, getSource: function getSource() {
        return this.source;
      } }), c;
  }), b("lib/file", ["base", "lib/blob"], function (a, b) {
    function c(a, c) {
      var f;this.name = c.name || "untitled" + d++, f = e.exec(c.name) ? RegExp.$1.toLowerCase() : "", !f && c.type && (f = /\/(jpg|jpeg|png|gif|bmp)$/i.exec(c.type) ? RegExp.$1.toLowerCase() : "", this.name += "." + f), this.ext = f, this.lastModifiedDate = c.lastModifiedDate || new Date().toLocaleString(), b.apply(this, arguments);
    }var d = 1,
        e = /\.([^.]+)$/;return a.inherits(b, c);
  }), b("lib/filepicker", ["base", "runtime/client", "lib/file"], function (b, c, d) {
    function e(a) {
      if (a = this.options = f.extend({}, e.options, a), a.container = f(a.id), !a.container.length) throw new Error("按钮指定错误");a.innerHTML = a.innerHTML || a.label || a.container.html() || "", a.button = f(a.button || document.createElement("div")), a.button.html(a.innerHTML), a.container.html(a.button), c.call(this, "FilePicker", !0);
    }var f = b.$;return e.options = { button: null, container: null, label: null, innerHTML: null, multiple: !0, accept: null, name: "file", style: "webuploader-pick" }, b.inherits(c, { constructor: e, init: function init() {
        var c = this,
            e = c.options,
            g = e.button,
            h = e.style;h && g.addClass("webuploader-pick"), c.on("all", function (a) {
          var b;switch (a) {case "mouseenter":
              h && g.addClass("webuploader-pick-hover");break;case "mouseleave":
              h && g.removeClass("webuploader-pick-hover");break;case "change":
              b = c.exec("getFiles"), c.trigger("select", f.map(b, function (a) {
                return a = new d(c.getRuid(), a), a._refer = e.container, a;
              }), e.container);}
        }), c.connectRuntime(e, function () {
          c.refresh(), c.exec("init", e), c.trigger("ready");
        }), this._resizeHandler = b.bindFn(this.refresh, this), f(a).on("resize", this._resizeHandler);
      }, refresh: function refresh() {
        var a = this.getRuntime().getContainer(),
            b = this.options.button,
            c = b.outerWidth ? b.outerWidth() : b.width(),
            d = b.outerHeight ? b.outerHeight() : b.height(),
            e = b.offset();c && d && a.css({ bottom: "auto", right: "auto", width: c + "px", height: d + "px" }).offset(e);
      }, enable: function enable() {
        var a = this.options.button;a.removeClass("webuploader-pick-disable"), this.refresh();
      }, disable: function disable() {
        var a = this.options.button;this.getRuntime().getContainer().css({ top: "-99999px" }), a.addClass("webuploader-pick-disable");
      }, destroy: function destroy() {
        var b = this.options.button;f(a).off("resize", this._resizeHandler), b.removeClass("webuploader-pick-disable webuploader-pick-hover webuploader-pick");
      } }), e;
  }), b("widgets/filepicker", ["base", "uploader", "lib/filepicker", "widgets/widget"], function (a, b, c) {
    var d = a.$;return d.extend(b.options, { pick: null, accept: null }), b.register({ name: "picker", init: function init(a) {
        return this.pickers = [], a.pick && this.addBtn(a.pick);
      }, refresh: function refresh() {
        d.each(this.pickers, function () {
          this.refresh();
        });
      }, addBtn: function addBtn(b) {
        var e = this,
            f = e.options,
            g = f.accept,
            h = [];if (b) return d.isPlainObject(b) || (b = { id: b }), d(b.id).each(function () {
          var i, j, k;k = a.Deferred(), i = d.extend({}, b, { accept: d.isPlainObject(g) ? [g] : g, swf: f.swf, runtimeOrder: f.runtimeOrder, id: this }), j = new c(i), j.once("ready", k.resolve), j.on("select", function (a) {
            e.owner.request("add-file", [a]);
          }), j.on("dialogopen", function () {
            e.owner.trigger("dialogOpen", j.button);
          }), j.init(), e.pickers.push(j), h.push(k.promise());
        }), a.when.apply(a, h);
      }, disable: function disable() {
        d.each(this.pickers, function () {
          this.disable();
        });
      }, enable: function enable() {
        d.each(this.pickers, function () {
          this.enable();
        });
      }, destroy: function destroy() {
        d.each(this.pickers, function () {
          this.destroy();
        }), this.pickers = null;
      } });
  }), b("lib/image", ["base", "runtime/client", "lib/blob"], function (a, b, c) {
    function d(a) {
      this.options = e.extend({}, d.options, a), b.call(this, "Image"), this.on("load", function () {
        this._info = this.exec("info"), this._meta = this.exec("meta");
      });
    }var e = a.$;return d.options = { quality: 90, crop: !1, preserveHeaders: !1, allowMagnify: !1 }, a.inherits(b, { constructor: d, info: function info(a) {
        return a ? (this._info = a, this) : this._info;
      }, meta: function meta(a) {
        return a ? (this._meta = a, this) : this._meta;
      }, loadFromBlob: function loadFromBlob(a) {
        var b = this,
            c = a.getRuid();this.connectRuntime(c, function () {
          b.exec("init", b.options), b.exec("loadFromBlob", a);
        });
      }, resize: function resize() {
        var b = a.slice(arguments);return this.exec.apply(this, ["resize"].concat(b));
      }, crop: function crop() {
        var b = a.slice(arguments);return this.exec.apply(this, ["crop"].concat(b));
      }, getAsDataUrl: function getAsDataUrl(a) {
        return this.exec("getAsDataUrl", a);
      }, getAsBlob: function getAsBlob(a) {
        var b = this.exec("getAsBlob", a);return new c(this.getRuid(), b);
      } }), d;
  }), b("widgets/image", ["base", "uploader", "lib/image", "widgets/widget"], function (a, b, c) {
    var d,
        e = a.$;return d = function (a) {
      var b = 0,
          c = [],
          d = function d() {
        for (var d; c.length && a > b;) {
          d = c.shift(), b += d[0], d[1]();
        }
      };return function (a, e, f) {
        c.push([e, f]), a.once("destroy", function () {
          b -= e, setTimeout(d, 1);
        }), setTimeout(d, 1);
      };
    }(5242880), e.extend(b.options, { thumb: { width: 110, height: 110, quality: 70, allowMagnify: !0, crop: !0, preserveHeaders: !1, type: "image/jpeg" }, compress: { width: 1600, height: 1600, quality: 90, allowMagnify: !1, crop: !1, preserveHeaders: !0 } }), b.register({ name: "image", makeThumb: function makeThumb(a, b, f, g) {
        var h, i;return a = this.request("get-file", a), a.type.match(/^image/) ? (h = e.extend({}, this.options.thumb), e.isPlainObject(f) && (h = e.extend(h, f), f = null), f = f || h.width, g = g || h.height, i = new c(h), i.once("load", function () {
          a._info = a._info || i.info(), a._meta = a._meta || i.meta(), 1 >= f && f > 0 && (f = a._info.width * f), 1 >= g && g > 0 && (g = a._info.height * g), i.resize(f, g);
        }), i.once("complete", function () {
          b(!1, i.getAsDataUrl(h.type)), i.destroy();
        }), i.once("error", function (a) {
          b(a || !0), i.destroy();
        }), d(i, a.source.size, function () {
          a._info && i.info(a._info), a._meta && i.meta(a._meta), i.loadFromBlob(a.source);
        }), void 0) : (b(!0), void 0);
      }, beforeSendFile: function beforeSendFile(b) {
        var d,
            f,
            g = this.options.compress || this.options.resize,
            h = g && g.compressSize || 0,
            i = g && g.noCompressIfLarger || !1;return b = this.request("get-file", b), !g || !~"image/jpeg,image/jpg".indexOf(b.type) || b.size < h || b._compressed ? void 0 : (g = e.extend({}, g), f = a.Deferred(), d = new c(g), f.always(function () {
          d.destroy(), d = null;
        }), d.once("error", f.reject), d.once("load", function () {
          var a = g.width,
              c = g.height;b._info = b._info || d.info(), b._meta = b._meta || d.meta(), 1 >= a && a > 0 && (a = b._info.width * a), 1 >= c && c > 0 && (c = b._info.height * c), d.resize(a, c);
        }), d.once("complete", function () {
          var a, c;try {
            a = d.getAsBlob(g.type), c = b.size, (!i || a.size < c) && (b.source = a, b.size = a.size, b.trigger("resize", a.size, c)), b._compressed = !0, f.resolve();
          } catch (e) {
            f.resolve();
          }
        }), b._info && d.info(b._info), b._meta && d.meta(b._meta), d.loadFromBlob(b.source), f.promise());
      } });
  }), b("file", ["base", "mediator"], function (a, b) {
    function c() {
      return f + g++;
    }function d(a) {
      this.name = a.name || "Untitled", this.size = a.size || 0, this.type = a.type || "application/octet-stream", this.lastModifiedDate = a.lastModifiedDate || 1 * new Date(), this.id = c(), this.ext = h.exec(this.name) ? RegExp.$1 : "", this.statusText = "", i[this.id] = d.Status.INITED, this.source = a, this.loaded = 0, this.on("error", function (a) {
        this.setStatus(d.Status.ERROR, a);
      });
    }var e = a.$,
        f = "WU_FILE_",
        g = 0,
        h = /\.([^.]+)$/,
        i = {};return e.extend(d.prototype, { setStatus: function setStatus(a, b) {
        var c = i[this.id];"undefined" != typeof b && (this.statusText = b), a !== c && (i[this.id] = a, this.trigger("statuschange", a, c));
      }, getStatus: function getStatus() {
        return i[this.id];
      }, getSource: function getSource() {
        return this.source;
      }, destroy: function destroy() {
        this.off(), delete i[this.id];
      } }), b.installTo(d.prototype), d.Status = { INITED: "inited", QUEUED: "queued", PROGRESS: "progress", ERROR: "error", COMPLETE: "complete", CANCELLED: "cancelled", INTERRUPT: "interrupt", INVALID: "invalid" }, d;
  }), b("queue", ["base", "mediator", "file"], function (a, b, c) {
    function d() {
      this.stats = { numOfQueue: 0, numOfSuccess: 0, numOfCancel: 0, numOfProgress: 0, numOfUploadFailed: 0, numOfInvalid: 0, numofDeleted: 0, numofInterrupt: 0 }, this._queue = [], this._map = {};
    }var e = a.$,
        f = c.Status;return e.extend(d.prototype, { append: function append(a) {
        return this._queue.push(a), this._fileAdded(a), this;
      }, prepend: function prepend(a) {
        return this._queue.unshift(a), this._fileAdded(a), this;
      }, getFile: function getFile(a) {
        return "string" != typeof a ? a : this._map[a];
      }, fetch: function fetch(a) {
        var b,
            c,
            d = this._queue.length;for (a = a || f.QUEUED, b = 0; d > b; b++) {
          if (c = this._queue[b], a === c.getStatus()) return c;
        }return null;
      }, sort: function sort(a) {
        "function" == typeof a && this._queue.sort(a);
      }, getFiles: function getFiles() {
        for (var a, b = [].slice.call(arguments, 0), c = [], d = 0, f = this._queue.length; f > d; d++) {
          a = this._queue[d], (!b.length || ~e.inArray(a.getStatus(), b)) && c.push(a);
        }return c;
      }, removeFile: function removeFile(a) {
        var b = this._map[a.id];b && (delete this._map[a.id], this._delFile(a), a.destroy(), this.stats.numofDeleted++);
      }, _fileAdded: function _fileAdded(a) {
        var b = this,
            c = this._map[a.id];c || (this._map[a.id] = a, a.on("statuschange", function (a, c) {
          b._onFileStatusChange(a, c);
        }));
      }, _delFile: function _delFile(a) {
        for (var b = this._queue.length - 1; b >= 0; b--) {
          if (this._queue[b] == a) {
            this._queue.splice(b, 1);break;
          }
        }
      }, _onFileStatusChange: function _onFileStatusChange(a, b) {
        var c = this.stats;switch (b) {case f.PROGRESS:
            c.numOfProgress--;break;case f.QUEUED:
            c.numOfQueue--;break;case f.ERROR:
            c.numOfUploadFailed--;break;case f.INVALID:
            c.numOfInvalid--;break;case f.INTERRUPT:
            c.numofInterrupt--;}switch (a) {case f.QUEUED:
            c.numOfQueue++;break;case f.PROGRESS:
            c.numOfProgress++;break;case f.ERROR:
            c.numOfUploadFailed++;break;case f.COMPLETE:
            c.numOfSuccess++;break;case f.CANCELLED:
            c.numOfCancel++;break;case f.INVALID:
            c.numOfInvalid++;break;case f.INTERRUPT:
            c.numofInterrupt++;}
      } }), b.installTo(d.prototype), d;
  }), b("widgets/queue", ["base", "uploader", "queue", "file", "lib/file", "runtime/client", "widgets/widget"], function (a, b, c, d, e, f) {
    var g = a.$,
        h = /\.\w+$/,
        i = d.Status;return b.register({ name: "queue", init: function init(b) {
        var d,
            e,
            h,
            i,
            j,
            k,
            l,
            m = this;if (g.isPlainObject(b.accept) && (b.accept = [b.accept]), b.accept) {
          for (j = [], h = 0, e = b.accept.length; e > h; h++) {
            i = b.accept[h].extensions, i && j.push(i);
          }j.length && (k = "\\." + j.join(",").replace(/,/g, "$|\\.").replace(/\*/g, ".*") + "$"), m.accept = new RegExp(k, "i");
        }return m.queue = new c(), m.stats = m.queue.stats, "html5" === this.request("predict-runtime-type") ? (d = a.Deferred(), this.placeholder = l = new f("Placeholder"), l.connectRuntime({ runtimeOrder: "html5" }, function () {
          m._ruid = l.getRuid(), d.resolve();
        }), d.promise()) : void 0;
      }, _wrapFile: function _wrapFile(a) {
        if (!(a instanceof d)) {
          if (!(a instanceof e)) {
            if (!this._ruid) throw new Error("Can't add external files.");a = new e(this._ruid, a);
          }a = new d(a);
        }return a;
      }, acceptFile: function acceptFile(a) {
        var b = !a || !a.size || this.accept && h.exec(a.name) && !this.accept.test(a.name);return !b;
      }, _addFile: function _addFile(a) {
        var b = this;return a = b._wrapFile(a), b.owner.trigger("beforeFileQueued", a) ? b.acceptFile(a) ? (b.queue.append(a), b.owner.trigger("fileQueued", a), a) : (b.owner.trigger("error", "Q_TYPE_DENIED", a), void 0) : void 0;
      }, getFile: function getFile(a) {
        return this.queue.getFile(a);
      }, addFile: function addFile(a) {
        var b = this;a.length || (a = [a]), a = g.map(a, function (a) {
          return b._addFile(a);
        }), a.length && (b.owner.trigger("filesQueued", a), b.options.auto && setTimeout(function () {
          b.request("start-upload");
        }, 20));
      }, getStats: function getStats() {
        return this.stats;
      }, removeFile: function removeFile(a, b) {
        var c = this;a = a.id ? a : c.queue.getFile(a), this.request("cancel-file", a), b && this.queue.removeFile(a);
      }, getFiles: function getFiles() {
        return this.queue.getFiles.apply(this.queue, arguments);
      }, fetchFile: function fetchFile() {
        return this.queue.fetch.apply(this.queue, arguments);
      }, retry: function retry(a, b) {
        var c,
            d,
            e,
            f = this;if (a) return a = a.id ? a : f.queue.getFile(a), a.setStatus(i.QUEUED), b || f.request("start-upload"), void 0;for (c = f.queue.getFiles(i.ERROR), d = 0, e = c.length; e > d; d++) {
          a = c[d], a.setStatus(i.QUEUED);
        }f.request("start-upload");
      }, sortFiles: function sortFiles() {
        return this.queue.sort.apply(this.queue, arguments);
      }, reset: function reset() {
        this.owner.trigger("reset"), this.queue = new c(), this.stats = this.queue.stats;
      }, destroy: function destroy() {
        this.reset(), this.placeholder && this.placeholder.destroy();
      } });
  }), b("widgets/runtime", ["uploader", "runtime/runtime", "widgets/widget"], function (a, b) {
    return a.support = function () {
      return b.hasRuntime.apply(b, arguments);
    }, a.register({ name: "runtime", init: function init() {
        if (!this.predictRuntimeType()) throw Error("Runtime Error");
      }, predictRuntimeType: function predictRuntimeType() {
        var a,
            c,
            d = this.options.runtimeOrder || b.orders,
            e = this.type;if (!e) for (d = d.split(/\s*,\s*/g), a = 0, c = d.length; c > a; a++) {
          if (b.hasRuntime(d[a])) {
            this.type = e = d[a];break;
          }
        }return e;
      } });
  }), b("lib/transport", ["base", "runtime/client", "mediator"], function (a, b, c) {
    function d(a) {
      var c = this;a = c.options = e.extend(!0, {}, d.options, a || {}), b.call(this, "Transport"), this._blob = null, this._formData = a.formData || {}, this._headers = a.headers || {}, this.on("progress", this._timeout), this.on("load error", function () {
        c.trigger("progress", 1), clearTimeout(c._timer);
      });
    }var e = a.$;return d.options = { server: "", method: "POST", withCredentials: !1, fileVal: "file", timeout: 12e4, formData: {}, headers: {}, sendAsBinary: !1 }, e.extend(d.prototype, { appendBlob: function appendBlob(a, b, c) {
        var d = this,
            e = d.options;d.getRuid() && d.disconnectRuntime(), d.connectRuntime(b.ruid, function () {
          d.exec("init");
        }), d._blob = b, e.fileVal = a || e.fileVal, e.filename = c || e.filename;
      }, append: function append(a, b) {
        "object" == (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) ? e.extend(this._formData, a) : this._formData[a] = b;
      }, setRequestHeader: function setRequestHeader(a, b) {
        "object" == (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) ? e.extend(this._headers, a) : this._headers[a] = b;
      }, send: function send(a) {
        this.exec("send", a), this._timeout();
      }, abort: function abort() {
        return clearTimeout(this._timer), this.exec("abort");
      }, destroy: function destroy() {
        this.trigger("destroy"), this.off(), this.exec("destroy"), this.disconnectRuntime();
      }, getResponseHeaders: function getResponseHeaders() {
        return this.exec("getResponseHeaders");
      }, getResponse: function getResponse() {
        return this.exec("getResponse");
      }, getResponseAsJson: function getResponseAsJson() {
        return this.exec("getResponseAsJson");
      }, getStatus: function getStatus() {
        return this.exec("getStatus");
      }, _timeout: function _timeout() {
        var a = this,
            b = a.options.timeout;b && (clearTimeout(a._timer), a._timer = setTimeout(function () {
          a.abort(), a.trigger("error", "timeout");
        }, b));
      } }), c.installTo(d.prototype), d;
  }), b("widgets/upload", ["base", "uploader", "file", "lib/transport", "widgets/widget"], function (a, b, c, d) {
    function e(a, b) {
      var c,
          d,
          e = [],
          f = a.source,
          g = f.size,
          h = b ? Math.ceil(g / b) : 1,
          i = 0,
          j = 0;for (d = { file: a, has: function has() {
          return !!e.length;
        }, shift: function shift() {
          return e.shift();
        }, unshift: function unshift(a) {
          e.unshift(a);
        } }; h > j;) {
        c = Math.min(b, g - i), e.push({ file: a, start: i, end: b ? i + c : g, total: g, chunks: h, chunk: j++, cuted: d }), i += c;
      }return a.blocks = e.concat(), a.remaning = e.length, d;
    }var f = a.$,
        g = a.isPromise,
        h = c.Status;f.extend(b.options, { prepareNextFile: !1, chunked: !1, chunkSize: 5242880, chunkRetry: 2, chunkRetryDelay: 1e3, threads: 3, formData: {} }), b.register({ name: "upload", init: function init() {
        var b = this.owner,
            c = this;this.runing = !1, this.progress = !1, b.on("startUpload", function () {
          c.progress = !0;
        }).on("uploadFinished", function () {
          c.progress = !1;
        }), this.pool = [], this.stack = [], this.pending = [], this.remaning = 0, this.__tick = a.bindFn(this._tick, this), b.on("uploadComplete", function (a) {
          a.blocks && f.each(a.blocks, function (a, b) {
            b.transport && (b.transport.abort(), b.transport.destroy()), delete b.transport;
          }), delete a.blocks, delete a.remaning;
        });
      }, reset: function reset() {
        this.request("stop-upload", !0), this.runing = !1, this.pool = [], this.stack = [], this.pending = [], this.remaning = 0, this._trigged = !1, this._promise = null;
      }, startUpload: function startUpload(b) {
        var c = this;if (f.each(c.request("get-files", h.INVALID), function () {
          c.request("remove-file", this);
        }), b ? (b = b.id ? b : c.request("get-file", b), b.getStatus() === h.INTERRUPT ? (b.setStatus(h.QUEUED), f.each(c.pool, function (a, c) {
          c.file === b && (c.transport && c.transport.send(), b.setStatus(h.PROGRESS));
        })) : b.getStatus() !== h.PROGRESS && b.setStatus(h.QUEUED)) : f.each(c.request("get-files", [h.INITED]), function () {
          this.setStatus(h.QUEUED);
        }), c.runing) return c.owner.trigger("startUpload", b), a.nextTick(c.__tick);c.runing = !0;var d = [];b || f.each(c.pool, function (a, b) {
          var e = b.file;e.getStatus() === h.INTERRUPT && (c._trigged = !1, d.push(e), b.transport && b.transport.send());
        }), f.each(d, function () {
          this.setStatus(h.PROGRESS);
        }), b || f.each(c.request("get-files", h.INTERRUPT), function () {
          this.setStatus(h.PROGRESS);
        }), c._trigged = !1, a.nextTick(c.__tick), c.owner.trigger("startUpload");
      }, stopUpload: function stopUpload(b, c) {
        var d = this;if (b === !0 && (c = b, b = null), d.runing !== !1) {
          if (b) {
            if (b = b.id ? b : d.request("get-file", b), b.getStatus() !== h.PROGRESS && b.getStatus() !== h.QUEUED) return;return b.setStatus(h.INTERRUPT), f.each(d.pool, function (a, e) {
              e.file === b && (e.transport && e.transport.abort(), c && (d._putback(e), d._popBlock(e)));
            }), d.owner.trigger("stopUpload", b), a.nextTick(d.__tick);
          }d.runing = !1, this._promise && this._promise.file && this._promise.file.setStatus(h.INTERRUPT), c && f.each(d.pool, function (a, b) {
            b.transport && b.transport.abort(), b.file.setStatus(h.INTERRUPT);
          }), d.owner.trigger("stopUpload");
        }
      }, cancelFile: function cancelFile(a) {
        a = a.id ? a : this.request("get-file", a), a.blocks && f.each(a.blocks, function (a, b) {
          var c = b.transport;c && (c.abort(), c.destroy(), delete b.transport);
        }), a.setStatus(h.CANCELLED), this.owner.trigger("fileDequeued", a);
      }, isInProgress: function isInProgress() {
        return !!this.progress;
      }, _getStats: function _getStats() {
        return this.request("get-stats");
      }, skipFile: function skipFile(a, b) {
        a = a.id ? a : this.request("get-file", a), a.setStatus(b || h.COMPLETE), a.skipped = !0, a.blocks && f.each(a.blocks, function (a, b) {
          var c = b.transport;c && (c.abort(), c.destroy(), delete b.transport);
        }), this.owner.trigger("uploadSkip", a);
      }, _tick: function _tick() {
        var b,
            c,
            d = this,
            e = d.options;return d._promise ? d._promise.always(d.__tick) : (d.pool.length < e.threads && (c = d._nextBlock()) ? (d._trigged = !1, b = function b(_b) {
          d._promise = null, _b && _b.file && d._startSend(_b), a.nextTick(d.__tick);
        }, d._promise = g(c) ? c.always(b) : b(c)) : d.remaning || d._getStats().numOfQueue || d._getStats().numofInterrupt || (d.runing = !1, d._trigged || a.nextTick(function () {
          d.owner.trigger("uploadFinished");
        }), d._trigged = !0), void 0);
      }, _putback: function _putback(a) {
        var b;a.cuted.unshift(a), b = this.stack.indexOf(a.cuted), ~b || this.stack.unshift(a.cuted);
      }, _getStack: function _getStack() {
        for (var a, b = 0; a = this.stack[b++];) {
          if (a.has() && a.file.getStatus() === h.PROGRESS) return a;(!a.has() || a.file.getStatus() !== h.PROGRESS && a.file.getStatus() !== h.INTERRUPT) && this.stack.splice(--b, 1);
        }return null;
      }, _nextBlock: function _nextBlock() {
        var a,
            b,
            c,
            d,
            f = this,
            h = f.options;return (a = this._getStack()) ? (h.prepareNextFile && !f.pending.length && f._prepareNextFile(), a.shift()) : f.runing ? (!f.pending.length && f._getStats().numOfQueue && f._prepareNextFile(), b = f.pending.shift(), c = function c(b) {
          return b ? (a = e(b, h.chunked ? h.chunkSize : 0), f.stack.push(a), a.shift()) : null;
        }, g(b) ? (d = b.file, b = b[b.pipe ? "pipe" : "then"](c), b.file = d, b) : c(b)) : void 0;
      }, _prepareNextFile: function _prepareNextFile() {
        var a,
            b = this,
            c = b.request("fetch-file"),
            d = b.pending;c && (a = b.request("before-send-file", c, function () {
          return c.getStatus() === h.PROGRESS || c.getStatus() === h.INTERRUPT ? c : b._finishFile(c);
        }), b.owner.trigger("uploadStart", c), c.setStatus(h.PROGRESS), a.file = c, a.done(function () {
          var b = f.inArray(a, d);~b && d.splice(b, 1, c);
        }), a.fail(function (a) {
          c.setStatus(h.ERROR, a), b.owner.trigger("uploadError", c, a), b.owner.trigger("uploadComplete", c);
        }), d.push(a));
      }, _popBlock: function _popBlock(a) {
        var b = f.inArray(a, this.pool);this.pool.splice(b, 1), a.file.remaning--, this.remaning--;
      }, _startSend: function _startSend(b) {
        var c,
            d = this,
            e = b.file;return e.getStatus() !== h.PROGRESS ? (e.getStatus() === h.INTERRUPT && d._putback(b), void 0) : (d.pool.push(b), d.remaning++, b.blob = 1 === b.chunks ? e.source : e.source.slice(b.start, b.end), c = d.request("before-send", b, function () {
          e.getStatus() === h.PROGRESS ? d._doSend(b) : (d._popBlock(b), a.nextTick(d.__tick));
        }), c.fail(function () {
          1 === e.remaning ? d._finishFile(e).always(function () {
            b.percentage = 1, d._popBlock(b), d.owner.trigger("uploadComplete", e), a.nextTick(d.__tick);
          }) : (b.percentage = 1, d.updateFileProgress(e), d._popBlock(b), a.nextTick(d.__tick));
        }), void 0);
      }, _doSend: function _doSend(b) {
        var c,
            e,
            g = this,
            i = g.owner,
            j = f.extend({}, g.options, b.options),
            k = b.file,
            l = new d(j),
            m = f.extend({}, j.formData),
            n = f.extend({}, j.headers);b.transport = l, l.on("destroy", function () {
          delete b.transport, g._popBlock(b), a.nextTick(g.__tick);
        }), l.on("progress", function (a) {
          b.percentage = a, g.updateFileProgress(k);
        }), c = function c(a) {
          var c;return e = l.getResponseAsJson() || {}, e._raw = l.getResponse(), e._headers = l.getResponseHeaders(), b.response = e, c = function c(b) {
            a = b;
          }, i.trigger("uploadAccept", b, e, c) || (a = a || "server"), a;
        }, l.on("error", function (a, d) {
          b.retried = b.retried || 0, b.chunks > 1 && ~"http,abort,server".indexOf(a.replace(/-.*/, "")) && b.retried < j.chunkRetry ? (b.retried++, g.retryTimer = setTimeout(function () {
            l.send();
          }, j.chunkRetryDelay || 1e3)) : (d || "server" !== a || (a = c(a)), k.setStatus(h.ERROR, a), i.trigger("uploadError", k, a), i.trigger("uploadComplete", k));
        }), l.on("load", function () {
          var a;return (a = c()) ? (l.trigger("error", a, !0), void 0) : (1 === k.remaning ? g._finishFile(k, e) : l.destroy(), void 0);
        }), m = f.extend(m, { id: k.id, name: k.name, type: k.type, lastModifiedDate: k.lastModifiedDate, size: k.size }), b.chunks > 1 && f.extend(m, { chunks: b.chunks, chunk: b.chunk }), i.trigger("uploadBeforeSend", b, m, n), l.appendBlob(j.fileVal, b.blob, k.name), l.append(m), l.setRequestHeader(n), l.send();
      }, _finishFile: function _finishFile(a, b, c) {
        var d = this.owner;return d.request("after-send-file", arguments, function () {
          a.setStatus(h.COMPLETE), d.trigger("uploadSuccess", a, b, c);
        }).fail(function (b) {
          a.getStatus() === h.PROGRESS && a.setStatus(h.ERROR, b), d.trigger("uploadError", a, b);
        }).always(function () {
          d.trigger("uploadComplete", a);
        });
      }, updateFileProgress: function updateFileProgress(a) {
        var b = 0,
            c = 0;a.blocks && (f.each(a.blocks, function (a, b) {
          c += (b.percentage || 0) * (b.end - b.start);
        }), b = c / a.size, this.owner.trigger("uploadProgress", a, b || 0));
      }, destroy: function destroy() {
        clearTimeout(this.retryTimer);
      } });
  }), b("widgets/validator", ["base", "uploader", "file", "widgets/widget"], function (a, b, c) {
    var d,
        e = a.$,
        f = {};return d = { addValidator: function addValidator(a, b) {
        f[a] = b;
      }, removeValidator: function removeValidator(a) {
        delete f[a];
      } }, b.register({ name: "validator", init: function init() {
        var b = this;a.nextTick(function () {
          e.each(f, function () {
            this.call(b.owner);
          });
        });
      } }), d.addValidator("fileNumLimit", function () {
      var a = this,
          b = a.options,
          c = 0,
          d = parseInt(b.fileNumLimit, 10),
          e = !0;d && (a.on("beforeFileQueued", function (a) {
        return this.trigger("beforeFileQueuedCheckfileNumLimit", a, c) ? (c >= d && e && (e = !1, this.trigger("error", "Q_EXCEED_NUM_LIMIT", d, a), setTimeout(function () {
          e = !0;
        }, 1)), c >= d ? !1 : !0) : !1;
      }), a.on("fileQueued", function () {
        c++;
      }), a.on("fileDequeued", function () {
        c--;
      }), a.on("reset", function () {
        c = 0;
      }));
    }), d.addValidator("fileSizeLimit", function () {
      var a = this,
          b = a.options,
          c = 0,
          d = parseInt(b.fileSizeLimit, 10),
          e = !0;d && (a.on("beforeFileQueued", function (a) {
        var b = c + a.size > d;return b && e && (e = !1, this.trigger("error", "Q_EXCEED_SIZE_LIMIT", d, a), setTimeout(function () {
          e = !0;
        }, 1)), b ? !1 : !0;
      }), a.on("fileQueued", function (a) {
        c += a.size;
      }), a.on("fileDequeued", function (a) {
        c -= a.size;
      }), a.on("reset", function () {
        c = 0;
      }));
    }), d.addValidator("fileSingleSizeLimit", function () {
      var a = this,
          b = a.options,
          d = b.fileSingleSizeLimit;d && a.on("beforeFileQueued", function (a) {
        return a.size > d ? (a.setStatus(c.Status.INVALID, "exceed_size"), this.trigger("error", "F_EXCEED_SIZE", d, a), !1) : void 0;
      });
    }), d.addValidator("duplicate", function () {
      function a(a) {
        for (var b, c = 0, d = 0, e = a.length; e > d; d++) {
          b = a.charCodeAt(d), c = b + (c << 6) + (c << 16) - c;
        }return c;
      }var b = this,
          c = b.options,
          d = {};c.duplicate || (b.on("beforeFileQueued", function (b) {
        var c = b.__hash || (b.__hash = a(b.name + b.size + b.lastModifiedDate));return d[c] ? (this.trigger("error", "F_DUPLICATE", b), !1) : void 0;
      }), b.on("fileQueued", function (a) {
        var b = a.__hash;b && (d[b] = !0);
      }), b.on("fileDequeued", function (a) {
        var b = a.__hash;b && delete d[b];
      }), b.on("reset", function () {
        d = {};
      }));
    }), d;
  }), b("lib/md5", ["runtime/client", "mediator"], function (a, b) {
    function c() {
      a.call(this, "Md5");
    }return b.installTo(c.prototype), c.prototype.loadFromBlob = function (a) {
      var b = this;b.getRuid() && b.disconnectRuntime(), b.connectRuntime(a.ruid, function () {
        b.exec("init"), b.exec("loadFromBlob", a);
      });
    }, c.prototype.getResult = function () {
      return this.exec("getResult");
    }, c;
  }), b("widgets/md5", ["base", "uploader", "lib/md5", "lib/blob", "widgets/widget"], function (a, b, c, d) {
    return b.register({ name: "md5", md5File: function md5File(b, e, f) {
        var g = new c(),
            h = a.Deferred(),
            i = b instanceof d ? b : this.request("get-file", b).source;return g.on("progress load", function (a) {
          a = a || {}, h.notify(a.total ? a.loaded / a.total : 1);
        }), g.on("complete", function () {
          h.resolve(g.getResult());
        }), g.on("error", function (a) {
          h.reject(a);
        }), arguments.length > 1 && (e = e || 0, f = f || 0, 0 > e && (e = i.size + e), 0 > f && (f = i.size + f), f = Math.min(f, i.size), i = i.slice(e, f)), g.loadFromBlob(i), h.promise();
      } });
  }), b("runtime/compbase", [], function () {
    function a(a, b) {
      this.owner = a, this.options = a.options, this.getRuntime = function () {
        return b;
      }, this.getRuid = function () {
        return b.uid;
      }, this.trigger = function () {
        return a.trigger.apply(a, arguments);
      };
    }return a;
  }), b("runtime/html5/runtime", ["base", "runtime/runtime", "runtime/compbase"], function (b, c, d) {
    function e() {
      var a = {},
          d = this,
          e = this.destroy;c.apply(d, arguments), d.type = f, d.exec = function (c, e) {
        var f,
            h = this,
            i = h.uid,
            j = b.slice(arguments, 2);return g[c] && (f = a[i] = a[i] || new g[c](h, d), f[e]) ? f[e].apply(f, j) : void 0;
      }, d.destroy = function () {
        return e && e.apply(this, arguments);
      };
    }var f = "html5",
        g = {};return b.inherits(c, { constructor: e, init: function init() {
        var a = this;setTimeout(function () {
          a.trigger("ready");
        }, 1);
      } }), e.register = function (a, c) {
      var e = g[a] = b.inherits(d, c);return e;
    }, a.Blob && a.FileReader && a.DataView && c.addRuntime(f, e), e;
  }), b("runtime/html5/blob", ["runtime/html5/runtime", "lib/blob"], function (a, b) {
    return a.register("Blob", { slice: function slice(a, c) {
        var d = this.owner.source,
            e = d.slice || d.webkitSlice || d.mozSlice;return d = e.call(d, a, c), new b(this.getRuid(), d);
      } });
  }), b("runtime/html5/dnd", ["base", "runtime/html5/runtime", "lib/file"], function (a, b, c) {
    var d = a.$,
        e = "webuploader-dnd-";return b.register("DragAndDrop", { init: function init() {
        var b = this.elem = this.options.container;this.dragEnterHandler = a.bindFn(this._dragEnterHandler, this), this.dragOverHandler = a.bindFn(this._dragOverHandler, this), this.dragLeaveHandler = a.bindFn(this._dragLeaveHandler, this), this.dropHandler = a.bindFn(this._dropHandler, this), this.dndOver = !1, b.on("dragenter", this.dragEnterHandler), b.on("dragover", this.dragOverHandler), b.on("dragleave", this.dragLeaveHandler), b.on("drop", this.dropHandler), this.options.disableGlobalDnd && (d(document).on("dragover", this.dragOverHandler), d(document).on("drop", this.dropHandler));
      }, _dragEnterHandler: function _dragEnterHandler(a) {
        var b,
            c = this,
            d = c._denied || !1;return a = a.originalEvent || a, c.dndOver || (c.dndOver = !0, b = a.dataTransfer.items, b && b.length && (c._denied = d = !c.trigger("accept", b)), c.elem.addClass(e + "over"), c.elem[d ? "addClass" : "removeClass"](e + "denied")), a.dataTransfer.dropEffect = d ? "none" : "copy", !1;
      }, _dragOverHandler: function _dragOverHandler(a) {
        var b = this.elem.parent().get(0);return b && !d.contains(b, a.currentTarget) ? !1 : (clearTimeout(this._leaveTimer), this._dragEnterHandler.call(this, a), !1);
      }, _dragLeaveHandler: function _dragLeaveHandler() {
        var a,
            b = this;return a = function a() {
          b.dndOver = !1, b.elem.removeClass(e + "over " + e + "denied");
        }, clearTimeout(b._leaveTimer), b._leaveTimer = setTimeout(a, 100), !1;
      }, _dropHandler: function _dropHandler(a) {
        var b,
            f,
            g = this,
            h = g.getRuid(),
            i = g.elem.parent().get(0);if (i && !d.contains(i, a.currentTarget)) return !1;a = a.originalEvent || a, b = a.dataTransfer;try {
          f = b.getData("text/html");
        } catch (j) {}return g.dndOver = !1, g.elem.removeClass(e + "over"), b && !f ? (g._getTansferFiles(b, function (a) {
          g.trigger("drop", d.map(a, function (a) {
            return new c(h, a);
          }));
        }), !1) : void 0;
      }, _getTansferFiles: function _getTansferFiles(b, c) {
        var d,
            e,
            f,
            g,
            h,
            i,
            j,
            k = [],
            l = [];for (d = b.items, e = b.files, j = !(!d || !d[0].webkitGetAsEntry), h = 0, i = e.length; i > h; h++) {
          f = e[h], g = d && d[h], j && g.webkitGetAsEntry().isDirectory ? l.push(this._traverseDirectoryTree(g.webkitGetAsEntry(), k)) : k.push(f);
        }a.when.apply(a, l).done(function () {
          k.length && c(k);
        });
      }, _traverseDirectoryTree: function _traverseDirectoryTree(b, c) {
        var d = a.Deferred(),
            e = this;return b.isFile ? b.file(function (a) {
          c.push(a), d.resolve();
        }) : b.isDirectory && b.createReader().readEntries(function (b) {
          var f,
              g = b.length,
              h = [],
              i = [];for (f = 0; g > f; f++) {
            h.push(e._traverseDirectoryTree(b[f], i));
          }a.when.apply(a, h).then(function () {
            c.push.apply(c, i), d.resolve();
          }, d.reject);
        }), d.promise();
      }, destroy: function destroy() {
        var a = this.elem;a && (a.off("dragenter", this.dragEnterHandler), a.off("dragover", this.dragOverHandler), a.off("dragleave", this.dragLeaveHandler), a.off("drop", this.dropHandler), this.options.disableGlobalDnd && (d(document).off("dragover", this.dragOverHandler), d(document).off("drop", this.dropHandler)));
      } });
  }), b("runtime/html5/filepaste", ["base", "runtime/html5/runtime", "lib/file"], function (a, b, c) {
    return b.register("FilePaste", { init: function init() {
        var b,
            c,
            d,
            e,
            f = this.options,
            g = this.elem = f.container,
            h = ".*";if (f.accept) {
          for (b = [], c = 0, d = f.accept.length; d > c; c++) {
            e = f.accept[c].mimeTypes, e && b.push(e);
          }b.length && (h = b.join(","), h = h.replace(/,/g, "|").replace(/\*/g, ".*"));
        }this.accept = h = new RegExp(h, "i"), this.hander = a.bindFn(this._pasteHander, this), g.on("paste", this.hander);
      }, _pasteHander: function _pasteHander(a) {
        var b,
            d,
            e,
            f,
            g,
            h = [],
            i = this.getRuid();for (a = a.originalEvent || a, b = a.clipboardData.items, f = 0, g = b.length; g > f; f++) {
          d = b[f], "file" === d.kind && (e = d.getAsFile()) && h.push(new c(i, e));
        }h.length && (a.preventDefault(), a.stopPropagation(), this.trigger("paste", h));
      }, destroy: function destroy() {
        this.elem.off("paste", this.hander);
      } });
  }), b("runtime/html5/filepicker", ["base", "runtime/html5/runtime"], function (a, b) {
    var c = a.$;return b.register("FilePicker", { init: function init() {
        var a,
            b,
            d,
            e,
            _f,
            g = this.getRuntime().getContainer(),
            h = this,
            i = h.owner,
            j = h.options,
            k = this.label = c(document.createElement("label")),
            l = this.input = c(document.createElement("input"));if (l.attr("type", "file"), l.attr("capture", "camera"), l.attr("name", j.name), l.addClass("webuploader-element-invisible"), k.on("click", function (a) {
          l.trigger("click"), a.stopPropagation(), i.trigger("dialogopen");
        }), k.css({ opacity: 0, width: "100%", height: "100%", display: "block", cursor: "pointer", background: "#ffffff" }), j.multiple && l.attr("multiple", "multiple"), j.accept && j.accept.length > 0) {
          for (a = [], b = 0, d = j.accept.length; d > b; b++) {
            a.push(j.accept[b].mimeTypes);
          }l.attr("accept", a.join(","));
        }g.append(l), g.append(k), e = function e(a) {
          i.trigger(a.type);
        }, _f = function f(a) {
          var b;return 0 === a.target.files.length ? !1 : (h.files = a.target.files, b = this.cloneNode(!0), b.value = null, this.parentNode.replaceChild(b, this), l.off(), l = c(b).on("change", _f).on("mouseenter mouseleave", e), i.trigger("change"), void 0);
        }, l.on("change", _f), k.on("mouseenter mouseleave", e);
      }, getFiles: function getFiles() {
        return this.files;
      }, destroy: function destroy() {
        this.input.off(), this.label.off();
      } });
  }), b("runtime/html5/util", ["base"], function (b) {
    var c = a.createObjectURL && a || a.URL && URL.revokeObjectURL && URL || a.webkitURL,
        d = b.noop,
        e = d;return c && (d = function d() {
      return c.createObjectURL.apply(c, arguments);
    }, e = function e() {
      return c.revokeObjectURL.apply(c, arguments);
    }), { createObjectURL: d, revokeObjectURL: e, dataURL2Blob: function dataURL2Blob(a) {
        var b, c, d, e, f, g;for (g = a.split(","), b = ~g[0].indexOf("base64") ? atob(g[1]) : decodeURIComponent(g[1]), d = new ArrayBuffer(b.length), c = new Uint8Array(d), e = 0; e < b.length; e++) {
          c[e] = b.charCodeAt(e);
        }return f = g[0].split(":")[1].split(";")[0], this.arrayBufferToBlob(d, f);
      }, dataURL2ArrayBuffer: function dataURL2ArrayBuffer(a) {
        var b, c, d, e;for (e = a.split(","), b = ~e[0].indexOf("base64") ? atob(e[1]) : decodeURIComponent(e[1]), c = new Uint8Array(b.length), d = 0; d < b.length; d++) {
          c[d] = b.charCodeAt(d);
        }return c.buffer;
      }, arrayBufferToBlob: function arrayBufferToBlob(b, c) {
        var d,
            e = a.BlobBuilder || a.WebKitBlobBuilder;return e ? (d = new e(), d.append(b), d.getBlob(c)) : new Blob([b], c ? { type: c } : {});
      }, canvasToDataUrl: function canvasToDataUrl(a, b, c) {
        return a.toDataURL(b, c / 100);
      }, parseMeta: function parseMeta(a, b) {
        b(!1, {});
      }, updateImageHead: function updateImageHead(a) {
        return a;
      } };
  }), b("runtime/html5/imagemeta", ["runtime/html5/util"], function (a) {
    var b;return b = { parsers: { 65505: [] }, maxMetaDataSize: 262144, parse: function parse(a, b) {
        var c = this,
            d = new FileReader();d.onload = function () {
          b(!1, c._parse(this.result)), d = d.onload = d.onerror = null;
        }, d.onerror = function (a) {
          b(a.message), d = d.onload = d.onerror = null;
        }, a = a.slice(0, c.maxMetaDataSize), d.readAsArrayBuffer(a.getSource());
      }, _parse: function _parse(a, c) {
        if (!(a.byteLength < 6)) {
          var d,
              e,
              f,
              g,
              h = new DataView(a),
              i = 2,
              j = h.byteLength - 4,
              k = i,
              l = {};if (65496 === h.getUint16(0)) {
            for (; j > i && (d = h.getUint16(i), d >= 65504 && 65519 >= d || 65534 === d) && (e = h.getUint16(i + 2) + 2, !(i + e > h.byteLength));) {
              if (f = b.parsers[d], !c && f) for (g = 0; g < f.length; g += 1) {
                f[g].call(b, h, i, e, l);
              }i += e, k = i;
            }k > 6 && (l.imageHead = a.slice ? a.slice(2, k) : new Uint8Array(a).subarray(2, k));
          }return l;
        }
      }, updateImageHead: function updateImageHead(a, b) {
        var c,
            d,
            e,
            f = this._parse(a, !0);return e = 2, f.imageHead && (e = 2 + f.imageHead.byteLength), d = a.slice ? a.slice(e) : new Uint8Array(a).subarray(e), c = new Uint8Array(b.byteLength + 2 + d.byteLength), c[0] = 255, c[1] = 216, c.set(new Uint8Array(b), 2), c.set(new Uint8Array(d), b.byteLength + 2), c.buffer;
      } }, a.parseMeta = function () {
      return b.parse.apply(b, arguments);
    }, a.updateImageHead = function () {
      return b.updateImageHead.apply(b, arguments);
    }, b;
  }), b("runtime/html5/imagemeta/exif", ["base", "runtime/html5/imagemeta"], function (a, b) {
    var c = {};return c.ExifMap = function () {
      return this;
    }, c.ExifMap.prototype.map = { Orientation: 274 }, c.ExifMap.prototype.get = function (a) {
      return this[a] || this[this.map[a]];
    }, c.exifTagTypes = { 1: { getValue: function getValue(a, b) {
          return a.getUint8(b);
        }, size: 1 }, 2: { getValue: function getValue(a, b) {
          return String.fromCharCode(a.getUint8(b));
        }, size: 1, ascii: !0 }, 3: { getValue: function getValue(a, b, c) {
          return a.getUint16(b, c);
        }, size: 2 }, 4: { getValue: function getValue(a, b, c) {
          return a.getUint32(b, c);
        }, size: 4 }, 5: { getValue: function getValue(a, b, c) {
          return a.getUint32(b, c) / a.getUint32(b + 4, c);
        }, size: 8 }, 9: { getValue: function getValue(a, b, c) {
          return a.getInt32(b, c);
        }, size: 4 }, 10: { getValue: function getValue(a, b, c) {
          return a.getInt32(b, c) / a.getInt32(b + 4, c);
        }, size: 8 } }, c.exifTagTypes[7] = c.exifTagTypes[1], c.getExifValue = function (b, d, e, f, g, h) {
      var i,
          j,
          k,
          l,
          m,
          n,
          o = c.exifTagTypes[f];if (!o) return a.log("Invalid Exif data: Invalid tag type."), void 0;if (i = o.size * g, j = i > 4 ? d + b.getUint32(e + 8, h) : e + 8, j + i > b.byteLength) return a.log("Invalid Exif data: Invalid data offset."), void 0;if (1 === g) return o.getValue(b, j, h);for (k = [], l = 0; g > l; l += 1) {
        k[l] = o.getValue(b, j + l * o.size, h);
      }if (o.ascii) {
        for (m = "", l = 0; l < k.length && (n = k[l], "\0" !== n); l += 1) {
          m += n;
        }return m;
      }return k;
    }, c.parseExifTag = function (a, b, d, e, f) {
      var g = a.getUint16(d, e);f.exif[g] = c.getExifValue(a, b, d, a.getUint16(d + 2, e), a.getUint32(d + 4, e), e);
    }, c.parseExifTags = function (b, c, d, e, f) {
      var g, h, i;if (d + 6 > b.byteLength) return a.log("Invalid Exif data: Invalid directory offset."), void 0;if (g = b.getUint16(d, e), h = d + 2 + 12 * g, h + 4 > b.byteLength) return a.log("Invalid Exif data: Invalid directory size."), void 0;for (i = 0; g > i; i += 1) {
        this.parseExifTag(b, c, d + 2 + 12 * i, e, f);
      }return b.getUint32(h, e);
    }, c.parseExifData = function (b, d, e, f) {
      var g,
          h,
          i = d + 10;if (1165519206 === b.getUint32(d + 4)) {
        if (i + 8 > b.byteLength) return a.log("Invalid Exif data: Invalid segment size."), void 0;if (0 !== b.getUint16(d + 8)) return a.log("Invalid Exif data: Missing byte alignment offset."), void 0;switch (b.getUint16(i)) {case 18761:
            g = !0;break;case 19789:
            g = !1;break;default:
            return a.log("Invalid Exif data: Invalid byte alignment marker."), void 0;}if (42 !== b.getUint16(i + 2, g)) return a.log("Invalid Exif data: Missing TIFF marker."), void 0;h = b.getUint32(i + 4, g), f.exif = new c.ExifMap(), h = c.parseExifTags(b, i, i + h, g, f);
      }
    }, b.parsers[65505].push(c.parseExifData), c;
  }), b("runtime/html5/jpegencoder", [], function () {
    function a(a) {
      function b(a) {
        for (var b = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], c = 0; 64 > c; c++) {
          var d = y((b[c] * a + 50) / 100);1 > d ? d = 1 : d > 255 && (d = 255), z[P[c]] = d;
        }for (var e = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], f = 0; 64 > f; f++) {
          var g = y((e[f] * a + 50) / 100);1 > g ? g = 1 : g > 255 && (g = 255), A[P[f]] = g;
        }for (var h = [1, 1.387039845, 1.306562965, 1.175875602, 1, .785694958, .5411961, .275899379], i = 0, j = 0; 8 > j; j++) {
          for (var k = 0; 8 > k; k++) {
            B[i] = 1 / (8 * z[P[i]] * h[j] * h[k]), C[i] = 1 / (8 * A[P[i]] * h[j] * h[k]), i++;
          }
        }
      }function c(a, b) {
        for (var c = 0, d = 0, e = new Array(), f = 1; 16 >= f; f++) {
          for (var g = 1; g <= a[f]; g++) {
            e[b[d]] = [], e[b[d]][0] = c, e[b[d]][1] = f, d++, c++;
          }c *= 2;
        }return e;
      }function d() {
        t = c(Q, R), u = c(U, V), v = c(S, T), w = c(W, X);
      }function e() {
        for (var a = 1, b = 2, c = 1; 15 >= c; c++) {
          for (var d = a; b > d; d++) {
            E[32767 + d] = c, D[32767 + d] = [], D[32767 + d][1] = c, D[32767 + d][0] = d;
          }for (var e = -(b - 1); -a >= e; e++) {
            E[32767 + e] = c, D[32767 + e] = [], D[32767 + e][1] = c, D[32767 + e][0] = b - 1 + e;
          }a <<= 1, b <<= 1;
        }
      }function f() {
        for (var a = 0; 256 > a; a++) {
          O[a] = 19595 * a, O[a + 256 >> 0] = 38470 * a, O[a + 512 >> 0] = 7471 * a + 32768, O[a + 768 >> 0] = -11059 * a, O[a + 1024 >> 0] = -21709 * a, O[a + 1280 >> 0] = 32768 * a + 8421375, O[a + 1536 >> 0] = -27439 * a, O[a + 1792 >> 0] = -5329 * a;
        }
      }function g(a) {
        for (var b = a[0], c = a[1] - 1; c >= 0;) {
          b & 1 << c && (I |= 1 << J), c--, J--, 0 > J && (255 == I ? (h(255), h(0)) : h(I), J = 7, I = 0);
        }
      }function h(a) {
        H.push(N[a]);
      }function i(a) {
        h(255 & a >> 8), h(255 & a);
      }function j(a, b) {
        var c,
            d,
            e,
            f,
            g,
            h,
            i,
            j,
            k,
            l = 0,
            m = 8,
            n = 64;for (k = 0; m > k; ++k) {
          c = a[l], d = a[l + 1], e = a[l + 2], f = a[l + 3], g = a[l + 4], h = a[l + 5], i = a[l + 6], j = a[l + 7];var o = c + j,
              p = c - j,
              q = d + i,
              r = d - i,
              s = e + h,
              t = e - h,
              u = f + g,
              v = f - g,
              w = o + u,
              x = o - u,
              y = q + s,
              z = q - s;a[l] = w + y, a[l + 4] = w - y;var A = .707106781 * (z + x);a[l + 2] = x + A, a[l + 6] = x - A, w = v + t, y = t + r, z = r + p;var B = .382683433 * (w - z),
              C = .5411961 * w + B,
              D = 1.306562965 * z + B,
              E = .707106781 * y,
              G = p + E,
              H = p - E;a[l + 5] = H + C, a[l + 3] = H - C, a[l + 1] = G + D, a[l + 7] = G - D, l += 8;
        }for (l = 0, k = 0; m > k; ++k) {
          c = a[l], d = a[l + 8], e = a[l + 16], f = a[l + 24], g = a[l + 32], h = a[l + 40], i = a[l + 48], j = a[l + 56];var I = c + j,
              J = c - j,
              K = d + i,
              L = d - i,
              M = e + h,
              N = e - h,
              O = f + g,
              P = f - g,
              Q = I + O,
              R = I - O,
              S = K + M,
              T = K - M;a[l] = Q + S, a[l + 32] = Q - S;var U = .707106781 * (T + R);a[l + 16] = R + U, a[l + 48] = R - U, Q = P + N, S = N + L, T = L + J;var V = .382683433 * (Q - T),
              W = .5411961 * Q + V,
              X = 1.306562965 * T + V,
              Y = .707106781 * S,
              Z = J + Y,
              $ = J - Y;a[l + 40] = $ + W, a[l + 24] = $ - W, a[l + 8] = Z + X, a[l + 56] = Z - X, l++;
        }var _;for (k = 0; n > k; ++k) {
          _ = a[k] * b[k], F[k] = _ > 0 ? 0 | _ + .5 : 0 | _ - .5;
        }return F;
      }function k() {
        i(65504), i(16), h(74), h(70), h(73), h(70), h(0), h(1), h(1), h(0), i(1), i(1), h(0), h(0);
      }function l(a, b) {
        i(65472), i(17), h(8), i(b), i(a), h(3), h(1), h(17), h(0), h(2), h(17), h(1), h(3), h(17), h(1);
      }function m() {
        i(65499), i(132), h(0);for (var a = 0; 64 > a; a++) {
          h(z[a]);
        }h(1);for (var b = 0; 64 > b; b++) {
          h(A[b]);
        }
      }function n() {
        i(65476), i(418), h(0);for (var a = 0; 16 > a; a++) {
          h(Q[a + 1]);
        }for (var b = 0; 11 >= b; b++) {
          h(R[b]);
        }h(16);for (var c = 0; 16 > c; c++) {
          h(S[c + 1]);
        }for (var d = 0; 161 >= d; d++) {
          h(T[d]);
        }h(1);for (var e = 0; 16 > e; e++) {
          h(U[e + 1]);
        }for (var f = 0; 11 >= f; f++) {
          h(V[f]);
        }h(17);for (var g = 0; 16 > g; g++) {
          h(W[g + 1]);
        }for (var j = 0; 161 >= j; j++) {
          h(X[j]);
        }
      }function o() {
        i(65498), i(12), h(3), h(1), h(0), h(2), h(17), h(3), h(17), h(0), h(63), h(0);
      }function p(a, b, c, d, e) {
        for (var f, h = e[0], i = e[240], k = 16, l = 63, m = 64, n = j(a, b), o = 0; m > o; ++o) {
          G[P[o]] = n[o];
        }var p = G[0] - c;c = G[0], 0 == p ? g(d[0]) : (f = 32767 + p, g(d[E[f]]), g(D[f]));for (var q = 63; q > 0 && 0 == G[q]; q--) {}if (0 == q) return g(h), c;for (var r, s = 1; q >= s;) {
          for (var t = s; 0 == G[s] && q >= s; ++s) {}var u = s - t;if (u >= k) {
            r = u >> 4;for (var v = 1; r >= v; ++v) {
              g(i);
            }u = 15 & u;
          }f = 32767 + G[s], g(e[(u << 4) + E[f]]), g(D[f]), s++;
        }return q != l && g(h), c;
      }function q() {
        for (var a = String.fromCharCode, b = 0; 256 > b; b++) {
          N[b] = a(b);
        }
      }function r(a) {
        if (0 >= a && (a = 1), a > 100 && (a = 100), x != a) {
          var c = 0;c = 50 > a ? Math.floor(5e3 / a) : Math.floor(200 - 2 * a), b(c), x = a;
        }
      }function s() {
        a || (a = 50), q(), d(), e(), f(), r(a);
      }Math.round;var t,
          u,
          v,
          w,
          x,
          y = Math.floor,
          z = new Array(64),
          A = new Array(64),
          B = new Array(64),
          C = new Array(64),
          D = new Array(65535),
          E = new Array(65535),
          F = new Array(64),
          G = new Array(64),
          H = [],
          I = 0,
          J = 7,
          K = new Array(64),
          L = new Array(64),
          M = new Array(64),
          N = new Array(256),
          O = new Array(2048),
          P = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63],
          Q = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
          R = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          S = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125],
          T = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250],
          U = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
          V = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          W = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119],
          X = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];this.encode = function (a, b) {
        b && r(b), H = new Array(), I = 0, J = 7, i(65496), k(), m(), l(a.width, a.height), n(), o();var c = 0,
            d = 0,
            e = 0;I = 0, J = 7, this.encode.displayName = "_encode_";for (var f, h, j, q, s, x, y, z, A, D = a.data, E = a.width, F = a.height, G = 4 * E, N = 0; F > N;) {
          for (f = 0; G > f;) {
            for (s = G * N + f, x = s, y = -1, z = 0, A = 0; 64 > A; A++) {
              z = A >> 3, y = 4 * (7 & A), x = s + z * G + y, N + z >= F && (x -= G * (N + 1 + z - F)), f + y >= G && (x -= f + y - G + 4), h = D[x++], j = D[x++], q = D[x++], K[A] = (O[h] + O[j + 256 >> 0] + O[q + 512 >> 0] >> 16) - 128, L[A] = (O[h + 768 >> 0] + O[j + 1024 >> 0] + O[q + 1280 >> 0] >> 16) - 128, M[A] = (O[h + 1280 >> 0] + O[j + 1536 >> 0] + O[q + 1792 >> 0] >> 16) - 128;
            }c = p(K, B, c, t, v), d = p(L, C, d, u, w), e = p(M, C, e, u, w), f += 32;
          }N += 8;
        }if (J >= 0) {
          var P = [];P[1] = J + 1, P[0] = (1 << J + 1) - 1, g(P);
        }i(65497);var Q = "data:image/jpeg;base64," + btoa(H.join(""));return H = [], Q;
      }, s();
    }return a.encode = function (b, c) {
      var d = new a(c);return d.encode(b);
    }, a;
  }), b("runtime/html5/androidpatch", ["runtime/html5/util", "runtime/html5/jpegencoder", "base"], function (a, b, c) {
    var d,
        e = a.canvasToDataUrl;a.canvasToDataUrl = function (a, f, g) {
      var h, i, j, k, l;return c.os.android ? ("image/jpeg" === f && "undefined" == typeof d && (k = e.apply(null, arguments), l = k.split(","), k = ~l[0].indexOf("base64") ? atob(l[1]) : decodeURIComponent(l[1]), k = k.substring(0, 2), d = 255 === k.charCodeAt(0) && 216 === k.charCodeAt(1)), "image/jpeg" !== f || d ? e.apply(null, arguments) : (i = a.width, j = a.height, h = a.getContext("2d"), b.encode(h.getImageData(0, 0, i, j), g))) : e.apply(null, arguments);
    };
  }), b("runtime/html5/image", ["base", "runtime/html5/runtime", "runtime/html5/util"], function (a, b, c) {
    var d = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";return b.register("Image", { modified: !1, init: function init() {
        var a = this,
            b = new Image();b.onload = function () {
          a._info = { type: a.type, width: this.width, height: this.height }, a._metas || "image/jpeg" !== a.type ? a.owner.trigger("load") : c.parseMeta(a._blob, function (b, c) {
            a._metas = c, a.owner.trigger("load");
          });
        }, b.onerror = function () {
          a.owner.trigger("error");
        }, a._img = b;
      }, loadFromBlob: function loadFromBlob(a) {
        var b = this,
            d = b._img;b._blob = a, b.type = a.type, d.src = c.createObjectURL(a.getSource()), b.owner.once("load", function () {
          c.revokeObjectURL(d.src);
        });
      }, resize: function resize(a, b) {
        var c = this._canvas || (this._canvas = document.createElement("canvas"));this._resize(this._img, c, a, b), this._blob = null, this.modified = !0, this.owner.trigger("complete", "resize");
      }, crop: function crop(a, b, c, d, e) {
        var f = this._canvas || (this._canvas = document.createElement("canvas")),
            g = this.options,
            h = this._img,
            i = h.naturalWidth,
            j = h.naturalHeight,
            k = this.getOrientation();e = e || 1, f.width = c, f.height = d, g.preserveHeaders || this._rotate2Orientaion(f, k), this._renderImageToCanvas(f, h, -a, -b, i * e, j * e), this._blob = null, this.modified = !0, this.owner.trigger("complete", "crop");
      }, getAsBlob: function getAsBlob(a) {
        var b,
            d = this._blob,
            e = this.options;if (a = a || this.type, this.modified || this.type !== a) {
          if (b = this._canvas, "image/jpeg" === a) {
            if (d = c.canvasToDataUrl(b, a, e.quality), e.preserveHeaders && this._metas && this._metas.imageHead) return d = c.dataURL2ArrayBuffer(d), d = c.updateImageHead(d, this._metas.imageHead), d = c.arrayBufferToBlob(d, a);
          } else d = c.canvasToDataUrl(b, a);d = c.dataURL2Blob(d);
        }return d;
      }, getAsDataUrl: function getAsDataUrl(a) {
        var b = this.options;return a = a || this.type, "image/jpeg" === a ? c.canvasToDataUrl(this._canvas, a, b.quality) : this._canvas.toDataURL(a);
      }, getOrientation: function getOrientation() {
        return this._metas && this._metas.exif && this._metas.exif.get("Orientation") || 1;
      }, info: function info(a) {
        return a ? (this._info = a, this) : this._info;
      }, meta: function meta(a) {
        return a ? (this._metas = a, this) : this._metas;
      }, destroy: function destroy() {
        var a = this._canvas;this._img.onload = null, a && (a.getContext("2d").clearRect(0, 0, a.width, a.height), a.width = a.height = 0, this._canvas = null), this._img.src = d, this._img = this._blob = null;
      }, _resize: function _resize(a, b, c, d) {
        var e,
            f,
            g,
            h,
            i,
            j = this.options,
            k = a.width,
            l = a.height,
            m = this.getOrientation();~[5, 6, 7, 8].indexOf(m) && (c ^= d, d ^= c, c ^= d), e = Math[j.crop ? "max" : "min"](c / k, d / l), j.allowMagnify || (e = Math.min(1, e)), f = k * e, g = l * e, j.crop ? (b.width = c, b.height = d) : (b.width = f, b.height = g), h = (b.width - f) / 2, i = (b.height - g) / 2, j.preserveHeaders || this._rotate2Orientaion(b, m), this._renderImageToCanvas(b, a, h, i, f, g);
      }, _rotate2Orientaion: function _rotate2Orientaion(a, b) {
        var c = a.width,
            d = a.height,
            e = a.getContext("2d");switch (b) {case 5:case 6:case 7:case 8:
            a.width = d, a.height = c;}switch (b) {case 2:
            e.translate(c, 0), e.scale(-1, 1);break;case 3:
            e.translate(c, d), e.rotate(Math.PI);break;case 4:
            e.translate(0, d), e.scale(1, -1);break;case 5:
            e.rotate(.5 * Math.PI), e.scale(1, -1);break;case 6:
            e.rotate(.5 * Math.PI), e.translate(0, -d);break;case 7:
            e.rotate(.5 * Math.PI), e.translate(c, -d), e.scale(-1, 1);break;case 8:
            e.rotate(-.5 * Math.PI), e.translate(-c, 0);}
      }, _renderImageToCanvas: function () {
        function b(a, b, c) {
          var d,
              e,
              f,
              g = document.createElement("canvas"),
              h = g.getContext("2d"),
              i = 0,
              j = c,
              k = c;for (g.width = 1, g.height = c, h.drawImage(a, 0, 0), d = h.getImageData(0, 0, 1, c).data; k > i;) {
            e = d[4 * (k - 1) + 3], 0 === e ? j = k : i = k, k = j + i >> 1;
          }return f = k / c, 0 === f ? 1 : f;
        }function c(a) {
          var b,
              c,
              d = a.naturalWidth,
              e = a.naturalHeight;return d * e > 1048576 ? (b = document.createElement("canvas"), b.width = b.height = 1, c = b.getContext("2d"), c.drawImage(a, -d + 1, 0), 0 === c.getImageData(0, 0, 1, 1).data[3]) : !1;
        }return a.os.ios ? a.os.ios >= 7 ? function (a, c, d, e, f, g) {
          var h = c.naturalWidth,
              i = c.naturalHeight,
              j = b(c, h, i);return a.getContext("2d").drawImage(c, 0, 0, h * j, i * j, d, e, f, g);
        } : function (a, d, e, f, g, h) {
          var i,
              j,
              k,
              l,
              m,
              n,
              o,
              p = d.naturalWidth,
              q = d.naturalHeight,
              r = a.getContext("2d"),
              s = c(d),
              t = "image/jpeg" === this.type,
              u = 1024,
              v = 0,
              w = 0;for (s && (p /= 2, q /= 2), r.save(), i = document.createElement("canvas"), i.width = i.height = u, j = i.getContext("2d"), k = t ? b(d, p, q) : 1, l = Math.ceil(u * g / p), m = Math.ceil(u * h / q / k); q > v;) {
            for (n = 0, o = 0; p > n;) {
              j.clearRect(0, 0, u, u), j.drawImage(d, -n, -v), r.drawImage(i, 0, 0, u, u, e + o, f + w, l, m), n += u, o += l;
            }v += u, w += m;
          }r.restore(), i = j = null;
        } : function (b) {
          var c = a.slice(arguments, 1),
              d = b.getContext("2d");d.drawImage.apply(d, c);
        };
      }() });
  }), b("runtime/html5/transport", ["base", "runtime/html5/runtime"], function (a, b) {
    var c = a.noop,
        d = a.$;return b.register("Transport", { init: function init() {
        this._status = 0, this._response = null;
      }, send: function send() {
        var b,
            c,
            e,
            f = this.owner,
            g = this.options,
            h = this._initAjax(),
            i = f._blob,
            j = g.server;g.sendAsBinary ? (j += g.attachInfoToQuery !== !1 ? (/\?/.test(j) ? "&" : "?") + d.param(f._formData) : "", c = i.getSource()) : (b = new FormData(), d.each(f._formData, function (a, c) {
          b.append(a, c);
        }), b.append(g.fileVal, i.getSource(), g.filename || f._formData.name || "")), g.withCredentials && "withCredentials" in h ? (h.open(g.method, j, !0), h.withCredentials = !0) : h.open(g.method, j), this._setRequestHeader(h, g.headers), c ? (h.overrideMimeType && h.overrideMimeType("application/octet-stream"), a.os.android ? (e = new FileReader(), e.onload = function () {
          h.send(this.result), e = e.onload = null;
        }, e.readAsArrayBuffer(c)) : h.send(c)) : h.send(b);
      }, getResponse: function getResponse() {
        return this._response;
      }, getResponseAsJson: function getResponseAsJson() {
        return this._parseJson(this._response);
      }, getResponseHeaders: function getResponseHeaders() {
        return this._headers;
      }, getStatus: function getStatus() {
        return this._status;
      }, abort: function abort() {
        var a = this._xhr;a && (a.upload.onprogress = c, a.onreadystatechange = c, a.abort(), this._xhr = a = null);
      }, destroy: function destroy() {
        this.abort();
      }, _parseHeader: function _parseHeader(a) {
        var b = {};return a && a.replace(/^([^\:]+):(.*)$/gm, function (a, c, d) {
          b[c.trim()] = d.trim();
        }), b;
      }, _initAjax: function _initAjax() {
        var a = this,
            b = new XMLHttpRequest(),
            d = this.options;return !d.withCredentials || "withCredentials" in b || "undefined" == typeof XDomainRequest || (b = new XDomainRequest()), b.upload.onprogress = function (b) {
          var c = 0;return b.lengthComputable && (c = b.loaded / b.total), a.trigger("progress", c);
        }, b.onreadystatechange = function () {
          return 4 === b.readyState ? (b.upload.onprogress = c, b.onreadystatechange = c, a._xhr = null, a._status = b.status, b.status >= 200 && b.status < 300 ? (a._response = b.responseText, a._headers = a._parseHeader(b.getAllResponseHeaders()), a.trigger("load")) : b.status >= 500 && b.status < 600 ? (a._response = b.responseText, a._headers = a._parseHeader(b.getAllResponseHeaders()), a.trigger("error", "server-" + b.status)) : a.trigger("error", a._status ? "http-" + b.status : "abort")) : void 0;
        }, a._xhr = b, b;
      }, _setRequestHeader: function _setRequestHeader(a, b) {
        d.each(b, function (b, c) {
          a.setRequestHeader(b, c);
        });
      }, _parseJson: function _parseJson(a) {
        var b;try {
          b = JSON.parse(a);
        } catch (c) {
          b = {};
        }return b;
      } });
  }), b("runtime/html5/md5", ["runtime/html5/runtime"], function (a) {
    var b = function b(a, _b2) {
      return 4294967295 & a + _b2;
    },
        c = function c(a, _c, d, e, f, g) {
      return _c = b(b(_c, a), b(e, g)), b(_c << f | _c >>> 32 - f, d);
    },
        d = function d(a, b, _d, e, f, g, h) {
      return c(b & _d | ~b & e, a, b, f, g, h);
    },
        e = function e(a, b, d, _e, f, g, h) {
      return c(b & _e | d & ~_e, a, b, f, g, h);
    },
        f = function f(a, b, d, e, _f2, g, h) {
      return c(b ^ d ^ e, a, b, _f2, g, h);
    },
        g = function g(a, b, d, e, f, _g, h) {
      return c(d ^ (b | ~e), a, b, f, _g, h);
    },
        h = function h(a, c) {
      var h = a[0],
          i = a[1],
          j = a[2],
          k = a[3];h = d(h, i, j, k, c[0], 7, -680876936), k = d(k, h, i, j, c[1], 12, -389564586), j = d(j, k, h, i, c[2], 17, 606105819), i = d(i, j, k, h, c[3], 22, -1044525330), h = d(h, i, j, k, c[4], 7, -176418897), k = d(k, h, i, j, c[5], 12, 1200080426), j = d(j, k, h, i, c[6], 17, -1473231341), i = d(i, j, k, h, c[7], 22, -45705983), h = d(h, i, j, k, c[8], 7, 1770035416), k = d(k, h, i, j, c[9], 12, -1958414417), j = d(j, k, h, i, c[10], 17, -42063), i = d(i, j, k, h, c[11], 22, -1990404162), h = d(h, i, j, k, c[12], 7, 1804603682), k = d(k, h, i, j, c[13], 12, -40341101), j = d(j, k, h, i, c[14], 17, -1502002290), i = d(i, j, k, h, c[15], 22, 1236535329), h = e(h, i, j, k, c[1], 5, -165796510), k = e(k, h, i, j, c[6], 9, -1069501632), j = e(j, k, h, i, c[11], 14, 643717713), i = e(i, j, k, h, c[0], 20, -373897302), h = e(h, i, j, k, c[5], 5, -701558691), k = e(k, h, i, j, c[10], 9, 38016083), j = e(j, k, h, i, c[15], 14, -660478335), i = e(i, j, k, h, c[4], 20, -405537848), h = e(h, i, j, k, c[9], 5, 568446438), k = e(k, h, i, j, c[14], 9, -1019803690), j = e(j, k, h, i, c[3], 14, -187363961), i = e(i, j, k, h, c[8], 20, 1163531501), h = e(h, i, j, k, c[13], 5, -1444681467), k = e(k, h, i, j, c[2], 9, -51403784), j = e(j, k, h, i, c[7], 14, 1735328473), i = e(i, j, k, h, c[12], 20, -1926607734), h = f(h, i, j, k, c[5], 4, -378558), k = f(k, h, i, j, c[8], 11, -2022574463), j = f(j, k, h, i, c[11], 16, 1839030562), i = f(i, j, k, h, c[14], 23, -35309556), h = f(h, i, j, k, c[1], 4, -1530992060), k = f(k, h, i, j, c[4], 11, 1272893353), j = f(j, k, h, i, c[7], 16, -155497632), i = f(i, j, k, h, c[10], 23, -1094730640), h = f(h, i, j, k, c[13], 4, 681279174), k = f(k, h, i, j, c[0], 11, -358537222), j = f(j, k, h, i, c[3], 16, -722521979), i = f(i, j, k, h, c[6], 23, 76029189), h = f(h, i, j, k, c[9], 4, -640364487), k = f(k, h, i, j, c[12], 11, -421815835), j = f(j, k, h, i, c[15], 16, 530742520), i = f(i, j, k, h, c[2], 23, -995338651), h = g(h, i, j, k, c[0], 6, -198630844), k = g(k, h, i, j, c[7], 10, 1126891415), j = g(j, k, h, i, c[14], 15, -1416354905), i = g(i, j, k, h, c[5], 21, -57434055), h = g(h, i, j, k, c[12], 6, 1700485571), k = g(k, h, i, j, c[3], 10, -1894986606), j = g(j, k, h, i, c[10], 15, -1051523), i = g(i, j, k, h, c[1], 21, -2054922799), h = g(h, i, j, k, c[8], 6, 1873313359), k = g(k, h, i, j, c[15], 10, -30611744), j = g(j, k, h, i, c[6], 15, -1560198380), i = g(i, j, k, h, c[13], 21, 1309151649), h = g(h, i, j, k, c[4], 6, -145523070), k = g(k, h, i, j, c[11], 10, -1120210379), j = g(j, k, h, i, c[2], 15, 718787259), i = g(i, j, k, h, c[9], 21, -343485551), a[0] = b(h, a[0]), a[1] = b(i, a[1]), a[2] = b(j, a[2]), a[3] = b(k, a[3]);
    },
        i = function i(a) {
      var b,
          c = [];for (b = 0; 64 > b; b += 4) {
        c[b >> 2] = a.charCodeAt(b) + (a.charCodeAt(b + 1) << 8) + (a.charCodeAt(b + 2) << 16) + (a.charCodeAt(b + 3) << 24);
      }return c;
    },
        j = function j(a) {
      var b,
          c = [];for (b = 0; 64 > b; b += 4) {
        c[b >> 2] = a[b] + (a[b + 1] << 8) + (a[b + 2] << 16) + (a[b + 3] << 24);
      }return c;
    },
        k = function k(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          j = a.length,
          k = [1732584193, -271733879, -1732584194, 271733878];for (b = 64; j >= b; b += 64) {
        h(k, i(a.substring(b - 64, b)));
      }for (a = a.substring(b - 64), c = a.length, d = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], b = 0; c > b; b += 1) {
        d[b >> 2] |= a.charCodeAt(b) << (b % 4 << 3);
      }if (d[b >> 2] |= 128 << (b % 4 << 3), b > 55) for (h(k, d), b = 0; 16 > b; b += 1) {
        d[b] = 0;
      }return e = 8 * j, e = e.toString(16).match(/(.*?)(.{0,8})$/), f = parseInt(e[2], 16), g = parseInt(e[1], 16) || 0, d[14] = f, d[15] = g, h(k, d), k;
    },
        l = function l(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          i = a.length,
          k = [1732584193, -271733879, -1732584194, 271733878];for (b = 64; i >= b; b += 64) {
        h(k, j(a.subarray(b - 64, b)));
      }for (a = i > b - 64 ? a.subarray(b - 64) : new Uint8Array(0), c = a.length, d = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], b = 0; c > b; b += 1) {
        d[b >> 2] |= a[b] << (b % 4 << 3);
      }if (d[b >> 2] |= 128 << (b % 4 << 3), b > 55) for (h(k, d), b = 0; 16 > b; b += 1) {
        d[b] = 0;
      }return e = 8 * i, e = e.toString(16).match(/(.*?)(.{0,8})$/), f = parseInt(e[2], 16), g = parseInt(e[1], 16) || 0, d[14] = f, d[15] = g, h(k, d), k;
    },
        m = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"],
        n = function n(a) {
      var b,
          c = "";for (b = 0; 4 > b; b += 1) {
        c += m[15 & a >> 8 * b + 4] + m[15 & a >> 8 * b];
      }return c;
    },
        o = function o(a) {
      var b;for (b = 0; b < a.length; b += 1) {
        a[b] = n(a[b]);
      }return a.join("");
    },
        p = function p(a) {
      return o(k(a));
    },
        q = function q() {
      this.reset();
    };return "5d41402abc4b2a76b9719d911017c592" !== p("hello") && (b = function b(a, _b3) {
      var c = (65535 & a) + (65535 & _b3),
          d = (a >> 16) + (_b3 >> 16) + (c >> 16);return d << 16 | 65535 & c;
    }), q.prototype.append = function (a) {
      return (/[\u0080-\uFFFF]/.test(a) && (a = unescape(encodeURIComponent(a))), this.appendBinary(a), this
      );
    }, q.prototype.appendBinary = function (a) {
      this._buff += a, this._length += a.length;var b,
          c = this._buff.length;for (b = 64; c >= b; b += 64) {
        h(this._state, i(this._buff.substring(b - 64, b)));
      }return this._buff = this._buff.substr(b - 64), this;
    }, q.prototype.end = function (a) {
      var b,
          c,
          d = this._buff,
          e = d.length,
          f = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];for (b = 0; e > b; b += 1) {
        f[b >> 2] |= d.charCodeAt(b) << (b % 4 << 3);
      }return this._finish(f, e), c = a ? this._state : o(this._state), this.reset(), c;
    }, q.prototype._finish = function (a, b) {
      var c,
          d,
          e,
          f = b;if (a[f >> 2] |= 128 << (f % 4 << 3), f > 55) for (h(this._state, a), f = 0; 16 > f; f += 1) {
        a[f] = 0;
      }c = 8 * this._length, c = c.toString(16).match(/(.*?)(.{0,8})$/), d = parseInt(c[2], 16), e = parseInt(c[1], 16) || 0, a[14] = d, a[15] = e, h(this._state, a);
    }, q.prototype.reset = function () {
      return this._buff = "", this._length = 0, this._state = [1732584193, -271733879, -1732584194, 271733878], this;
    }, q.prototype.destroy = function () {
      delete this._state, delete this._buff, delete this._length;
    }, q.hash = function (a, b) {
      /[\u0080-\uFFFF]/.test(a) && (a = unescape(encodeURIComponent(a)));var c = k(a);return b ? c : o(c);
    }, q.hashBinary = function (a, b) {
      var c = k(a);return b ? c : o(c);
    }, q.ArrayBuffer = function () {
      this.reset();
    }, q.ArrayBuffer.prototype.append = function (a) {
      var b,
          c = this._concatArrayBuffer(this._buff, a),
          d = c.length;for (this._length += a.byteLength, b = 64; d >= b; b += 64) {
        h(this._state, j(c.subarray(b - 64, b)));
      }return this._buff = d > b - 64 ? c.subarray(b - 64) : new Uint8Array(0), this;
    }, q.ArrayBuffer.prototype.end = function (a) {
      var b,
          c,
          d = this._buff,
          e = d.length,
          f = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];for (b = 0; e > b; b += 1) {
        f[b >> 2] |= d[b] << (b % 4 << 3);
      }return this._finish(f, e), c = a ? this._state : o(this._state), this.reset(), c;
    }, q.ArrayBuffer.prototype._finish = q.prototype._finish, q.ArrayBuffer.prototype.reset = function () {
      return this._buff = new Uint8Array(0), this._length = 0, this._state = [1732584193, -271733879, -1732584194, 271733878], this;
    }, q.ArrayBuffer.prototype.destroy = q.prototype.destroy, q.ArrayBuffer.prototype._concatArrayBuffer = function (a, b) {
      var c = a.length,
          d = new Uint8Array(c + b.byteLength);return d.set(a), d.set(new Uint8Array(b), c), d;
    }, q.ArrayBuffer.hash = function (a, b) {
      var c = l(new Uint8Array(a));return b ? c : o(c);
    }, a.register("Md5", { init: function init() {}, loadFromBlob: function loadFromBlob(a) {
        var _b4,
            c,
            d = a.getSource(),
            e = 2097152,
            f = Math.ceil(d.size / e),
            g = 0,
            h = this.owner,
            i = new q.ArrayBuffer(),
            j = this,
            k = d.mozSlice || d.webkitSlice || d.slice;c = new FileReader(), _b4 = function b() {
          var l, m;l = g * e, m = Math.min(l + e, d.size), c.onload = function (b) {
            i.append(b.target.result), h.trigger("progress", { total: a.size, loaded: m });
          }, c.onloadend = function () {
            c.onloadend = c.onload = null, ++g < f ? setTimeout(_b4, 1) : setTimeout(function () {
              h.trigger("load"), j.result = i.end(), _b4 = a = d = i = null, h.trigger("complete");
            }, 50);
          }, c.readAsArrayBuffer(k.call(d, l, m));
        }, _b4();
      }, getResult: function getResult() {
        return this.result;
      } });
  }), b("runtime/flash/runtime", ["base", "runtime/runtime", "runtime/compbase"], function (b, c, d) {
    function e() {
      var a;try {
        a = navigator.plugins["Shockwave Flash"], a = a.description;
      } catch (b) {
        try {
          a = new ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version");
        } catch (c) {
          a = "0.0";
        }
      }return a = a.match(/\d+/g), parseFloat(a[0] + "." + a[1], 10);
    }function f() {
      function d(a, b) {
        var c,
            d,
            e = a.type || a;c = e.split("::"), d = c[0], e = c[1], "Ready" === e && d === j.uid ? j.trigger("ready") : f[d] && f[d].trigger(e.toLowerCase(), a, b);
      }var e = {},
          f = {},
          g = this.destroy,
          j = this,
          k = b.guid("webuploader_");c.apply(j, arguments), j.type = h, j.exec = function (a, c) {
        var d,
            g = this,
            h = g.uid,
            k = b.slice(arguments, 2);return f[h] = g, i[a] && (e[h] || (e[h] = new i[a](g, j)), d = e[h], d[c]) ? d[c].apply(d, k) : j.flashExec.apply(g, arguments);
      }, a[k] = function () {
        var a = arguments;setTimeout(function () {
          d.apply(null, a);
        }, 1);
      }, this.jsreciver = k, this.destroy = function () {
        return g && g.apply(this, arguments);
      }, this.flashExec = function (a, c) {
        var d = j.getFlash(),
            e = b.slice(arguments, 2);return d.exec(this.uid, a, c, e);
      };
    }var g = b.$,
        h = "flash",
        i = {};return b.inherits(c, { constructor: f, init: function init() {
        var a,
            c = this.getContainer(),
            d = this.options;c.css({ position: "absolute", top: "-8px", left: "-8px", width: "9px", height: "9px", overflow: "hidden" }), a = '<object id="' + this.uid + '" type="application/' + 'x-shockwave-flash" data="' + d.swf + '" ', b.browser.ie && (a += 'classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" '), a += 'width="100%" height="100%" style="outline:0"><param name="movie" value="' + d.swf + '" />' + '<param name="flashvars" value="uid=' + this.uid + "&jsreciver=" + this.jsreciver + '" />' + '<param name="wmode" value="transparent" />' + '<param name="allowscriptaccess" value="always" />' + "</object>", c.html(a);
      }, getFlash: function getFlash() {
        return this._flash ? this._flash : (this._flash = g("#" + this.uid).get(0), this._flash);
      } }), f.register = function (a, c) {
      return c = i[a] = b.inherits(d, g.extend({ flashExec: function flashExec() {
          var a = this.owner,
              b = this.getRuntime();return b.flashExec.apply(a, arguments);
        } }, c));
    }, e() >= 11.4 && c.addRuntime(h, f), f;
  }), b("runtime/flash/filepicker", ["base", "runtime/flash/runtime"], function (a, b) {
    var c = a.$;return b.register("FilePicker", { init: function init(a) {
        var b,
            d,
            e = c.extend({}, a);for (b = e.accept && e.accept.length, d = 0; b > d; d++) {
          e.accept[d].title || (e.accept[d].title = "Files");
        }delete e.button, delete e.id, delete e.container, this.flashExec("FilePicker", "init", e);
      }, destroy: function destroy() {
        this.flashExec("FilePicker", "destroy");
      } });
  }), b("runtime/flash/image", ["runtime/flash/runtime"], function (a) {
    return a.register("Image", { loadFromBlob: function loadFromBlob(a) {
        var b = this.owner;b.info() && this.flashExec("Image", "info", b.info()), b.meta() && this.flashExec("Image", "meta", b.meta()), this.flashExec("Image", "loadFromBlob", a.uid);
      } });
  }), b("runtime/flash/transport", ["base", "runtime/flash/runtime", "runtime/client"], function (b, c, d) {
    var e = b.$;return c.register("Transport", { init: function init() {
        this._status = 0, this._response = null, this._responseJson = null;
      }, send: function send() {
        var a,
            b = this.owner,
            c = this.options,
            d = this._initAjax(),
            f = b._blob,
            g = c.server;d.connectRuntime(f.ruid), c.sendAsBinary ? (g += (/\?/.test(g) ? "&" : "?") + e.param(b._formData), a = f.uid) : (e.each(b._formData, function (a, b) {
          d.exec("append", a, b);
        }), d.exec("appendBlob", c.fileVal, f.uid, c.filename || b._formData.name || "")), this._setRequestHeader(d, c.headers), d.exec("send", { method: c.method, url: g, forceURLStream: c.forceURLStream, mimeType: "application/octet-stream" }, a);
      }, getStatus: function getStatus() {
        return this._status;
      }, getResponse: function getResponse() {
        return this._response || "";
      }, getResponseAsJson: function getResponseAsJson() {
        return this._responseJson;
      }, getResponseHeaders: function getResponseHeaders() {
        return {};
      }, abort: function abort() {
        var a = this._xhr;a && (a.exec("abort"), a.destroy(), this._xhr = a = null);
      }, destroy: function destroy() {
        this.abort();
      }, _initAjax: function _initAjax() {
        var b = this,
            c = new d("XMLHttpRequest");return c.on("uploadprogress progress", function (a) {
          var c = a.loaded / a.total;return c = Math.min(1, Math.max(0, c)), b.trigger("progress", c);
        }), c.on("load", function () {
          var d,
              e = c.exec("getStatus"),
              f = !1,
              g = "";return c.off(), b._xhr = null, e >= 200 && 300 > e ? f = !0 : e >= 500 && 600 > e ? (f = !0, g = "server-" + e) : g = "http-" + e, f && (b._response = c.exec("getResponse"), b._response = decodeURIComponent(b._response), d = function d(b) {
            try {
              return a.JSON && a.JSON.parse ? JSON.parse(b) : new Function("return " + b).call();
            } catch (c) {
              return {};
            }
          }, b._responseJson = b._response ? d(b._response) : {}), c.destroy(), c = null, g ? b.trigger("error", g) : b.trigger("load");
        }), c.on("error", function () {
          var a = c.exec("getStatus"),
              d = a ? "http-" + a : "http";c.off(), b._xhr = null, b.trigger("error", d);
        }), b._xhr = c, c;
      }, _setRequestHeader: function _setRequestHeader(a, b) {
        e.each(b, function (b, c) {
          a.exec("setRequestHeader", b, c);
        });
      } });
  }), b("runtime/flash/blob", ["runtime/flash/runtime", "lib/blob"], function (a, b) {
    return a.register("Blob", { slice: function slice(a, c) {
        var d = this.flashExec("Blob", "slice", a, c);return new b(this.getRuid(), d);
      } });
  }), b("runtime/flash/md5", ["runtime/flash/runtime"], function (a) {
    return a.register("Md5", { init: function init() {}, loadFromBlob: function loadFromBlob(a) {
        return this.flashExec("Md5", "loadFromBlob", a.uid);
      } });
  }), b("preset/all", ["base", "widgets/filednd", "widgets/filepaste", "widgets/filepicker", "widgets/image", "widgets/queue", "widgets/runtime", "widgets/upload", "widgets/validator", "widgets/md5", "runtime/html5/blob", "runtime/html5/dnd", "runtime/html5/filepaste", "runtime/html5/filepicker", "runtime/html5/imagemeta/exif", "runtime/html5/androidpatch", "runtime/html5/image", "runtime/html5/transport", "runtime/html5/md5", "runtime/flash/filepicker", "runtime/flash/image", "runtime/flash/transport", "runtime/flash/blob", "runtime/flash/md5"], function (a) {
    return a;
  }), b("widgets/log", ["base", "uploader", "widgets/widget"], function (a, b) {
    function c(a) {
      var b = e.extend({}, d, a),
          c = f.replace(/^(.*)\?/, "$1" + e.param(b)),
          g = new Image();g.src = c;
    }var d,
        e = a.$,
        f = " http://static.tieba.baidu.com/tb/pms/img/st.gif??",
        g = (location.hostname || location.host || "protected").toLowerCase(),
        h = g && /baidu/i.exec(g);if (h) return d = { dv: 3, master: "webuploader", online: /test/.exec(g) ? 0 : 1, module: "", product: g, type: 0 }, b.register({ name: "log", init: function init() {
        var a = this.owner,
            b = 0,
            d = 0;a.on("error", function (a) {
          c({ type: 2, c_error_code: a });
        }).on("uploadError", function (a, b) {
          c({ type: 2, c_error_code: "UPLOAD_ERROR", c_reason: "" + b });
        }).on("uploadComplete", function (a) {
          b++, d += a.size;
        }).on("uploadFinished", function () {
          c({ c_count: b, c_size: d }), b = d = 0;
        }), c({ c_usage: 1 });
      } });
  }), b("webuploader", ["preset/all", "widgets/log"], function (a) {
    return a;
  }), c("webuploader");
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)(module)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var tools = {
    createAttribute: function createAttribute(attr) {
        return {
            id: tools.idGeter(attr.attr_id, attr.attr_value_id),
            key: attr.attr_id,
            keyalias: attr.attr_name,
            value: attr.attr_value_id,
            valuealias: attr.attr_value,
            disable: false,
            selected: false,
            friends: {}
        };
    },
    idGeter: function idGeter(key, value) {
        return key + '-' + value;
    },
    inArray: function inArray(array, judger) {
        var res = null;
        $.each(array, function (i, item) {
            if (judger(item)) {
                res = item;
                return false;
            }
        });
        return res;
    }
};

function Hash() {
    this.data = {};
    this.minPrice = 0;
    this.maxPrice = 0;
    this.minSharedPrice = 0;
    this.maxSharedPrice = 0;
    this.minMarketPrice = 0;
    this.maxMarketPrice = 0;
    this.minCut = 0;
    this.maxCut = 0;
    this.totalStock = 0;
    this.sourceData = {};
    this.skus = {};
    this.stocks = {};
}

Hash.prototype = {
    initData: function initData(data) {
        var that = this;
        that.sourceData = data;

        if (data.length === 0) {
            that.minPrice = 0;
            that.maxPrice = 0;
            that.minAppPrice = 0;
            that.maxAppPrice = 0;
            that.minMarketPrice = 0;
            that.maxMarketPrice = 0;
            that.minCut = 0;
            that.maxCut = 0;
            that.Shared = 0;
            that.maxSharedPrice = 0;
        } else {
            that.minPrice = data[0].price;
            that.maxPrice = data[0].price;
            that.minAppPrice = data[0].appPrice;
            that.maxAppPrice = data[0].appPrice;
            that.minMarketPrice = data[0].marketPrice;
            that.maxMarketPrice = data[0].marketPrice;
            that.minCut = data[0].cut;
            that.maxCut = data[0].cut;
            that.minSharedPrice = data[0].share_price;
            that.maxSharedPrice = data[0].share_price;
        }

        $.each(data, function (i, row) {
            that.minPrice = Math.min(that.minPrice, row.price);
            that.maxPrice = Math.max(that.maxPrice, row.price);
            that.minAppPrice = Math.min(that.minAppPrice, row.appPrice);
            that.maxAppPrice = Math.max(that.maxAppPrice, row.appPrice);
            that.minSharedPrice = Math.min(that.minSharedPrice, row.share_price);
            that.maxSharedPrice = Math.max(that.maxSharedPrice, row.share_price);

            that.minMarketPrice = Math.min(that.minMarketPrice, row.marketPrice);
            that.maxMarketPrice = Math.max(that.maxMarketPrice, row.marketPrice);
            that.minCut = Math.min(that.minCut, row.cut);
            that.maxCut = Math.max(that.maxCut, row.cut);
            that.totalStock += row.number;
            var spec_id = row.spec_id,
                _key = $.map(row.attributes, function (o) {
                return '[' + o.attr_id + '-' + o.attr_value_id + ']';
            }).join('');
            that.stocks[_key] = row;
            $.each(row.attributes, function (i, attr) {
                var id = tools.idGeter(attr.attr_id, attr.attr_value_id);
                var attrObject = null;
                if (that.has(id)) {
                    attrObject = that.get(id);
                } else {
                    attrObject = tools.createAttribute(attr);
                    attrObject.index = i;
                    that.data[id] = attrObject;
                }
                if (attr.attr_id === spec_id) {
                    // attrObject.imgs = row.imgs;
                    attrObject.imgs = row.images;
                }
                that.addAttrFriends(attrObject, row.attributes);
            });
            that.skus[row.sku_id] = row;
        });
    },
    reloadStock: function reloadStock(data) {
        var that = this;
        $.each(data, function (sku_id, number) {
            that.skus[sku_id].number = number;
        });
    },
    addAttrFriends: function addAttrFriends(attrObject, friends) {
        var myFriends = attrObject.friends;
        $.each(friends, function (i, attr) {
            var id = tools.idGeter(attr.attr_id, attr.attr_value_id);
            // 去除自己
            if (myFriends[id] === undefined && attr.attr_id !== attrObject.key) {
                myFriends[id] = 1;
            }
        });
    },
    get: function get(id) {
        return this.data[id];
    },
    clear: function clear() {
        this.data = {};
        this.minPrice = 0;
        this.maxPrice = 0;
        this.minAppPrice = 0;
        this.maxAppPrice = 0;
        this.minMarketPrice = 0;
        this.maxMarketPrice = 0;
        this.minCut = 0;
        this.maxCut = 0;
        this.totalStock = 0;
        this.sourceData = {};
        this.skus = {};
    },
    has: function has(id) {
        return this.data[id] !== undefined;
    },
    toGroups: function toGroups() {
        var array = [];
        $.each(this.data, function (id, attr) {
            var group = tools.inArray(array, function (item) {
                return attr.key === item.key;
            });
            if (group === null) {
                array.push({
                    key: attr.key,
                    keyalias: attr.keyalias,
                    list: [attr]
                });
            } else {
                group.list.push(attr);
            }
        });
        return array;
    },
    replaceAttrs: function replaceAttrs(groups) {
        var that = this;
        $.each(groups, function (i, group) {
            $.each(group.list, function (j, attr) {
                that.data[attr.id] = attr;
            });
        });
    },
    freeAll: function freeAll() {
        $.each(this.data, function (id, attr) {
            attr.disable = false;
        });
    },
    disable: function disable(list) {
        $.each(list, function (i, attr) {
            if (attr.selected === false) {
                attr.disable = true;
            }
        });
    },
    querySourceData: function querySourceData(key) {
        key = key.join('').replace(/\\/g, '');
        return this.stocks[key];
    },
    getPriceRange: function getPriceRange() {
        if (this.minPrice === this.maxPrice) {
            return this.minPrice;
        } else {
            return this.minPrice + '－' + this.maxPrice;
        }
    },
    getAppPriceRange: function getAppPriceRange() {
        if (this.minAppPrice === this.maxAppPrice) {
            return this.minAppPrice;
        } else {
            return this.minAppPrice + '－' + this.maxAppPrice;
        }
    },
    getMarketPriceRange: function getMarketPriceRange() {
        if (this.minMarketPrice === this.maxMarketPrice) {
            return this.minMarketPrice;
        } else {
            return this.minMarketPrice + '－' + this.maxMarketPrice;
        }
    },
    getSharedPriceRange: function getSharedPriceRange() {
        if (this.minSharedPrice === this.maxSharedPrice) {
            return this.minSharedPrice;
        } else {
            return this.minSharedPrice + '－' + this.maxSharedPrice;
        }
    },
    getCutRange: function getCutRange() {
        if (this.minCut === this.maxCut) {
            return this.minCut;
        } else {
            return this.minCut + '－' + this.maxCut;
        }
    },
    getTotalStock: function getTotalStock() {
        return this.totalStock;
    }
};

exports.default = new Hash();

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(41)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(20);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(47);
var hide = __webpack_require__(10);
var Iterators = __webpack_require__(25);
var $iterCreate = __webpack_require__(97);
var setToStringTag = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(103);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(46);
var hiddenKeys = __webpack_require__(24).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(11);
var arrayIndexOf = __webpack_require__(91)(false);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(10);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    return function (avalon) {

        var tpl = ['<div class="dialog-blank" ms-on-tap="bgClick" ms-visible="isShowingDialog">', '<div class="dialog-blank-content" ms-on-tap="contentClick" ms-attr-style="cssLabel">', '<div>[[content | html]]</div>', '</div>', '</div>'].join('');

        avalon.component('ms:dialog', {
            $template: tpl,
            // $replace: 1, //是否替换容器
            content: '',
            css: {},
            cssLabel: '',
            isShowingDialog: false,
            $ready: function $ready(vm, elem, vms) {
                var csss = [];
                for (var i in vm.css) {
                    if (vm.css.hasOwnProperty(i)) {
                        csss.push(i + ':' + vm.css[i]);
                    }
                }
                vm.cssLabel = csss.join(';');

                vm.bgClick = function () {
                    vm['hiddenCallback'] && vm['hiddenCallback']();
                    vm.isShowingDialog = false;
                };

                vm.contentClick = function ($event) {
                    $event.stopPropagation();
                };

                vm.$watch('isShowingDialog', function (v) {
                    var content = elem.querySelector('[slot]');
                    if (v) {
                        content.style.display = 'block';
                    } else {
                        content.style.display = 'none';
                    }
                });

                vm.onInit(vm);

                // 这里加上补充style的原因是app里渲染不出 ms-attr-style="cssLabel" 下来再研究
                setTimeout(function () {
                    if (vm.cssLabel) {
                        var dialogContent = $('.dialog-blank-content');
                        if (dialogContent.length) {
                            var style = dialogContent.attr('stype');
                            if (!style) {
                                dialogContent.attr('style', vm.cssLabel);
                            }
                        }
                    }
                }, 500);
            },
            bgClick: avalon.noop,
            contentClick: avalon.noop,
            onInit: avalon.noop
        });
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*
 * Lazy Load - jQuery plugin for lazy loading images
 *
 * Copyright (c) 2007-2013 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   http://www.appelsiini.net/projects/lazyload
 *
 * Version:  1.9.3
 *
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {

	return {
		init: function init($, window, document, undefined) {

			var $window = $(window);

			$.fn.lazyload = function (options) {
				var elements = this;
				var $container;
				var settings = {
					threshold: 0,
					failure_limit: 0,
					event: "scroll",
					effect: "show",
					container: window,
					data_attribute: "original",
					skip_invisible: true,
					appear: null,
					load: null,
					placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
				};

				function update() {
					var counter = 0;

					elements.each(function () {
						var $this = $(this);
						if (settings.skip_invisible && !$this.is(":visible")) {
							return;
						}
						if ($.abovethetop(this, settings) || $.leftofbegin(this, settings)) {
							/* Nothing. */
						} else if (!$.belowthefold(this, settings) && !$.rightoffold(this, settings)) {
							$this.trigger("appear");
							/* if we found an image we'll load, reset the counter */
							counter = 0;
						} else {
							if (++counter > settings.failure_limit) {
								return false;
							}
						}
					});
				}

				if (options) {
					/* Maintain BC for a couple of versions. */
					if (undefined !== options.failurelimit) {
						options.failure_limit = options.failurelimit;
						delete options.failurelimit;
					}
					if (undefined !== options.effectspeed) {
						options.effect_speed = options.effectspeed;
						delete options.effectspeed;
					}

					$.extend(settings, options);
				}

				/* Cache container as jQuery as object. */
				$container = settings.container === undefined || settings.container === window ? $window : $(settings.container);

				/* Fire one scroll event per scroll. Not one scroll event per image. */
				if (0 === settings.event.indexOf("scroll")) {
					$container.bind(settings.event, function () {
						return update();
					});
				}

				this.each(function () {
					var self = this;
					var $self = $(self);

					self.loaded = false;

					/* If no src attribute given use data:uri. */
					if ($self.attr("src") === undefined || $self.attr("src") === false) {
						if ($self.is("img")) {
							$self.attr("src", settings.placeholder);
						}
					}

					/* When appear is triggered load original image. */
					$self.one("appear", function () {
						if (!this.loaded) {
							if (settings.appear) {
								var elements_left = elements.length;
								settings.appear.call(self, elements_left, settings);
							}
							$("<img />").bind("load", function () {

								var original = $self.attr("data-" + settings.data_attribute);
								$self.hide();
								if ($self.is("img")) {
									$self.attr("src", original);
								} else {
									$self.css("background-image", "url('" + original + "')");
								}
								$self[settings.effect](settings.effect_speed);

								self.loaded = true;

								/* Remove image from array so it is not looped next time. */
								var temp = $.grep(elements, function (element) {
									return !element.loaded;
								});
								elements = $(temp);

								if (settings.load) {
									var elements_left = elements.length;
									settings.load.call(self, elements_left, settings);
								}
							}).attr("src", $self.attr("data-" + settings.data_attribute));
						}
					});

					/* When wanted event is triggered load original image */
					/* by triggering appear.                              */
					if (0 !== settings.event.indexOf("scroll")) {
						$self.bind(settings.event, function () {
							if (!self.loaded) {
								$self.trigger("appear");
							}
						});
					}
				});

				/* Check if something appears when window is resized. */
				$window.bind("resize", function () {
					update();
				});

				/* With IOS5 force loading images when navigating with back button. */
				/* Non optimal workaround. */
				if (/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)) {
					$window.bind("pageshow", function (event) {
						if (event.originalEvent && event.originalEvent.persisted) {
							elements.each(function () {
								$(this).trigger("appear");
							});
						}
					});
				}

				/* Force initial check if images should appear. */
				$(document).ready(function () {
					update();
				});

				return this;
			};

			/* Convenience methods in jQuery namespace.           */
			/* Use as  $.belowthefold(element, {threshold : 100, container : window}) */

			$.belowthefold = function (element, settings) {
				var fold;

				if (settings.container === undefined || settings.container === window) {
					fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
				} else {
					fold = $(settings.container).offset().top + $(settings.container).height();
				}

				return fold <= $(element).offset().top - settings.threshold;
			};

			$.rightoffold = function (element, settings) {
				var fold;

				if (settings.container === undefined || settings.container === window) {
					fold = $window.width() + $window.scrollLeft();
				} else {
					fold = $(settings.container).offset().left + $(settings.container).width();
				}

				return fold <= $(element).offset().left - settings.threshold;
			};

			$.abovethetop = function (element, settings) {
				var fold;

				if (settings.container === undefined || settings.container === window) {
					fold = $window.scrollTop();
				} else {
					fold = $(settings.container).offset().top;
				}

				return fold >= $(element).offset().top + settings.threshold + $(element).height();
			};

			$.leftofbegin = function (element, settings) {
				var fold;

				if (settings.container === undefined || settings.container === window) {
					fold = $window.scrollLeft();
				} else {
					fold = $(settings.container).offset().left;
				}

				return fold >= $(element).offset().left + settings.threshold + $(element).width();
			};

			$.inviewport = function (element, settings) {
				return !$.rightoffold(element, settings) && !$.leftofbegin(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
			};

			/* Custom selectors for your convenience.   */
			/* Use as $("img:below-the-fold").something() or */
			/* $("img").filter(":below-the-fold").something() which is faster */

			$.extend($.expr[":"], {
				"below-the-fold": function belowTheFold(a) {
					return $.belowthefold(a, { threshold: 0 });
				},
				"above-the-top": function aboveTheTop(a) {
					return !$.belowthefold(a, { threshold: 0 });
				},
				"right-of-screen": function rightOfScreen(a) {
					return $.rightoffold(a, { threshold: 0 });
				},
				"left-of-screen": function leftOfScreen(a) {
					return !$.rightoffold(a, { threshold: 0 });
				},
				"in-viewport": function inViewport(a) {
					return $.inviewport(a, { threshold: 0 });
				},
				/* Maintain BC for couple of versions. */
				"above-the-fold": function aboveTheFold(a) {
					return !$.belowthefold(a, { threshold: 0 });
				},
				"right-of-fold": function rightOfFold(a) {
					return $.rightoffold(a, { threshold: 0 });
				},
				"left-of-fold": function leftOfFold(a) {
					return !$.rightoffold(a, { threshold: 0 });
				}
			});
		}
	};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = function ($) {
  // When called on a container with a selector, fetches the href with
  // ajax into the container or with the data-pjax attribute on the link
  // itself.
  //
  // Tries to make sure the back button and ctrl+click work the way
  // you'd expect.
  //
  // Exported as $.fn.pjax
  //
  // Accepts a jQuery ajax options object that may include these
  // pjax specific options:
  //
  //
  // container - String selector for the element where to place the response body.
  //      push - Whether to pushState the URL. Defaults to true (of course).
  //   replace - Want to use replaceState instead? That's cool.
  //
  // For convenience the second parameter can be either the container or
  // the options object.
  //
  // Returns the jQuery object
  function fnPjax(selector, container, options) {
    options = optionsFor(container, options);
    return this.on('click.pjax', selector, function (event) {
      var opts = options;
      if (!opts.container) {
        opts = $.extend({}, options);
        opts.container = $(this).attr('data-pjax');
      }
      handleClick(event, opts);
    });
  }

  // Public: pjax on click handler
  //
  // Exported as $.pjax.click.
  //
  // event   - "click" jQuery.Event
  // options - pjax options
  //
  // Examples
  //
  //   $(document).on('click', 'a', $.pjax.click)
  //   // is the same as
  //   $(document).pjax('a')
  //
  // Returns nothing.
  function handleClick(event, container, options) {
    options = optionsFor(container, options);

    var link = event.currentTarget;
    var $link = $(link);

    if (link.tagName.toUpperCase() !== 'A') throw "$.fn.pjax or $.pjax.click requires an anchor element";

    // Middle click, cmd click, and ctrl click should open
    // links in a new tab as normal.
    if (event.which > 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // Ignore cross origin links
    if (location.protocol !== link.protocol || location.hostname !== link.hostname) return;

    // Ignore case when a hash is being tacked on the current URL
    if (link.href.indexOf('#') > -1 && stripHash(link) == stripHash(location)) return;

    // Ignore event with default prevented
    if (event.isDefaultPrevented()) return;

    var defaults = {
      url: link.href,
      container: $link.attr('data-pjax'),
      target: link
    };

    var opts = $.extend({}, defaults, options);
    var clickEvent = $.Event('pjax:click');
    $link.trigger(clickEvent, [opts]);

    if (!clickEvent.isDefaultPrevented()) {
      pjax(opts);
      event.preventDefault();
      $link.trigger('pjax:clicked', [opts]);
    }
  }

  // Public: pjax on form submit handler
  //
  // Exported as $.pjax.submit
  //
  // event   - "click" jQuery.Event
  // options - pjax options
  //
  // Examples
  //
  //  $(document).on('submit', 'form', function(event) {
  //    $.pjax.submit(event, '[data-pjax-container]')
  //  })
  //
  // Returns nothing.
  function handleSubmit(event, container, options) {
    options = optionsFor(container, options);

    var form = event.currentTarget;
    var $form = $(form);

    if (form.tagName.toUpperCase() !== 'FORM') throw "$.pjax.submit requires a form element";

    var defaults = {
      type: ($form.attr('method') || 'GET').toUpperCase(),
      url: $form.attr('action'),
      container: $form.attr('data-pjax'),
      target: form
    };

    if (defaults.type !== 'GET' && window.FormData !== undefined) {
      defaults.data = new FormData(form);
      defaults.processData = false;
      defaults.contentType = false;
    } else {
      // Can't handle file uploads, exit
      if ($form.find(':file').length) {
        return;
      }

      // Fallback to manually serializing the fields
      defaults.data = $form.serializeArray();
    }

    pjax($.extend({}, defaults, options));

    event.preventDefault();
  }

  // Loads a URL with ajax, puts the response body inside a container,
  // then pushState()'s the loaded URL.
  //
  // Works just like $.ajax in that it accepts a jQuery ajax
  // settings object (with keys like url, type, data, etc).
  //
  // Accepts these extra keys:
  //
  // container - String selector for where to stick the response body.
  //      push - Whether to pushState the URL. Defaults to true (of course).
  //   replace - Want to use replaceState instead? That's cool.
  //
  // Use it just like $.ajax:
  //
  //   var xhr = $.pjax({ url: this.href, container: '#main' })
  //   console.log( xhr.readyState )
  //
  // Returns whatever $.ajax returns.
  function pjax(options) {
    options = $.extend(true, {}, $.ajaxSettings, pjax.defaults, options);

    if ($.isFunction(options.url)) {
      options.url = options.url();
    }

    var hash = parseURL(options.url).hash;

    var containerType = $.type(options.container);
    if (containerType !== 'string') {
      throw "expected string value for 'container' option; got " + containerType;
    }
    var context = options.context = $(options.container);
    if (!context.length) {
      throw "the container selector '" + options.container + "' did not match anything";
    }

    // We want the browser to maintain two separate internal caches: one
    // for pjax'd partial page loads and one for normal page loads.
    // Without adding this secret parameter, some browsers will often
    // confuse the two.
    if (!options.data) options.data = {};
    if ($.isArray(options.data)) {
      options.data.push({ name: '_pjax', value: options.container });
    } else {
      options.data._pjax = options.container;
    }

    function fire(type, args, props) {
      if (!props) props = {};
      props.relatedTarget = options.target;
      var event = $.Event(type, props);
      context.trigger(event, args);
      return !event.isDefaultPrevented();
    }

    var timeoutTimer;

    options.beforeSend = function (xhr, settings) {
      // No timeout for non-GET requests
      // Its not safe to request the resource again with a fallback method.
      if (settings.type !== 'GET') {
        settings.timeout = 0;
      }

      xhr.setRequestHeader('X-PJAX', 'true');
      xhr.setRequestHeader('X-PJAX-Container', options.container);

      if (!fire('pjax:beforeSend', [xhr, settings])) return false;

      if (settings.timeout > 0) {
        timeoutTimer = setTimeout(function () {
          if (fire('pjax:timeout', [xhr, options])) xhr.abort('timeout');
        }, settings.timeout);

        // Clear timeout setting so jquerys internal timeout isn't invoked
        settings.timeout = 0;
      }

      var url = parseURL(settings.url);
      if (hash) url.hash = hash;
      options.requestUrl = stripInternalParams(url);
    };

    options.complete = function (xhr, textStatus) {
      if (timeoutTimer) clearTimeout(timeoutTimer);

      fire('pjax:complete', [xhr, textStatus, options]);

      fire('pjax:end', [xhr, options]);
    };

    options.error = function (xhr, textStatus, errorThrown) {
      var container = extractContainer("", xhr, options);

      var allowed = fire('pjax:error', [xhr, textStatus, errorThrown, options]);
      if (options.type == 'GET' && textStatus !== 'abort' && allowed) {
        locationReplace(container.url);
      }
    };

    options.success = function (data, status, xhr) {
      var previousState = pjax.state;

      // If $.pjax.defaults.version is a function, invoke it first.
      // Otherwise it can be a static string.
      var currentVersion = typeof $.pjax.defaults.version === 'function' ? $.pjax.defaults.version() : $.pjax.defaults.version;

      var latestVersion = xhr.getResponseHeader('X-PJAX-Version');

      var container = extractContainer(data, xhr, options);

      var url = parseURL(container.url);
      if (hash) {
        url.hash = hash;
        container.url = url.href;
      }

      // If there is a layout version mismatch, hard load the new url
      if (currentVersion && latestVersion && currentVersion !== latestVersion) {
        locationReplace(container.url);
        return;
      }

      // If the new response is missing a body, hard load the page
      if (!container.contents) {
        locationReplace(container.url);
        return;
      }

      pjax.state = {
        id: options.id || uniqueId(),
        url: container.url,
        title: container.title,
        container: options.container,
        fragment: options.fragment,
        timeout: options.timeout
      };

      if (options.push || options.replace) {
        window.history.replaceState(pjax.state, container.title, container.url);
      }

      // Only blur the focus if the focused element is within the container.
      var blurFocus = $.contains(context, document.activeElement);

      // Clear out any focused controls before inserting new page contents.
      if (blurFocus) {
        try {
          document.activeElement.blur();
        } catch (e) {/* ignore */}
      }

      if (container.title) document.title = container.title;

      fire('pjax:beforeReplace', [container.contents, options], {
        state: pjax.state,
        previousState: previousState
      });
      context.html(container.contents);

      // FF bug: Won't autofocus fields that are inserted via JS.
      // This behavior is incorrect. So if theres no current focus, autofocus
      // the last field.
      //
      // http://www.w3.org/html/wg/drafts/html/master/forms.html
      var autofocusEl = context.find('input[autofocus], textarea[autofocus]').last()[0];
      if (autofocusEl && document.activeElement !== autofocusEl) {
        autofocusEl.focus();
      }

      executeScriptTags(container.scripts);

      var scrollTo = options.scrollTo;

      // Ensure browser scrolls to the element referenced by the URL anchor
      if (hash) {
        var name = decodeURIComponent(hash.slice(1));
        var target = document.getElementById(name) || document.getElementsByName(name)[0];
        if (target) scrollTo = $(target).offset().top;
      }

      if (typeof scrollTo == 'number') $(window).scrollTop(scrollTo);

      fire('pjax:success', [data, status, xhr, options]);
    };

    // Initialize pjax.state for the initial page load. Assume we're
    // using the container and options of the link we're loading for the
    // back button to the initial page. This ensures good back button
    // behavior.
    if (!pjax.state) {
      pjax.state = {
        id: uniqueId(),
        url: window.location.href,
        title: document.title,
        container: options.container,
        fragment: options.fragment,
        timeout: options.timeout
      };
      window.history.replaceState(pjax.state, document.title);
    }

    // Cancel the current request if we're already pjaxing
    abortXHR(pjax.xhr);

    pjax.options = options;
    var xhr = pjax.xhr = $.ajax(options);

    if (xhr.readyState > 0) {
      if (options.push && !options.replace) {
        // Cache current container element before replacing it
        cachePush(pjax.state.id, [options.container, cloneContents(context)]);

        window.history.pushState(null, "", options.requestUrl);
      }

      fire('pjax:start', [xhr, options]);
      fire('pjax:send', [xhr, options]);
    }

    return pjax.xhr;
  }

  // Public: Reload current page with pjax.
  //
  // Returns whatever $.pjax returns.
  function pjaxReload(container, options) {
    var defaults = {
      url: window.location.href,
      push: false,
      replace: true,
      scrollTo: false
    };

    return pjax($.extend(defaults, optionsFor(container, options)));
  }

  // Internal: Hard replace current state with url.
  //
  // Work for around WebKit
  //   https://bugs.webkit.org/show_bug.cgi?id=93506
  //
  // Returns nothing.
  function locationReplace(url) {
    window.history.replaceState(null, "", pjax.state.url);
    window.location.replace(url);
  }

  var initialPop = true;
  var initialURL = window.location.href;
  var initialState = window.history.state;

  // Initialize $.pjax.state if possible
  // Happens when reloading a page and coming forward from a different
  // session history.
  if (initialState && initialState.container) {
    pjax.state = initialState;
  }

  // Non-webkit browsers don't fire an initial popstate event
  if ('state' in window.history) {
    initialPop = false;
  }

  // popstate handler takes care of the back and forward buttons
  //
  // You probably shouldn't use pjax on pages with other pushState
  // stuff yet.
  function onPjaxPopstate(event) {

    // Hitting back or forward should override any pending PJAX request.
    if (!initialPop) {
      abortXHR(pjax.xhr);
    }

    var previousState = pjax.state;
    var state = event.state;
    var direction;

    if (state && state.container) {
      // When coming forward from a separate history session, will get an
      // initial pop with a state we are already at. Skip reloading the current
      // page.
      if (initialPop && initialURL == state.url) return;

      if (previousState) {
        // If popping back to the same state, just skip.
        // Could be clicking back from hashchange rather than a pushState.
        if (previousState.id === state.id) return;

        // Since state IDs always increase, we can deduce the navigation direction
        direction = previousState.id < state.id ? 'forward' : 'back';
      }

      var cache = cacheMapping[state.id] || [];
      var containerSelector = cache[0] || state.container;
      var container = $(containerSelector),
          contents = cache[1];

      if (container.length) {
        if (previousState) {
          // Cache current container before replacement and inform the
          // cache which direction the history shifted.
          cachePop(direction, previousState.id, [containerSelector, cloneContents(container)]);
        }

        var popstateEvent = $.Event('pjax:popstate', {
          state: state,
          direction: direction
        });
        container.trigger(popstateEvent);

        var options = {
          id: state.id,
          url: state.url,
          container: containerSelector,
          push: false,
          fragment: state.fragment,
          timeout: state.timeout,
          scrollTo: false
        };

        if (contents) {
          container.trigger('pjax:start', [null, options]);

          pjax.state = state;
          if (state.title) document.title = state.title;
          var beforeReplaceEvent = $.Event('pjax:beforeReplace', {
            state: state,
            previousState: previousState
          });
          container.trigger(beforeReplaceEvent, [contents, options]);
          container.html(contents);

          container.trigger('pjax:end', [null, options]);
        } else {
          pjax(options);
        }

        // Force reflow/relayout before the browser tries to restore the
        // scroll position.
        container[0].offsetHeight; // eslint-disable-line no-unused-expressions
      } else {
        locationReplace(location.href);
      }
    }
    initialPop = false;
  }

  // Fallback version of main pjax function for browsers that don't
  // support pushState.
  //
  // Returns nothing since it retriggers a hard form submission.
  function fallbackPjax(options) {
    var url = $.isFunction(options.url) ? options.url() : options.url,
        method = options.type ? options.type.toUpperCase() : 'GET';

    var form = $('<form>', {
      method: method === 'GET' ? 'GET' : 'POST',
      action: url,
      style: 'display:none'
    });

    if (method !== 'GET' && method !== 'POST') {
      form.append($('<input>', {
        type: 'hidden',
        name: '_method',
        value: method.toLowerCase()
      }));
    }

    var data = options.data;
    if (typeof data === 'string') {
      $.each(data.split('&'), function (index, value) {
        var pair = value.split('=');
        form.append($('<input>', { type: 'hidden', name: pair[0], value: pair[1] }));
      });
    } else if ($.isArray(data)) {
      $.each(data, function (index, value) {
        form.append($('<input>', { type: 'hidden', name: value.name, value: value.value }));
      });
    } else if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
      var key;
      for (key in data) {
        form.append($('<input>', { type: 'hidden', name: key, value: data[key] }));
      }
    }

    $(document.body).append(form);
    form.submit();
  }

  // Internal: Abort an XmlHttpRequest if it hasn't been completed,
  // also removing its event handlers.
  function abortXHR(xhr) {
    if (xhr && xhr.readyState < 4) {
      xhr.onreadystatechange = $.noop;
      xhr.abort();
    }
  }

  // Internal: Generate unique id for state object.
  //
  // Use a timestamp instead of a counter since ids should still be
  // unique across page loads.
  //
  // Returns Number.
  function uniqueId() {
    return new Date().getTime();
  }

  function cloneContents(container) {
    var cloned = container.clone();
    // Unmark script tags as already being eval'd so they can get executed again
    // when restored from cache. HAXX: Uses jQuery internal method.
    cloned.find('script').each(function () {
      if (!this.src) $._data(this, 'globalEval', false);
    });
    return cloned.contents();
  }

  // Internal: Strip internal query params from parsed URL.
  //
  // Returns sanitized url.href String.
  function stripInternalParams(url) {
    url.search = url.search.replace(/([?&])(_pjax|_)=[^&]*/g, '').replace(/^&/, '');
    return url.href.replace(/\?($|#)/, '$1');
  }

  // Internal: Parse URL components and returns a Locationish object.
  //
  // url - String URL
  //
  // Returns HTMLAnchorElement that acts like Location.
  function parseURL(url) {
    var a = document.createElement('a');
    a.href = url;
    return a;
  }

  // Internal: Return the `href` component of given URL object with the hash
  // portion removed.
  //
  // location - Location or HTMLAnchorElement
  //
  // Returns String
  function stripHash(location) {
    return location.href.replace(/#.*/, '');
  }

  // Internal: Build options Object for arguments.
  //
  // For convenience the first parameter can be either the container or
  // the options object.
  //
  // Examples
  //
  //   optionsFor('#container')
  //   // => {container: '#container'}
  //
  //   optionsFor('#container', {push: true})
  //   // => {container: '#container', push: true}
  //
  //   optionsFor({container: '#container', push: true})
  //   // => {container: '#container', push: true}
  //
  // Returns options Object.
  function optionsFor(container, options) {
    if (container && options) {
      options = $.extend({}, options);
      options.container = container;
      return options;
    } else if ($.isPlainObject(container)) {
      return container;
    } else {
      return { container: container };
    }
  }

  // Internal: Filter and find all elements matching the selector.
  //
  // Where $.fn.find only matches descendants, findAll will test all the
  // top level elements in the jQuery object as well.
  //
  // elems    - jQuery object of Elements
  // selector - String selector to match
  //
  // Returns a jQuery object.
  function findAll(elems, selector) {
    return elems.filter(selector).add(elems.find(selector));
  }

  function parseHTML(html) {
    return $.parseHTML(html, document, true);
  }

  // Internal: Extracts container and metadata from response.
  //
  // 1. Extracts X-PJAX-URL header if set
  // 2. Extracts inline <title> tags
  // 3. Builds response Element and extracts fragment if set
  //
  // data    - String response data
  // xhr     - XHR response
  // options - pjax options Object
  //
  // Returns an Object with url, title, and contents keys.
  function extractContainer(data, xhr, options) {
    var obj = {},
        fullDocument = /<html/i.test(data);

    // Prefer X-PJAX-URL header if it was set, otherwise fallback to
    // using the original requested url.
    var serverUrl = xhr.getResponseHeader('X-PJAX-URL');
    obj.url = serverUrl ? stripInternalParams(parseURL(serverUrl)) : options.requestUrl;

    var $head, $body;
    // Attempt to parse response html into elements
    if (fullDocument) {
      $body = $(parseHTML(data.match(/<body[^>]*>([\s\S.]*)<\/body>/i)[0]));
      var head = data.match(/<head[^>]*>([\s\S.]*)<\/head>/i);
      $head = head != null ? $(parseHTML(head[0])) : $body;
    } else {
      $head = $body = $(parseHTML(data));
    }

    // If response data is empty, return fast
    if ($body.length === 0) return obj;

    // If there's a <title> tag in the header, use it as
    // the page's title.
    obj.title = findAll($head, 'title').last().text();

    if (options.fragment) {
      var $fragment = $body;
      // If they specified a fragment, look for it in the response
      // and pull it out.
      if (options.fragment !== 'body') {
        $fragment = findAll($fragment, options.fragment).first();
      }

      if ($fragment.length) {
        obj.contents = options.fragment === 'body' ? $fragment : $fragment.contents();

        // If there's no title, look for data-title and title attributes
        // on the fragment
        if (!obj.title) obj.title = $fragment.attr('title') || $fragment.data('title');
      }
    } else if (!fullDocument) {
      obj.contents = $body;
    }

    // Clean up any <title> tags
    if (obj.contents) {
      // Remove any parent title elements
      obj.contents = obj.contents.not(function () {
        return $(this).is('title');
      });

      // Then scrub any titles from their descendants
      obj.contents.find('title').remove();

      // Gather all script[src] elements
      obj.scripts = findAll(obj.contents, 'script[src]').remove();
      obj.contents = obj.contents.not(obj.scripts);
    }

    // Trim any whitespace off the title
    if (obj.title) obj.title = $.trim(obj.title);

    return obj;
  }

  // Load an execute scripts using standard script request.
  //
  // Avoids jQuery's traditional $.getScript which does a XHR request and
  // globalEval.
  //
  // scripts - jQuery object of script Elements
  //
  // Returns nothing.
  function executeScriptTags(scripts) {
    if (!scripts) return;

    var existingScripts = $('script[src]');

    scripts.each(function () {
      var src = this.src;
      var matchedScripts = existingScripts.filter(function () {
        return this.src === src;
      });
      if (matchedScripts.length) return;

      var script = document.createElement('script');
      var type = $(this).attr('type');
      if (type) script.type = type;
      script.src = $(this).attr('src');
      document.head.appendChild(script);
    });
  }

  // Internal: History DOM caching class.
  var cacheMapping = {};
  var cacheForwardStack = [];
  var cacheBackStack = [];

  // Push previous state id and container contents into the history
  // cache. Should be called in conjunction with `pushState` to save the
  // previous container contents.
  //
  // id    - State ID Number
  // value - DOM Element to cache
  //
  // Returns nothing.
  function cachePush(id, value) {
    cacheMapping[id] = value;
    cacheBackStack.push(id);

    // Remove all entries in forward history stack after pushing a new page.
    trimCacheStack(cacheForwardStack, 0);

    // Trim back history stack to max cache length.
    trimCacheStack(cacheBackStack, pjax.defaults.maxCacheLength);
  }

  // Shifts cache from directional history cache. Should be
  // called on `popstate` with the previous state id and container
  // contents.
  //
  // direction - "forward" or "back" String
  // id        - State ID Number
  // value     - DOM Element to cache
  //
  // Returns nothing.
  function cachePop(direction, id, value) {
    var pushStack, popStack;
    cacheMapping[id] = value;

    if (direction === 'forward') {
      pushStack = cacheBackStack;
      popStack = cacheForwardStack;
    } else {
      pushStack = cacheForwardStack;
      popStack = cacheBackStack;
    }

    pushStack.push(id);
    id = popStack.pop();
    if (id) delete cacheMapping[id];

    // Trim whichever stack we just pushed to to max cache length.
    trimCacheStack(pushStack, pjax.defaults.maxCacheLength);
  }

  // Trim a cache stack (either cacheBackStack or cacheForwardStack) to be no
  // longer than the specified length, deleting cached DOM elements as necessary.
  //
  // stack  - Array of state IDs
  // length - Maximum length to trim to
  //
  // Returns nothing.
  function trimCacheStack(stack, length) {
    while (stack.length > length) {
      delete cacheMapping[stack.shift()];
    }
  }

  // Public: Find version identifier for the initial page load.
  //
  // Returns String version or undefined.
  function findVersion() {
    return $('meta').filter(function () {
      var name = $(this).attr('http-equiv');
      return name && name.toUpperCase() === 'X-PJAX-VERSION';
    }).attr('content');
  }

  // Install pjax functions on $.pjax to enable pushState behavior.
  //
  // Does nothing if already enabled.
  //
  // Examples
  //
  //     $.pjax.enable()
  //
  // Returns nothing.
  function enable() {
    $.fn.pjax = fnPjax;
    $.pjax = pjax;
    $.pjax.enable = $.noop;
    $.pjax.disable = disable;
    $.pjax.click = handleClick;
    $.pjax.submit = handleSubmit;
    $.pjax.reload = pjaxReload;
    $.pjax.defaults = {
      timeout: 650,
      push: true,
      replace: false,
      type: 'GET',
      dataType: 'html',
      scrollTo: 0,
      maxCacheLength: 20,
      version: findVersion
    };
    $(window).on('popstate.pjax', onPjaxPopstate);
  }

  // Disable pushState behavior.
  //
  // This is the case when a browser doesn't support pushState. It is
  // sometimes useful to disable pushState for debugging on a modern
  // browser.
  //
  // Examples
  //
  //     $.pjax.disable()
  //
  // Returns nothing.
  function disable() {
    $.fn.pjax = function () {
      return this;
    };
    $.pjax = fallbackPjax;
    $.pjax.enable = enable;
    $.pjax.disable = $.noop;
    $.pjax.click = $.noop;
    $.pjax.submit = $.noop;
    $.pjax.reload = function () {
      window.location.reload();
    };

    $(window).off('popstate.pjax', onPjaxPopstate);
  }

  // Add the state property to jQuery's event object so we can use it in
  // $(window).bind('popstate')
  if ($.event.props && $.inArray('state', $.event.props) < 0) {
    $.event.props.push('state');
  } else if (!('state' in $.Event.prototype)) {
    $.event.addProp('state');
  }

  // Is pjax supported by this browser?
  $.support.pjax = window.history && window.history.pushState && window.history.replaceState &&
  // pushState isn't reliable on iOS until 5.
  !navigator.userAgent.match(/((iPod|iPhone|iPad).+\bOS\s+[1-4]\D|WebApps\/.+CFNetwork)/);

  if ($.support.pjax) {
    enable();
  } else {
    disable();
  }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _detailController = __webpack_require__(66);

var _detailController2 = _interopRequireDefault(_detailController);

var _cartController = __webpack_require__(61);

var _cartController2 = _interopRequireDefault(_cartController);

var _orderConfirmController = __webpack_require__(72);

var _orderConfirmController2 = _interopRequireDefault(_orderConfirmController);

var _orderListController = __webpack_require__(74);

var _orderListController2 = _interopRequireDefault(_orderListController);

var _orderDetailController = __webpack_require__(73);

var _orderDetailController2 = _interopRequireDefault(_orderDetailController);

var _indexController = __webpack_require__(70);

var _indexController2 = _interopRequireDefault(_indexController);

var _errorController = __webpack_require__(67);

var _errorController2 = _interopRequireDefault(_errorController);

var _checkstandController = __webpack_require__(62);

var _checkstandController2 = _interopRequireDefault(_checkstandController);

var _applyRefundController = __webpack_require__(57);

var _applyRefundController2 = _interopRequireDefault(_applyRefundController);

var _applyRefundStatusController = __webpack_require__(59);

var _applyRefundStatusController2 = _interopRequireDefault(_applyRefundStatusController);

var _applyRefundResultController = __webpack_require__(58);

var _applyRefundResultController2 = _interopRequireDefault(_applyRefundResultController);

var _cooperIndexController = __webpack_require__(64);

var _cooperIndexController2 = _interopRequireDefault(_cooperIndexController);

var _cooperCashController = __webpack_require__(63);

var _cooperCashController2 = _interopRequireDefault(_cooperCashController);

var _evaluateController = __webpack_require__(68);

var _evaluateController2 = _interopRequireDefault(_evaluateController);

var _searchController = __webpack_require__(75);

var _searchController2 = _interopRequireDefault(_searchController);

var _groupBuyingJumpController = __webpack_require__(69);

var _groupBuyingJumpController2 = _interopRequireDefault(_groupBuyingJumpController);

var _orderCodSuccessController = __webpack_require__(71);

var _orderCodSuccessController2 = _interopRequireDefault(_orderCodSuccessController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    detailController: _detailController2.default,
    cartController: _cartController2.default,
    orderConfirmController: _orderConfirmController2.default,
    orderListController: _orderListController2.default,
    orderDetailController: _orderDetailController2.default,
    indexController: _indexController2.default,
    errorController: _errorController2.default,
    checkstandController: _checkstandController2.default,
    applyRefundController: _applyRefundController2.default,
    applyRefundStatusController: _applyRefundStatusController2.default,
    applyRefundResultController: _applyRefundResultController2.default,
    cooperIndexController: _cooperIndexController2.default,
    cooperCashController: _cooperCashController2.default,
    evaluateController: _evaluateController2.default,
    searchController: _searchController2.default,
    groupBuyingJumpController: _groupBuyingJumpController2.default,
    orderCodSuccessController: _orderCodSuccessController2.default
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _tool = __webpack_require__(16);

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log(_tool2.default.getHiddenValues('#js-hidden-global'));
var globalHiddenParams = _tool2.default.getHiddenValues('#js-hiddens');

if (globalHiddenParams.skin_on_off === '1') {
    var style = $('<style>');
    var html = [];

    if (globalHiddenParams.skin_config.pc_skin !== '') {
        html.push('.index-list .bg-content {\n                background-image: url(\n                    ' + globalHiddenParams.skin_config.pc_skin + '\n                );\n                background-size: 100% auto!important;\n                background-position: center top!important;\n                background-repeat: no-repeat!important;\n            }\n            .index-list .nav .goods-nav li.active {\n                background: #fff!important;\n            }\n            .index-list .nav .goods-nav li.active a {\n                color: #fb1e46!important;\n            }\n            .index-list .nav .goods-nav li a {\n                font-weight: bold!important;\n                color: #fff!important;\n            }\n            .index-list .filtrate li.active a {\n                color: #fb1e46!important;\n            }\n            .index-list .filtrate li.active .arrows-icon .up {\n                border-bottom: 6px solid #fb1e46!important;\n            }\n            .index-list .filtrate li.active .arrows-icon .down {\n                border-top: 6px solid #fb1e46!important;\n            }\n            ');
    }
    if (globalHiddenParams.skin_config.index_title !== '') {
        var index_title = globalHiddenParams.skin_config.index_title;
        html.push('.index-list .nav .brand {\n                color: #fff!important;\n            }\n            ');
        if (/(.png)$|(.jpg)$|(.jpeg)$|(.gif)$|(.bmp)$/.test(index_title)) {
            html.push('.index-list .nav .brand {\n                    margin: 5px 40px 5px 0!important;\n                    font-size: 0!important;\n                }\n                .index-list .nav .brand span {\n                    background-image: url(\n                        ' + globalHiddenParams.skin_config.index_title + '\n                    )!important;\n                    width: 294px!important;\n                    height: 75px!important;\n                    display: inline-block!important;\n                    background-size: contain!important;\n                    vertical-align: middle!important;\n                    margin-right: 10px!important;\n                    background-repeat: no-repeat!important;\n                    background-position: left center!important;\n                }\n                ');
        }
    }
    if (globalHiddenParams.skin_config.panic_icon !== '') {
        html.push('.index-list .list .item a .seckill {\n                background-image: url(\n                    ' + globalHiddenParams.skin_config.panic_icon + '\n                ) !important;\n                width: 60px !important;\n                height: 60px !important;\n                right: 5px !important;\n                top: 5px !important;\n                font-size: 0 !important;\n                background-size: contain!important;\n                background-position: center!important;\n                background-repeat: no-repeat!important;\n                padding: 0!important;\n            }\n            ');
    }
    if (globalHiddenParams.skin_config.panic_banner !== '') {
        html.push('#goods-desc .right-box .seckill {\n                background-image: url(\n                    ' + globalHiddenParams.skin_config.panic_banner + '\n                ) !important;\n                background-size: cover!important;\n                background-position: center!important;\n                background-repeat: no-repeat!important;\n            }\n            ');
    }
    style.html(html.join(''));
    $(document.head).append(style);
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _groupBuyingJump = __webpack_require__(76);

var _groupBuyingJump2 = _interopRequireDefault(_groupBuyingJump);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { groupBuyingJump: _groupBuyingJump2.default };

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(13);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	var options = {

		required: new RegExp('^.{1,99999999}$'),

		number: new RegExp('^[0-9]+$'),

		zFloat: new RegExp('^\\d+(\\.\\d+)?$'),

		email: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/i,

		date: /^(\d{4})-(\d{2})-(\d{2})$/,

		cellphone: /^\d{1,50}$/,

		mobilephohe: /^0?1[2|3|4|5|6|7|8|9][0-9]\d{8}$/,

		//验证密码
		password: /^\S{6,24}$/,

		//验证金额
		money: /^(?!0+$)(?!0*\.0*$)\d{1,8}(\.\d{1,2})?$/,

		captcha: /^[0-9a-z]{1,10}$/i,

		qq: /^[1-9]\d{3,20}$/,

		//比较两个密码是否相同
		comparePass: function comparePass(newPassword, repeatPassword) {
			return newPassword == repeatPassword;
		},

		numberMin: function numberMin(str, min) {
			return str > min;
		},

		numberMax: function numberMax(str, max) {
			return str < max;
		},

		lengthMax: function lengthMax(str, max) {
			return str.length < max;
		},
		lengthMaxEqual: function lengthMaxEqual(str, max) {
			return str.length <= max;
		},
		lengthMin: function lengthMin(str, min) {
			return str.length > min;
		},
		lengthMinEqual: function lengthMinEqual(str, min) {
			return str.length >= min;
		},
		length: function length(str, val) {
			return str.length === val;
		},
		notZero: function notZero(str) {
			return str !== '0';
		},
		notEqual: function notEqual(str, val) {
			return str !== val;
		}

	};

	function _valid(str, config) {
		for (var name in config) {
			// 当验证的标准是一个方法
			if (typeof options[name] === 'function') {

				if (!options[name](str, config[name].value)) {
					return config[name].error;
				}
			} else {
				// 当验证的标准是一个字符串
				if ((0, _typeof3.default)(options[name]) === 'object') {
					if (!options[name].test(str)) {
						return config[name].error;
					}
				}
			}
		}
		return true;
	}

	return {
		/*
  	@param:data 需要验证的数据源
  	@param:config 验证配置
  */
		valid: function valid(data, configs) {
			var res = true;
			if (typeof data === 'string') {
				res = _valid(data, configs);
				return res;
			} else {
				for (var name in data) {
					res = _valid(data[name], configs[name]);
					if (res !== true) {
						break;
						return res;
					}
				}
			}
			return res;
		}
	};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _pjax = __webpack_require__(50);

var _pjax2 = _interopRequireDefault(_pjax);

var _avalon = __webpack_require__(0);

var _avalon2 = _interopRequireDefault(_avalon);

var _ajax = __webpack_require__(2);

var _ajax2 = _interopRequireDefault(_ajax);

var _toolLoaderPC = __webpack_require__(1);

var _toolLoaderPC2 = _interopRequireDefault(_toolLoaderPC);

var _dialog = __webpack_require__(4);

var _dialog2 = _interopRequireDefault(_dialog);

var _lazyload = __webpack_require__(49);

var _lazyload2 = _interopRequireDefault(_lazyload);

var _dialog3 = __webpack_require__(48);

var _dialog4 = _interopRequireDefault(_dialog3);

var _index = __webpack_require__(53);

var _index2 = _interopRequireDefault(_index);

var _controllers = __webpack_require__(51);

var _controllers2 = _interopRequireDefault(_controllers);

__webpack_require__(52);

__webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if ((0, _jquery2.default)('[ms-controller]').length) {
    _avalon2.default.config({
        interpolate: ['[[', ']]']
    });

    (0, _dialog4.default)(_avalon2.default);
    _lazyload2.default.init(_jquery2.default, window, document);

    var gHiddenValues = _toolLoaderPC2.default.getHiddenValues('#js-hiddens');

    (0, _pjax2.default)(_jquery2.default);

    console.log(gHiddenValues);

    //     var noCache = ['']


    // // 利用地址控制缓存

    //     if(noCache.indexOf('') !== -1){


    //     }

    _jquery2.default.pjax.defaults.maxCacheLength = 0;

    (0, _jquery2.default)(document).pjax('a[data-pjax]', '#pjax-container');

    if (_jquery2.default.pjax.defaults) {
        _jquery2.default.pjax.defaults.timeout = 50000;
        _jquery2.default.pjax.defaults.except = [gHiddenValues.mall];
    }

    (0, _jquery2.default)(document).on('pjax:send', function () {
        _dialog2.default.mask.show();
        _dialog2.default.progress.show(0);
        setTimeout(function () {
            _dialog2.default.progress.show(70);
        }, 0);
    }).on('pjax:beforeReplace', function (event, doms) {
        _jquery2.default.each(doms, function (i, dom) {
            console.log(dom);
            var $dom = (0, _jquery2.default)(dom);
            if ($dom.hasClass('overlay') || $dom.hasClass('mask')) {
                $dom.hide();
            }
        });
        _dialog2.default.mask.show();
        _dialog2.default.progress.show(100);
    }).on('pjax:end', function (xhr, options) {
        // 判断是否未登录
        try {
            var response = JSON.parse(options.responseText);
            if (response.code == 302) {
                return _ajax2.default.jump(response.url);
            }
        } catch (e) {}

        setTimeout(function () {
            _dialog2.default.mask.hide();
            _dialog2.default.progress.hide();
            _dialog2.default.progress.width(0);
            _dialog2.default.clear();
        }, 500);
        (0, _jquery2.default)('#footer-top, #footer-bar').show();
        scan();
    }).on('pjax:error', function () {
        _dialog2.default.mask.hide();
        _dialog2.default.progress.hide();
        _dialog2.default.progress.width(0);
    }).on('pjax:timeout', function () {
        _dialog2.default.mask.hide();
        _dialog2.default.progress.hide();
        _dialog2.default.progress.width(0);
    });

    var scan = function () {
        var lastController = null,
            // 上一个控制器
        pjaxContainer = (0, _jquery2.default)('#pjax-container'); // pjax的容器

        return function () {
            var avalonContainer, controllerId, controller, hiddenValues;

            avalonContainer = pjaxContainer.find('div[ms-controller]');
            if (avalonContainer.length <= 0) {
                avalonContainer = pjaxContainer.find('div[avalonctrl]');
            }

            controllerId = avalonContainer.attr('ms-controller') || avalonContainer.attr('avalonctrl');
            controller = _controllers2.default[controllerId], // avalon控制器
            hiddenValues = _toolLoaderPC2.default.getHiddenValues('#js-local-hiddens');

            // tool.fixTitle(hiddenValues);

            if (controller) {
                lastController && lastController.clear();
                controller.init();
                _avalon2.default.scan(avalonContainer.get(0));
                lastController = controller;
            }
        };
    }();

    (0, _jquery2.default)(function () {
        scan();
        setTimeout(function () {
            (0, _jquery2.default)('#header .pop').css('top', '100%');
        }, 300);
        (0, _jquery2.default)('.mask').fadeOut();
        (0, _jquery2.default)('.overlay').fadeOut();
    });
} else if ((0, _jquery2.default)('[data-vue]').length) {
    var name = (0, _jquery2.default)('[data-vue]').data('vue');
    setTimeout(function () {
        (0, _jquery2.default)('#header .pop').css('top', '100%');
    }, 300);
    (0, _jquery2.default)('.mask').fadeOut();
    (0, _jquery2.default)('.overlay').fadeOut();
    var vm = _index2.default[name]();
}

// 根据支付方式的不同执行不同的操作
window.operateAfterPay = function (response) {
    var data = response.message;

    if (data.channel_id == 0 || data.channel_id == 1 || !data.money) {
        // 金额为0直接支付 或 支付宝直接跳转
        _ajax2.default.jump(data.url);
    } else if (data.channel_id == 4) {
        var queryWechatState = function queryWechatState() {
            _toolLoaderPC2.default.singleWay('query-wechat-state', function (key) {
                kit = this;

                _ajax2.default.get('order/default/check-is-finished.html', {
                    orderId: data.orderId
                }).done(function (resp) {
                    if (resp.type === 'succ') {
                        if (queryWechatStateInterval) {
                            clearTimeout(queryWechatStateInterval);
                        }
                        var dialog = (0, _jquery2.default)('.wx-pay-dialog');
                        if (dialog.length) {
                            dialog.remove();
                            _ajax2.default.pjax('/order_list.html');
                        }
                    } else {
                        if (queryWechatStateInterval) {
                            clearTimeout(queryWechatStateInterval);
                        }

                        queryWechatStateInterval = setTimeout(queryWechatState, 1000);
                    }

                    kit.resolve(key);
                }).fail(function () {
                    if (queryWechatStateInterval) {
                        clearTimeout(queryWechatStateInterval);
                    }

                    queryWechatStateInterval = setTimeout(queryWechatState, 1000);

                    kit.resolve(key);
                });
            });
        };

        // 微信直接弹出二维码
        var htmlStr = ['<div class="wx-pay-dialog">', '<div class="wx-pay-main">', '<div class="wx-pay-head">', '<div class="wx-pay-title">支付' + data.money + '元</div>', '<div class="wx-pay-close"><i class="iconfont">&#xe618;</i> </div>', '</div>', '<div class="wx-pay-des">微信扫码支付</div>', '<div class="wx-pay-qcode"><img src="' + data.url + '" > </div>', '<div class="wx-pay-operations">', '</div>', '</div>', '</div>'].join('');

        (0, _jquery2.default)('body').append(htmlStr).on('click', '.wx-pay-close', function () {
            (0, _jquery2.default)('.wx-pay-dialog').remove();
            _ajax2.default.pjax('/order_list.html');

            if (queryWechatStateInterval) {
                clearTimeout(queryWechatStateInterval);
            }
        });

        // 支付成功后需要轮休后台查询支付的状态
        var kit;
        var queryWechatStateInterval;
        queryWechatStateInterval = setTimeout(queryWechatState, 1000);
    }
};

// 美洽客服
(0, _jquery2.default)(function () {
    var entId = (0, _jquery2.default)("#js-hiddens input[name='meiqia']").val();
    (function (m, ei, q, i, a, j, s) {
        m[a] = m[a] || function () {
            (m[a].a = m[a].a || []).push(arguments);
        };
        j = ei.createElement(q), s = ei.getElementsByTagName(q)[0];
        j.async = true;
        j.charset = 'UTF-8';
        j.src = i + '?v=' + new Date().getUTCDate();
        s.parentNode.insertBefore(j, s);
    })(window, document, 'script', '//static.meiqia.com/dist/meiqia.js', '_MEIQIA');
    _MEIQIA('entId', entId);

    var userId = (0, _jquery2.default)("[name='userid']").val();
    if (userId) {
        // 同步顾客身份
        _MEIQIA('clientId', userId);
    }

    // 在这里开启手动模式（必须紧跟美洽的嵌入代码）
    _MEIQIA('manualInit');

    _MEIQIA('init');

    // 获取顾客信息并传递
    _MEIQIA('allSet', function () {
        _ajax2.default.getJSON('/meiqia/user-info.html').done(function (response) {
            if (response.type == 'succ') {
                var msg = response.msg;
                var sendMeiqia = {
                    name: msg.username,
                    tel: msg.mobile,
                    总订单数: msg.order_total,
                    总订单额: msg.expendamount + '元',
                    最后订单: msg.last_order_time || '无',
                    未支付订单: msg.orderInfo.unpaid[msg.orderInfo.unpaid.length - 1] || '无',
                    未发货订单: msg.orderInfo.waiting_for_send[msg.orderInfo.waiting_for_send.length - 1] || '无',
                    未确认订单: msg.orderInfo.waiting_for_confirm[msg.orderInfo.waiting_for_confirm.length - 1] || '无'
                };
                /// /循环未支付
                // for(var i = 0; i < msg.orderInfo.unpaid.length; i++){
                //    sendMeiqia['未支付订单' + (i + 1)] = msg.orderInfo.unpaid[i];
                // }
                //
                /// /循环未发货
                // for(var i = 0; i < msg.orderInfo.waiting_for_send.length; i++){
                //    sendMeiqia['未发货订单' + (i + 1)] = msg.orderInfo.waiting_for_send[i];
                // }
                //
                /// /循环未确认
                // for(var i = 0; i < msg.orderInfo.waiting_for_confirm.length; i++){
                //    sendMeiqia['未确认订单' + (i + 1)] = msg.orderInfo.waiting_for_confirm[i];
                // }

                // 传递顾客信息
                _MEIQIA('metadata', sendMeiqia);
            }
        });
    });
});

// 体育社登陆
function Empty(a) {
    return a == '' || void 0 == a || a == null ? !0 : !1;
}

window.tiyushe = tiyusheConfig || {};
tiyushe.avatar = function (a, b) {
    if (isNaN(a)) return '';
    Empty(b) && (b = 'small');
    var c = ('' + a).length,
        d = '';
    if (c < 9) {
        for (var e = 0; 9 - c > e; e++) {
            d += '0';
        }d += a;
    } else d = a;
    var f = d.substr(0, 3),
        g = d.substr(3, 2),
        h = d.substr(5, 2),
        i = f + '/' + g + '/' + h + '/' + d.slice(-2) + '_avatar_' + b + '.jpg';
    return tiyushe.domain + 'avatar/' + i + '?' + a + '_avatar_append.jpg';
};
tiyushe.client_logged = function () {
    this.logged();
};
tiyushe.logged = function () {
    document.getElementById('head-unlogin').style.display = 'none';
    document.getElementById('user-avatar').src = tiyushe.avatar(tiyushe.passport.uid);
    document.getElementById('user-name').innerHTML = tiyushe.passport.username;
    document.getElementById('head-personal').style.display = 'block';
};
tiyushe.unlogged = function () {
    document.getElementById('head-personal').style.display = 'none';
    document.getElementById('head-unlogin').style.display = 'block';
};
(function () {
    function ISC(a) {
        for (var b in a) {
            var c = document.createElement('script');
            c.type = 'text/javascript', c.async = !0, c.src = a[b];
            var d = document.getElementsByTagName('script')[0];
            d.parentNode.insertBefore(c, d);
        }
    }
    ISC([tiyushe.passportJsUrl]);
})();

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _stringify = __webpack_require__(78);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        tool = __webpack_require__(1),
        WebUploader = __webpack_require__(38);

    var hiddenValues, globleValues, refundKit;

    var vmodel = avalon.define({
        $id: 'applyRefundController',

        max_refund_fee: null,
        refund_fee: null,
        refund_reason: '',
        refund_remark: null,
        images: [],
        timeout: false,

        type: '1',
        // 类型不能点击了
        // typeClick: function(type) {
        //     vmodel.type = type;
        // },

        backClick: function backClick() {
            ajax.pjax(hiddenValues.referrer);
        },

        submitClick: function submitClick() {
            if (!vmodel.refund_fee || vmodel.refund_fee == '' || parseFloat(vmodel.refund_fee) <= 0) {
                dialog.alert('请填写正确的申请金额');
                return;
            }
            if (parseFloat(vmodel.refund_fee) > parseFloat(vmodel.max_refund_fee)) {
                dialog.alert('申请金额必须小于等于最大申请金额');
                return;
            }
            if (!vmodel.refund_reason || vmodel.refund_reason == '') {
                dialog.alert('请选择退款原因');
                return;
            }

            vmodel.refund_remark = vmodel.refund_remark || '';
            if (vmodel.refund_remark.length > 100) {
                dialog.alert('退货描述请小于100字符');
                return;
            }

            tool.singleWay('mall-order-pay-refound-' + hiddenValues.og_id, function (key) {
                refundKit = this;
                ajax.postWithFail('apply-refund.html', {
                    og_id: hiddenValues.og_id,
                    type: vmodel.type,
                    refund_fee: parseFloat(vmodel.refund_fee),
                    refund_reason: vmodel.refund_reason,
                    refund_remark: vmodel.refund_remark,
                    refund_img: (0, _stringify2.default)(vmodel.images)
                }).done(function (response) {
                    refundKit.resolve(key);

                    if (response.type === 'succ') {
                        ajax.pjax('apply-success.html?refund_id=' + response.msg);
                    }
                }).fail(function () {
                    refundKit.resolve(key);
                });
            });
        },

        deleteImagesClick: function deleteImagesClick(el) {
            vmodel.images.remove(el);
        }
    });

    vmodel.$watch('refund_fee', function (n) {
        if (n && n != '') {
            var v = translate(n);
            vmodel.refund_fee = v;
        }
    });

    // avalon.duplexHooks.float = {
    //     get: function(val, binding) {
    //         if(val != '') {
    //             var v = translate(val);
    //             binding.element.value = v;
    //             return v;
    //         }
    //     },
    //     set: function(val) {
    //         console.log(val)
    //         console.log(vmodel.refund_fee)
    //         return val;
    //     }
    // };

    function translate(val) {
        var old = val + '';

        var re = /^[0-9]+\.{0,1}[0-9]{0,2}$/; // 限制小数点后两位
        while (!re.test(old) && old !== '') {
            old = old.substr(0, old.length - 1);
        }

        return old;
    }

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            globleValues = tool.getHiddenValues('#js-hiddens');
            vmodel.max_refund_fee = hiddenValues.max_refund_fee;

            if (hiddenValues.timeout === '1') {
                vmodel.timeout = true;
            }
            if (hiddenValues.order_status == '2') {
                vmodel.type = '1';
            } else if (hiddenValues.order_status == '3' || hiddenValues.order_status == '4') {
                vmodel.type = '2';
            }

            var fileMaxSize = 1024 * 1024 * 2;
            var uploader = WebUploader.create({
                auto: true,
                swf: globleValues.frontUrl + '/frontcommon_assets/swf/Uploader.swf',
                server: '../../pay/refund/images.html?mod=refund',
                pick: '#filePicker',
                accept: {
                    title: 'Images',
                    extensions: 'gif,jpg,jpeg,bmp,png',
                    mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png'
                },
                fileVal: 'thefile',
                fileSingleSizeLimit: fileMaxSize,
                duplicate: true
            });
            uploader.on('uploadSuccess', function (file, response) {
                if (response.type === 'succ') {
                    vmodel.images.push(response.msg.fileurl);
                } else {
                    dialog.alert(response.msg);
                }
            });
            uploader.on('beforeFileQueued', function (file) {
                if (file.size > fileMaxSize) {
                    dialog.alert('文件大小超过2M限制');
                    return false;
                } else if (vmodel.images.length >= 5) {
                    dialog.alert('最多上传5张图片');
                    return false;
                }
            });
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        tool = __webpack_require__(1);

    var hiddenValues;

    var vmodel = avalon.define({
        $id: 'applyRefundResultController',
        refund: null,

        refund_flow_1: null, // 申请退款信息
        refund_flow_2: null, // 同意退款信息
        refund_flow_3: null // 确定退款信息
    });

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.refund = hiddenValues.refund;

            if (hiddenValues.refund_flow[0]) {
                vmodel.refund_flow_1 = hiddenValues.refund_flow[0];
            }
            if (hiddenValues.refund_flow[1]) {
                vmodel.refund_flow_2 = hiddenValues.refund_flow[1];
            }
            if (hiddenValues.refund_flow[2]) {
                vmodel.refund_flow_3 = hiddenValues.refund_flow[2];
            }

            // console.log(hiddenValues)
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        tool = __webpack_require__(1),
        orderKit;

    var hiddenValues, cancelRefundKit;

    var vmodel = avalon.define({
        $id: 'applyRefundStatusController',
        type: '', // 申请退款类型  1退款， 2 退货
        status: '', // 申请退款  1申请退款,2拒绝退款，3通过等待退款,4退款成功,5用户取消退款
        good_status: '', // 申请退货  0不退货，1申请退货，2拒绝退货，3等待收货，4退货成功
        refund_header: '',
        refund_status: [], // 申请退款信息
        expressInfo: {},

        cancelClick: function cancelClick() {
            tool.singleWay('mall-order-pay-refound-cancel-' + hiddenValues.refund_id, function (key) {
                cancelRefundKit = this;
                ajax.postWithFail('cancel-refund.html', {
                    refund_id: hiddenValues.refund_id
                }).done(function (response) {
                    cancelRefundKit.resolve(key);

                    if (response.type === 'succ') {
                        ajax.pjax('../../order_list.html');
                    }
                }).fail(function () {
                    cancelRefundKit.resolve(key);
                });
            });
        },

        expressCompany: null,
        expressNum: null,
        expressConfig: {},
        showExpressDialog: function showExpressDialog() {
            expressVmodel.isShowingDialog = true;
        },
        hideExpressDialog: function hideExpressDialog() {
            expressVmodel.isShowingDialog = false;
            vmodel.expressCompany = '';
            vmodel.expressNum = '';
            location.reload();
        },
        submitExpressDialog: function submitExpressDialog() {
            if (!vmodel.expressCompany || vmodel.expressCompany === '') {
                dialog.alert('请填写快递公司');
                return;
            }
            if (!vmodel.expressNum || vmodel.expressNum === '') {
                dialog.alert('请填写快递单号');
                return;
            }

            tool.singleWay('mall-order-pay-refound-order-' + hiddenValues.refund_id, function (key) {
                orderKit = this;
                ajax.getWithFail('save-express.html', {
                    refund_id: hiddenValues.refund_id,
                    company: vmodel.expressCompany,
                    order: vmodel.expressNum
                }).done(function (response) {
                    orderKit.resolve(key);

                    if (response.type === 'succ') {
                        dialog.alert('保存成功');
                        vmodel.hideExpressDialog();
                    }
                }).fail(function () {
                    orderKit.resolve(key);
                    vmodel.hideExpressDialog();
                });
            });
        },

        moneyClick: function moneyClick() {
            ajax.jump('flow.html?refund_id=' + hiddenValues.refund_id);
        }
    });

    var expressVmodel; // 弹出层控件的vmodel
    // window.vm = vmodel
    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.expressInfo = {
                expressCompany: hiddenValues.express_company,
                expressNumber: hiddenValues.express_order,
                is: true
            };

            vmodel.refund_header = hiddenValues.refund_header;
            vmodel.refund_status = hiddenValues.refund_status;
            vmodel.type = hiddenValues.refund_status[0].type;
            vmodel.status = hiddenValues.refund_status[0].refund_status;
            vmodel.good_status = hiddenValues.refund_status[0].refund_goods_status;

            vmodel.expressConfig = {
                onInit: function onInit(vm) {
                    expressVmodel = vm;
                },
                hiddenCallback: function hiddenCallback() {
                    vmodel.hideExpressDialog();
                },
                css: {
                    width: '300px',
                    left: '50%',
                    'margin-left': '-150px',
                    padding: 0
                }
            };
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _hash = __webpack_require__(39);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selected = {};

exports.default = {
    push: function push(attr) {
        selected[attr.key] = attr;
    },
    deleteAttr: function deleteAttr(attr) {
        delete selected[attr.key];
    },
    clear: function clear() {
        selected = {};
    },
    getAll: function getAll() {
        return selected;
    },
    getByExcept: function getByExcept(except) {
        var _selected = {};
        $.each(selected, function (key, attr) {
            if (key !== except) {
                _selected[key] = attr;
            }
        });
        return _selected;
    },
    getLength: function getLength(obj) {
        obj = obj || selected;
        var len = 0;
        $.each(obj, function () {
            len++;
        });
        return len;
    },
    _copyFriends: function _copyFriends(attr) {
        var res = {};
        for (var name in attr.friends) {
            if (attr.friends.hasOwnProperty(name)) {
                res[name] = attr.friends[name];
            }
        }
        return res;
    },
    getSelected: function getSelected() {
        return selected;
    },
    getFriends: function getFriends(_selected) {
        var res = {};
        var count = 0;
        var that = this;
        $.each(_selected, function (key, attr) {
            if (count === 0) {
                res = that._copyFriends(attr);
            } else {
                var _res = {};
                for (var name in attr.friends) {
                    if (attr.friends.hasOwnProperty(name)) {
                        if (res[name]) {
                            _res[name] = 1;
                        }
                    }
                }
                res = _res;
            }
            count++;
        });
        return res;
    },
    enable: function enable(list, except, index, length) {
        var that = this,
            _selected = that.getByExcept(except),
            stocks = _hash2.default.stocks;

        var res = that.getSelectedKey(_selected, length);

        $.each(list, function (i, attr) {
            res[attr.index] = '\\[' + attr.id + '\\]';
            var reg = that.toRegexp(res);
            $.each(stocks, function (key, goods) {
                if (reg.test(key)) {
                    if (goods.number !== 0) {
                        attr.disable = false;
                    }
                }
            });
        });

        //			if (len === 0) {
        //				// 当只有一个规格
        //				if (length === 1) {
        //					$.each(list, function(i, attr){
        //						attr.disable = stocks['['+attr.id+']'].number === 0;
        //					});
        //				} else {
        //					$.each(list, function(i, attr){
        //						attr.disable = false;
        //					});
        //				}
        //			} else {
        //				var res = that.getSelectedKey(_selected, length);
        //				$.each(list, function(i, attr){
        //					res[attr.index] = '\\[' + attr.id + '\\]';
        //					var reg = that.toRegexp(res);
        //					$.each(stocks, function(key, goods){
        //						if (reg.test(key)) {
        //							if (goods.number !== 0) {
        //								attr.disable = false;
        //								return;
        //							}
        //						}
        //					})
        //				})
        //			}
    },
    getSelectedKey: function getSelectedKey(hash, length) {
        var res = [];
        res.length = length;
        $.each(hash, function (i, attr) {
            res[attr.index] = '\\[' + attr.id + '\\]';
        });
        return res;
    },
    toRegexp: function toRegexp(array) {
        var res = $.map(array, function (str) {
            if (str === undefined) {
                return '\\[.*\\]';
            } else {
                return str;
            }
        }).join('');
        return new RegExp(res);
    },
    getAttrImgs: function getAttrImgs() {
        var imgs = {};
        $.each(selected, function (i, attrObject) {
            if (attrObject.imgs) {
                imgs.key = attrObject.value;
                imgs.imgs = attrObject.imgs;
                return false;
            }
        });
        return imgs;
    }
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        tool = __webpack_require__(1),
        $ = __webpack_require__(3);
    /* eslint-disable */
    var hiddenValues,
        selectedArray = [],
        plusLoading = false,
        minusLoading = false;

    function inSelected(id) {
        var selected = vmodel.selected,
            res = false;
        $.each(selected, function (i, _id) {
            if (id === _id) {
                res = true;
                return false;
            }
        });
        return res;
    }

    function validate(group) {
        var total = group.can_buy,
            res = {
            count: 0,
            totalPrice: 0,
            freight: 0,
            flag: true
        },
            freight_cut_money = tool.toNumber(group.freight_cut_money);
        $.each(group.sku, function (i, goods) {
            if (inSelected(goods.sku_id)) {
                res.count += tool.toNumber(goods.nums);
                res.totalPrice += goods.nums * tool.toNumber(goods.shop_price);
                res.freight = tool.toNumber(group.freight);
                if (tool.toNumber(goods.nums) !== 0) {
                    selectedArray.push(goods.sku_id.toString());
                }

                if (goods.nums > goods.number) {
                    res.flag = false;
                }
            }
        });

        if (freight_cut_money !== 0 && res.totalPrice >= freight_cut_money) {
            res.freight = 0;
        }

        //如果超过库存或者超过最大购买数量
        if (group.restrict && res.flag == true) {
            //限购
            res.flag = res.count <= total;
        } else if (res.flag == true) {
            res.flag = true;
        }

        return res;
    }

    function update() {
        selectedArray = [];

        var selected = vmodel.selected,
            list = vmodel.list,
            res = true,
            count = 0,
            totalPrice = 0,
            totalFreight = 0;

        $.each(list, function (i, group) {
            var v = validate(group);
            count += v.count;
            totalPrice += v.totalPrice;
            totalFreight += v.freight;
            if (!v.flag) {
                group.red = true;
                res = false;
            } else {
                group.red = false;
            }
        });

        vmodel.count = count;
        vmodel.totalPrice = tool.toMoney(totalPrice);
        vmodel.totalFreight = tool.toMoney(totalFreight);
        return res;
    }

    var vmodel = avalon.define({
        $id: 'cartController',
        list: [],
        count: 0, // 选了多少件商品,
        totalPrice: '0.00', // 总价是多少
        totalFreight: '0.00', // 总运费是多少

        //埋点数据统计
        sendEventTracking: function sendEventTracking(n) {
            tool.sendEventTracking('pc', n);
        },

        selected: [],
        selectedChange: function selectedChange() {
            vmodel.selectedAll = [];
            update();
        },

        selectedAll: [],
        selectAllChange: function selectAllChange() {
            if (vmodel.selectedAll.length) {
                $.each(vmodel.list, function (i, group) {
                    $.each(group.sku, function (i, goods) {
                        vmodel.selected.push(goods.sku_id);
                    });
                });
            } else {
                vmodel.selected = [];
            }
            update();
        },

        //
        submitLoading: false,
        submit: function submit() {
            if (vmodel.submitLoading === true) {
                return;
            } else if (selectedArray.length === 0) {
                dialog.alert('请至少选择一件商品');
            } else if (!update()) {
                dialog.alert('商品超过限购数量，请减少商品数量');
            } else {
                vmodel.sendEventTracking(10600);
                ajax.jump('order_clearing.html?skus=' + selectedArray.join('_'));
            }
        },

        // 商品数量操作
        changeNums: function changeNums(goods, type) {
            // 购买数量不能超过最大购买量
            if ($(this).hasClass('disabled')) {
                return;
            }

            var goods_num = tool.toNumber(goods.nums) + tool.toNumber(type);
            if (goods_num > goods.number) {
                goods_num = goods.number;
            }

            // 购买数量不能小于1
            if (tool.toNumber(goods_num) < 1) return;

            tool.singleWay('get-register', function (key) {
                minusLoading = this;

                ajax.postWithFail('add_to_cart.html', {
                    //action: 'minus',
                    sku_id: goods.sku_id,
                    nums: goods_num
                }).done(function (response) {
                    if (response.type === 'succ') {
                        goods.nums = goods_num;
                        update();
                    }

                    minusLoading.resolve(key);
                }).fail(function () {
                    minusLoading.resolve(key);
                });
            });
        },

        countPrice: function countPrice(goods) {
            var price = tool.toNumber(goods.shop_price);
            var nums = tool.toNumber(goods.nums);
            return tool.toMoney(price * nums);
        },

        // 删除商品
        deleteGoods: function deleteGoods(goods, group) {
            dialog.confirm('确认删除该商品吗？', function () {
                ajax.getWithFail(goods.delete_url).done(function () {
                    group.sku.remove(goods);
                    vmodel.selected.remove(goods.sku_id);
                    update();
                });
            });
        }
    });

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');

            $.each(hiddenValues.cart_list, function (i, group) {
                group.red = false;
                // group.restrict = !(tool.toNumber(group.can_buy) === -1);
                group.tips = '';

                if (group.ip_restrict == '0') {
                    group.hint = '本商品不限购';
                    group.can_buy = -1;
                    group.restrict = false;
                } else {
                    group.hint = '本商品每人限购' + group.ip_restrict + '件，您已购买' + group.purchased + '件';
                    group.can_buy = tool.toNumber(group.ip_restrict) - tool.toNumber(group.purchased);
                    group.restrict = true;
                }

                $.each(group.sku, function (i, sku) {
                    sku.nums = tool.toNumber(sku.buy_num); //当前购买数量
                    sku.groupid = group.id;
                });
            });
            vmodel.list = hiddenValues.cart_list;
            vmodel.selectedAll = ['on'];
            vmodel.selectAllChange();

            vmodel.sendEventTracking(10500);

            setTimeout(function () {
                $('#pjax-container .personal-aside').css('height', 'auto');
                tool.fixHeight($('#pjax-container .container'), $('#pjax-container .personal-aside'));
            }, 0);
        },
        clear: function clear() {
            vmodel.list = [];
            vmodel.count = 0; // 选了多少件商品,
            vmodel.totalPrice = '0.00'; // 总价是多少
            vmodel.totalFreight = '0.00'; // 总运费是多少
            vmodel.selected = [];
            vmodel.selectedAll = [];
            plusLoading = false;
            minusLoading = false;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        tool = __webpack_require__(1);

    var hiddenValues, getPaykit;

    // 支付成功后需要轮休后台查询支付的状态
    var queryWechatStateKit,
        queryWechatStateTime = 3000,
        queryWechatStateInterval;

    var vmodel = avalon.define({
        $id: 'checkstandController',
        payType: '1', // 支付类型 1 支付宝， 4 微信,  7 招行一网通
        order: {}, // 订单信息
        order_sku: [], // 订单详情
        discount: false, // 是否折扣
        isShowOrder: true, // 是否显示订单详情
        weixinUrl: null, // 微信地址

        typeClick: function typeClick(type) {
            if (type === '4' && !vmodel.weixinUrl) {
                // 如果是微信支付 且没有查询微信二维码 那就获取微信二维码
                vmodel.payClick(type);
            }
            vmodel.payType = type;

            if (queryWechatStateInterval) {
                clearTimeout(queryWechatStateInterval);
            }
            if (type === '4') {
                queryWechatStateInterval = setTimeout(queryWechatState, queryWechatStateTime);
            }
        },

        convertShowOrder: function convertShowOrder() {
            vmodel.isShowOrder = !vmodel.isShowOrder;
        },

        payClick: function payClick(type) {
            tool.singleWay('mall-order-list-pay-' + vmodel.order.order_id, function (key) {
                getPaykit = this;
                ajax.getWithFail('pay.html', {
                    order_id: vmodel.order.order_id,
                    channel_id: type
                }).done(function (response) {
                    getPaykit.resolve(key);

                    var msg = response.msg;
                    if (msg.channel_id == 0 || msg.channel_id == 1 || !msg.money) {
                        // 金额为0直接支付 或 支付宝直接跳转
                        ajax.pjax(msg.url);
                    } else if (msg.channel_id == 4) {
                        // 微信支付
                        vmodel.weixinUrl = msg.url;
                    }
                    // else if(msg.channel_id == 7) { //招行一网通
                    //     var form = $(msg.url);
                    //     form.css('display', 'none');
                    //     form.append('<input type="submit" value="submit">')
                    //     $(document.body).append(form);
                    //     form.find('input[type="submit"]').trigger("click");
                    // }
                }).fail(function () {
                    getPaykit.resolve(key);
                });
            });
        }
    });

    // 查询微信支付的状态
    function queryWechatState() {
        tool.singleWay('query-wechat-state-' + vmodel.order.order_id, function (key) {
            queryWechatStateKit = this;

            ajax.get('check-is-finished.html', {
                order_id: vmodel.order.order_id
            }).done(function (resp) {
                if (queryWechatStateInterval) {
                    clearTimeout(queryWechatStateInterval);
                }

                if (resp.type === 'succ') {
                    ajax.pjax('/order_list.html');
                } else {
                    queryWechatStateInterval = setTimeout(queryWechatState, queryWechatStateTime);
                }

                queryWechatStateKit.resolve(key);
            }).fail(function () {
                if (queryWechatStateInterval) {
                    clearTimeout(queryWechatStateInterval);
                }

                queryWechatStateInterval = setTimeout(queryWechatState, queryWechatStateTime);

                queryWechatStateKit.resolve(key);
            });
        });
    }

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.order = hiddenValues.order;
            vmodel.order_sku = hiddenValues.order_sku;
            vmodel.discount = hiddenValues.discount;
        },
        clear: function clear() {
            if (queryWechatStateInterval) {
                clearTimeout(queryWechatStateInterval);
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        tool = __webpack_require__(1);

    var hiddenValues, getPaykit;

    // 支付成功后需要轮休后台查询支付的状态
    var queryWechatStateKit,
        queryWechatStateTime = 3000,
        queryWechatStateInterval;

    var vmodel = avalon.define({
        $id: 'cooperCashController',
        payType: '1', // 支付类型 1 支付宝， 4 微信

        order: {},
        order_sku: [],

        isShowOrder: false,
        convertShowOrder: function convertShowOrder() {
            vmodel.isShowOrder = !vmodel.isShowOrder;
        },

        weixinUrl: '',
        discount: false,

        typeClick: function typeClick(type) {
            if (type === '4' && !vmodel.weixinUrl) {
                // 如果是微信支付 且没有查询微信二维码 那就获取微信二维码
                vmodel.payClick(type);
            }
            vmodel.payType = type;

            if (queryWechatStateInterval) {
                clearTimeout(queryWechatStateInterval);
            }
            if (type === '4') {
                queryWechatStateInterval = setTimeout(queryWechatState, queryWechatStateTime);
            }
        },

        payClick: function payClick(type) {
            tool.singleWay('mall-order-list-pay-' + vmodel.order.order_id, function (key) {
                getPaykit = this;
                ajax.getWithFail('../default/pay.html', {
                    order_id: vmodel.order.order_id,
                    channel_id: type
                }).done(function (response) {
                    getPaykit.resolve(key);

                    var msg = response.msg;
                    if (msg.channel_id == 0 || msg.channel_id == 1 || !msg.money) {
                        // 金额为0直接支付 或 支付宝直接跳转
                        ajax.pjax(msg.url);
                    } else {
                        vmodel.weixinUrl = msg.url;
                    }
                }).fail(function () {
                    getPaykit.resolve(key);
                });
            });
        }
    });

    // 查询微信支付的状态
    function queryWechatState() {
        tool.singleWay('query-reward-wechat-state-' + vmodel.order.order_id, function (key) {
            queryWechatStateKit = this;

            ajax.get('../default/check-is-finished.html', {
                order_id: vmodel.order.order_id
            }).done(function (resp) {
                if (queryWechatStateInterval) {
                    clearTimeout(queryWechatStateInterval);
                }

                if (resp.type === 'succ') {
                    ajax.pjax('/order_list.html');
                } else {
                    queryWechatStateInterval = setTimeout(queryWechatState, queryWechatStateTime);
                }

                queryWechatStateKit.resolve(key);
            }).fail(function () {
                if (queryWechatStateInterval) {
                    clearTimeout(queryWechatStateInterval);
                }

                queryWechatStateInterval = setTimeout(queryWechatState, queryWechatStateTime);

                queryWechatStateKit.resolve(key);
            });
        });
    }

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.order = hiddenValues.order;
            vmodel.order_sku = hiddenValues.order_sku;
            vmodel.discount = hiddenValues.discount;

            console.log(hiddenValues);
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        tool = __webpack_require__(1);

    var hiddenValues, rewardConfirmKit;

    var vmodel = avalon.define({
        $id: 'cooperIndexController',
        cooper_amount: '', // 打赏总额
        title: '', // 打赏标题
        finalMoney: '0', // 最终总额
        usable_voucher: '0', // 代金券总额
        usedVoucher: false, // 是否使用代金券
        usedVoucherChange: function usedVoucherChange() {
            if (vmodel.usedVoucher) {
                var t = tool.toNumber(vmodel.cooper_amount) - tool.toNumber(vmodel.usable_voucher);
                vmodel.finalMoney = t >= 0 ? t : 0;
            } else {
                vmodel.finalMoney = vmodel.cooper_amount;
            }
        },
        pay: function pay() {
            tool.singleWay('order-confirm-pay', function (key) {
                rewardConfirmKit = this;

                ajax.post('create.html', {
                    cooper_amount: hiddenValues.cooper_amount,
                    use_coupon: vmodel.usedVoucher ? '1' : '0'
                }).done(function (response) {
                    if (response.type == 'error' || response.type == 'err') {
                        return dialog.confirm(response.msg, function () {
                            // ajax.pjax('/cart_list.html');
                        }, function () {
                            // ajax.pjax('/cart_list.html');
                        });
                    }
                    ajax.pjax(response.url);

                    rewardConfirmKit.resolve(key);
                }).fail(function () {
                    rewardConfirmKit.resolve(key);
                });
            });
        }
    });

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');

            vmodel.cooper_amount = hiddenValues.cooper_amount;
            vmodel.title = hiddenValues.title;

            if (hiddenValues.coupon && tool.toNumber(hiddenValues.coupon) > 0) {
                vmodel.usedVoucher = true;
                vmodel.usable_voucher = hiddenValues.coupon;

                var cooper_amount = tool.toNumber(hiddenValues.cooper_amount);
                var coupon = tool.toNumber(hiddenValues.coupon);
                if (cooper_amount - coupon >= 0) {
                    vmodel.finalMoney = cooper_amount - coupon;
                } else {
                    vmodel.finalMoney = coupon - cooper_amount;
                }
            }

            console.log(hiddenValues);
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var dialog = __webpack_require__(4),
        avalon = __webpack_require__(0),
        chooserDialog = null,
        location = window.GLOBAL_LOCATION,
        gOnSelect = null,
        html = ["<div class='dest-chooser-wrap st' ms-controller='destinationChooser'>", "<ul class='provinces clearfix'>", "<li ms-repeat='provinces' ms-class-1='choosed:el.id===choosedProvinceId' ms-click='chooseProvince(el)'>[[el.name]]</li>", '</ul>', "<ul class='citys clearfix'><li ms-repeat='citys' ms-click='chooseCity(el)'>[[el.name]]</li></ul>", '</div>'].join(''),
        vmodel = avalon.define({
        $id: 'destinationChooser',
        provinces: location,
        choosedProvinceId: 0,
        chooseProvince: function chooseProvince(province) {
            vmodel.choosedProvinceId = province.id;
            vmodel.citys = province.city;
            if (province.muni === '1') {
                vmodel.chooseCity(vmodel.citys[0]);
            }
        },
        citys: [],
        chooseCity: function chooseCity(city) {
            gOnSelect && gOnSelect(city.$model);
            chooserDialog.close();
        }
    });

    return {
        open: function open(onSelect, cityId) {
            if (!chooserDialog) {
                chooserDialog = dialog.init({
                    title: '选择目的地',
                    html: html,
                    width: 520,
                    onClose: function onClose() {
                        vmodel.citys.clear();
                        vmodel.choosedProvinceId = 0;
                    }
                });
                avalon.scan(chooserDialog.domBody.get(0), vmodel);
            }

            if (cityId) {
                $.each(location, function (i, province) {
                    var find = false;
                    $.each(province.city, function (j, city) {
                        if (city.id === cityId) {
                            if (province.muni !== '1') {
                                vmodel.citys = province.city;
                                vmodel.choosedProvinceId = province.id;
                            }
                            find = true;
                            return false;
                        }
                    });
                    if (find) {
                        return false;
                    }
                });
            }

            gOnSelect = onSelect;
            chooserDialog.open();
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _avalon = __webpack_require__(0);

var _avalon2 = _interopRequireDefault(_avalon);

var _dialog = __webpack_require__(4);

var _dialog2 = _interopRequireDefault(_dialog);

var _hash = __webpack_require__(39);

var _hash2 = _interopRequireDefault(_hash);

var _selected = __webpack_require__(60);

var _selected2 = _interopRequireDefault(_selected);

var _slider = __webpack_require__(37);

var _slider2 = _interopRequireDefault(_slider);

var _ajax = __webpack_require__(2);

var _ajax2 = _interopRequireDefault(_ajax);

var _pagination = __webpack_require__(15);

var _pagination2 = _interopRequireDefault(_pagination);

var _toolLoaderPC = __webpack_require__(1);

var _toolLoaderPC2 = _interopRequireDefault(_toolLoaderPC);

var _destinationChooser = __webpack_require__(65);

var _destinationChooser2 = _interopRequireDefault(_destinationChooser);

var _piczoom = __webpack_require__(36);

var _piczoom2 = _interopRequireDefault(_piczoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var evaluateListUrl = '';
var consultListUrl = ''; // 反馈咨询的发布链接

function updateCountAndAddToCart() {
    if (vmodel.canbuy === -1) {
        // 如果不限购
        var min = vmodel.stock;
        if (min === 0) {
            vmodel.count = 0;
        } else {
            if (vmodel.count === 0) {
                vmodel.count = 1;
            } else {
                vmodel.count = _toolLoaderPC2.default.min([vmodel.count, vmodel.stock]);
            }
        }
    } else {
        // 如果限购
        var min = _toolLoaderPC2.default.min([vmodel.stock, vmodel.canbuy]);
        if (min === 0) {
            vmodel.count = 0;
        } else {
            if (vmodel.count === 0) {
                vmodel.count = 1;
            } else {
                vmodel.count = _toolLoaderPC2.default.min([vmodel.count, vmodel.stock, vmodel.canbuy]);
            }
        }
    }
    // 未开始闪购
    if (hiddenValues.activeTime.shopping === 'N') {
        vmodel.addToCartDisable = true;
    } else {
        vmodel.addToCartDisable = min === 0;
    }
}

var sliderInstance, // 大图幻灯插件
hiddenValues, // 局部隐藏域的值
groups; // 属性分组

var vmodel = _avalon2.default.define({
    $id: 'detailController',

    sku_id: '', // 商品唯一ID

    marketPrice: 0, // 市场价格
    price: 0, // 折后价格
    current_price: 0, // 折后最低价
    presented_voucher: 0, // 赠送的代金券
    // max_voucher: 0, 		// 可抵扣的代金券

    cut: 0, // 折扣
    stock: 0, // 库存
    stockVisible: false,
    attributes: [], // 属性
    imgsKey: '', // 图片标记

    remark: '', // 商品的备注

    limitLabel: '', // 商品限购提示
    canbuy: -1, // 商品限购数量 -1表示不限购

    activeLabel: '', // 商品活动提示
    activeTime: '', // 闪购事件

    sell_total: 0, // 总销量

    mark_tags: [], // 商品营销标签
    star_tags: '', // 商品球星系列

    count: 1,

    // 埋点数据统计
    sendEventTracking: function sendEventTracking(n, param) {
        _toolLoaderPC2.default.sendEventTracking('pc', n, param);
    },

    minusCount: function minusCount() {
        var max = 0,
            count = vmodel.count;

        if (vmodel.count === 0 || vmodel.count === 1) {
            //				dialog.alert('数量不能再少了');
            return;
        }

        if (vmodel.canbuy === -1) {
            if (vmodel.stock > 0) {
                max = 1;
            } else {
                max = 0;
            }
        } else {
            max = _toolLoaderPC2.default.min([vmodel.stock, vmodel.canbuy]);
            max = max > 0 ? 1 : 0;
        }
        vmodel.count = Math.max(max, count - 1);
    },
    plusCount: function plusCount() {
        if (vmodel.count === vmodel.stock) {
            //				dialog.alert('库存不足');
            return;
        }

        var canbuy = vmodel.canbuy < 0 ? 0 : vmodel.canbuy;
        if (vmodel.canbuy !== -1) {
            if (vmodel.count === vmodel.canbuy) {
                //					dialog.alert('购买数量不能超过所能购买的数量');
                return;
            }
            var min = _toolLoaderPC2.default.min([vmodel.stock, vmodel.count + 1, canbuy]);
            vmodel.count = min;
        } else {
            vmodel.count = _toolLoaderPC2.default.min([vmodel.stock, vmodel.count + 1]);
        }
    },

    select: function select(attr, group) {
        vmodel.sendEventTracking(10300);

        // var key = attr.key;
        var sameLevel = group.list;

        // 判断属性当前状态
        if (attr.disable) {
            // return;
        }
        if (attr.selected) {
            attr.selected = false;
            _selected2.default.deleteAttr(attr);
        } else {
            _jquery2.default.each(sameLevel, function (i, attr) {
                attr.selected = false;
            });
            attr.selected = true;
            _selected2.default.push(attr);
        }

        // 区分所有属性是否可选
        _jquery2.default.each(groups, function (i, group) {
            _hash2.default.disable(group.list);
            _selected2.default.enable(group.list, group.key, i, groups.length);
        });

        _toolLoaderPC2.default.setVMValues(vmodel, {
            remark: ''
        });

        // 判断是否选择了一个商品
        if (groups.length === _selected2.default.getLength()) {
            var source = _hash2.default.querySourceData(_selected2.default.getSelectedKey(_selected2.default.getSelected(), groups.length));
            if (!source || _selected2.default.getLength(source) === 0) {
                _toolLoaderPC2.default.setVMValues(vmodel, {
                    stock: 0,
                    count: 0,
                    price: -1,
                    current_price: _hash2.default.minPrice
                });
            } else {
                _toolLoaderPC2.default.setVMValues(vmodel, {
                    price: source.price,
                    stock: source.number,
                    marketPrice: source.marketPrice,
                    count: Math.min(vmodel.stock, vmodel.count),
                    cut: source.cut,
                    sku_id: source.sku_id,
                    current_price: source.price,
                    remark: source.remark
                });
                getFreight(vmodel.freight.$model);
            }
            vmodel.stockVisible = true;
        } else {
            _toolLoaderPC2.default.setVMValues(vmodel, {
                price: _hash2.default.getPriceRange(),
                stock: _hash2.default.getTotalStock(),
                cut: _hash2.default.getCutRange(),
                current_price: _hash2.default.minPrice,
                stockVisible: false,
                sku_id: ''
            });
        }
        // 更新count和按钮
        updateCountAndAddToCart();

        // 判断是否替换图片
        var imgs = _selected2.default.getAttrImgs();
        if (imgs.key) {
            if (vmodel.imgsKey !== imgs.key) {
                if (imgs.imgs && imgs.imgs.length > 0) {
                    sliderInstance.setImgs(imgs.imgs);
                } else {
                    sliderInstance.setImgs(hiddenValues.defaultImg);
                }
            }
            vmodel.imgsKey = imgs.key;
        } else {
            if (vmodel.imgsKey !== 'cover') {
                sliderInstance.setImgs(hiddenValues.defaultImg);
            }
            vmodel.imgsKey = 'cover';
        }

        // 存在秒杀就更新一下秒杀价格
        // 购物车展示的价格 存在秒杀进行时 就减秒杀价， 不存在就直接是商品价格

        if (hiddenValues.panic && hiddenValues.panic.panic_mark) {
            updatePanicPrice();
        }
    },

    addToCartDisable: false,
    addToCart: function addToCart() {
        if (vmodel.addToCartDisable) {
            return;
        } else if (groups.length !== _selected2.default.getLength()) {
            _dialog2.default.alert('请选择商品型号');
            vmodel.sendEventTracking(10401);
            return;
        } else if (_toolLoaderPC2.default.toNumber(vmodel.count) === 0) {
            _dialog2.default.alert('商品数量不能为0');
            vmodel.sendEventTracking(10401);
            return;
        }

        vmodel.sendEventTracking(10400);

        _toolLoaderPC2.default.singleWay('goods-detail-addtocart', function (key) {
            var kit = this;
            _ajax2.default.postWithFail(hiddenValues.options.addtocart, {
                sku_id: vmodel.sku_id,
                nums: vmodel.count
            }).done(function () {
                _ajax2.default.pjax('/cart_list.html');
                kit.resolve(key);
            }).fail(function () {
                kit.resolve(key);
            });
        });
    },

    menu: 'detail',
    // 移动到商品咨询
    moveToConsult: function moveToConsult() {
        vmodel.menu = 'consult';
        _toolLoaderPC2.default.scrollTo((0, _jquery2.default)('#js-consultlist'));
    },

    // 移动到商品详情
    moveToDetail: function moveToDetail() {
        vmodel.menu = 'detail';
        _toolLoaderPC2.default.scrollTo((0, _jquery2.default)('#goods-det'));
    },

    // 移动到商品评价
    moveToEvaluate: function moveToEvaluate() {
        vmodel.menu = 'evaluate';
        _toolLoaderPC2.default.scrollTo((0, _jquery2.default)('#goods-eva'));
    },

    // 咨询列表分页
    consultlist: [],
    consultPagination: _pagination2.default.init(10, 1, 10),
    consultGoPage: function consultGoPage(page) {
        if (page.disable) {
            return;
        }
        _dialog2.default.mask.show();
        _dialog2.default.progress.show(70);
        _ajax2.default.getWithFail(consultListUrl, {
            id: hiddenValues.options.goods_id,
            page: page.target
        }).done(function (response) {
            var pageData = response.message;
            vmodel.consultlist = pageData.data;
            vmodel.consultPagination = _pagination2.default.init(pageData.total, pageData.page, pageData.count);
            _dialog2.default.progress.width(100);
            setTimeout(function () {
                _dialog2.default.mask.hide();
                _dialog2.default.progress.hide();
                vmodel.moveToConsult();
            }, 500);
        });
    },

    // 提交咨询内容
    consultContent: '',
    submitConsult: function submitConsult() {
        if (vmodel.consultContent === '') {
            _dialog2.default.alert('咨询内容不能为空');
            return;
        }
        _toolLoaderPC2.default.singleWay('goods-detail-consult', function (key) {
            var kit = this;
            _ajax2.default.postWithFail('/feedback/message.html', {
                _csrf: hiddenValues._csrf,
                'FeedbackModel[content]': vmodel.consultContent,
                'FeedbackModel[goods_id]': hiddenValues.options.goods_id
            }).done(function () {
                _dialog2.default.alert('咨询发送成功，请耐心等待客服回复');
                vmodel.consultContent = '';
                kit.resolve(key);
            }).fail(function () {
                kit.resolve(key);
            });
        });
    },

    // 评价列表
    evaluate: {
        tag: []
    },
    evaluatelist: [],
    evaluateType: 0,
    evaluateChangeType: function evaluateChangeType(type) {
        if (vmodel.evaluateType != type) {
            vmodel.evaluateType = type;
            vmodel.evaluateGoPage(1);
        }
    },
    evaluatePagination: _pagination2.default.init(0, 1, 0),
    evaluateGoPage: function evaluateGoPage(page) {
        if (page.disable) {
            return;
        }
        _dialog2.default.mask.show();
        _dialog2.default.progress.show(70);
        _ajax2.default.getWithFail(evaluateListUrl, {
            id: hiddenValues.options.goods_id,
            type: vmodel.evaluateType, // 1 => 有图  0 => 所有
            page: page.target
        }).done(function (response) {
            var pageData = response.msg.list;
            vmodel.evaluatelist = evaluateAdd(pageData.evaluates);
            vmodel.evaluatePagination = _pagination2.default.init(pageData.total, pageData.page, pageData.count);
            _dialog2.default.progress.width(100);
            setTimeout(function () {
                _dialog2.default.mask.hide();
                _dialog2.default.progress.hide();
                vmodel.moveToEvaluate();
            }, 500);
        });
    },
    openMoreMessage: function openMoreMessage(el) {
        el.openMoreMessage = 1;
    },
    openImg: function openImg(el, index) {
        _piczoom2.default.show(el, index);
    },
    imgRendered: function imgRendered() {
        (0, _jquery2.default)('.lazy-background').lazyload({
            effect: 'fadeIn',
            // placeholder: window.server.cdnHost + '/dest/quanzi/images/default200.jpg',
            threshold: 300
        });
    },

    // 关注
    followed: false, // 已经关注过了
    follow: function follow() {
        _toolLoaderPC2.default.singleWay('goods-detail-follow', function (key) {
            var kit = this,
                url = vmodel.followed ? '/goods/cancel.html' : '/goods/concern.html',
                text = vmodel.followed ? '取消关注成功' : '关注成功';
            _ajax2.default.getWithFail(url, { id: hiddenValues.options.goods_id }).done(function () {
                _dialog2.default.alert(text);
                vmodel.followed = !vmodel.followed;
                kit.resolve(key);
            }).fail(function () {
                kit.resolve(key);
            });
        });
    },

    toTopVisible: true,
    toTopPositionBottom: 335,
    toTop: function toTop() {
        _toolLoaderPC2.default.scrollTo((0, _jquery2.default)('#header'));
    },

    freight: {},
    changeDestination: function changeDestination() {
        _destinationChooser2.default.open(function (city) {
            vmodel.freight.endDistrictId = city.id;
            vmodel.freight.endDistrictName = city.name;
            getFreight(vmodel.freight.$model);
        }, vmodel.freight.endDistrictId);
    },

    serviceClick: function serviceClick() {
        _MEIQIA('showPanel');
    },

    panic: {}, // 秒杀信息

    subtitle: '', // 子标题 当为秒杀的时候读秒杀标题

    promotion: [],
    isShowPromotionMask: false,

    isShowPromotion: false,

    togglePromotionClick: function togglePromotionClick(val) {
        vmodel.isShowPromotion = val;
    },

    getKeyalias: function getKeyalias(val) {
        val = val.length > 5 ? val.substr(0, 5) : val;
        return val + '：';
    }
});

// 数量输入校验
_avalon2.default.duplexHooks.count = {
    get: function get(val, binding) {
        if (val) {
            var old = val + '';

            while (!/^[0-9]*$/.test(old)) {
                old = old.substr(0, old.length - 1);
            }

            var n, able;
            var count = Number(old);
            if (count > vmodel.stock) {
                able = true;
                old = val + '';
                while (able) {
                    n = old.substr(0, old.length - 1);
                    if (Number(n) > vmodel.stock) {
                        old = n;
                        able = true;
                    } else {
                        able = false;
                    }
                }

                count = Number(n);
            }

            var canbuy = vmodel.canbuy < 0 ? 0 : vmodel.canbuy;
            if (vmodel.canbuy !== -1) {
                if (count > vmodel.canbuy) {
                    var min = _toolLoaderPC2.default.min([count, canbuy]);
                    count = min;
                }
            }

            vmodel.count = count;
            if (count != val) {
                binding.element.value = count;
            }

            return count;
        }
    },
    set: function set(val) {
        return val;
    }
};

vmodel.$watch('count', _toolLoaderPC2.default.debounce3(function () {
    getFreight(vmodel.freight.$model);
}, 500));

var getFreight = function () {
    var dtd = null;
    return function (freight) {
        console.log(vmodel.sku_id);
        dtd = _ajax2.default.getWithFail('/freight.html', {
            startDistrictId: freight.startDistrictId,
            endDistrictId: freight.endDistrictId,
            goods_id: hiddenValues.options.goods_id,
            sku_id: vmodel.sku_id || '0',
            num: vmodel.count
        });
        dtd.done(function (respones) {
            vmodel.freight.fee = respones.message.fee;
        });
    };
}();

var timeOper = {
    activeTime: 0,
    format: function format() {
        var miniSeconds = 1;
        var time = this.activeTime,
            dayTime = miniSeconds * 60 * 60 * 24,
            days = 0,
            hourTime = miniSeconds * 60 * 60,
            hours = 0,
            minuteTime = miniSeconds * 60,
            minutes = 0,
            secondTime = miniSeconds,
            seconds = 0,
            res = [];

        if (time >= dayTime) {
            days = Math.floor(time / dayTime);
            res.push(_toolLoaderPC2.default.fixNum(days) + '天');
            time -= days * dayTime;
        } else {
            res.push('00天');
        }
        if (time >= hourTime) {
            hours = Math.floor(time / hourTime);
            res.push(_toolLoaderPC2.default.fixNum(hours) + '时');
            time -= hours * hourTime;
        } else {
            res.push('00时');
        }
        if (time >= minuteTime) {
            minutes = Math.floor(time / minuteTime);
            res.push(_toolLoaderPC2.default.fixNum(minutes) + '分');
            time -= minutes * minuteTime;
        } else {
            res.push('00分');
        }
        if (time >= secondTime) {
            seconds = Math.floor(time / secondTime);
            res.push(_toolLoaderPC2.default.fixNum(seconds) + '秒');
            time -= seconds * secondTime;
        } else {
            res.push('00秒');
        }
        return res.join('');
    },
    start: function start() {
        var that = this;
        that.activeTime = _toolLoaderPC2.default.toNumber(hiddenValues.activeTime.timing);
        vmodel.activeLabel = hiddenValues.activeTime.message;

        updateCountAndAddToCart();

        // 未开始闪购且距离时间为0，说闪购已结束
        if (that.activeTime === 0 && hiddenValues.activeTime.shopping === 'N') {
            vmodel.activeLabel = '闪购已结束';
            vmodel.activeTime = '';
            return;
        }
        // 不限购
        if (that.activeTime === 0 && hiddenValues.activeTime.shopping === 'Y') {
            vmodel.activeLabel = '';
            vmodel.activeTime = '';
            return;
        }

        vmodel.activeTime = that.format();
        that.timer = setInterval(function () {
            that.activeTime -= 1;
            vmodel.activeTime = that.format();
            if (that.activeTime === 0) {
                that.stop();
            }
        }, 1000);
    },
    stop: function stop() {
        clearInterval(this.timer);
    }
};

// 初始化百度分享
window._bd_share_config = {
    common: {
        bdSnsKey: {},
        bdText: '我在爱羽客网站发现一件商品非常不错，希望你能够帮我参考一下',
        bdMini: '2',
        bdMiniList: false,
        bdStyle: '1',
        bdSize: '16',
        bdUrl: window.location.href + '?share_uid=' + (0, _jquery2.default)("[name='userid']").val(),
        bdPic: ''
    },
    share: {}
};

// 初始化秒杀信息
function initPanic() {
    hiddenValues.panic.formatTime = {};
    hiddenValues.panic.formatTimeInterval = null;
    hiddenValues.panic.endTime = null;
    hiddenValues.panic.panicPrice = null;

    vmodel.panic = hiddenValues.panic;
    if (vmodel.panic.status == 2) {
        var endTime = vmodel.panic.time * 1000 + new Date().getTime();
        vmodel.panic.endTime = endTime;

        vmodel.panic.formatTime = timeFormat();
        vmodel.panic.formatTimeInterval = setInterval(function () {
            vmodel.panic.formatTime = timeFormat();
        }, 1000);
    }
}

// 更新秒杀价格 切换商品属性的时候也要更新秒杀价格
function updatePanicPrice() {
    var separator = '－',
        price = vmodel.price,
        panicPrice = '';

    if ((price + '').indexOf(separator) != -1) {
        var temp = price.split(separator);

        temp[0] = _toolLoaderPC2.default.toNumber(temp[0]) - _toolLoaderPC2.default.toNumber(vmodel.panic.discount);
        temp[0] = temp[0] <= 0 ? 0 : temp[0];
        temp[0] = _toolLoaderPC2.default.toMoney(temp[0]);

        temp[1] = _toolLoaderPC2.default.toNumber(temp[1]) - _toolLoaderPC2.default.toNumber(vmodel.panic.discount);
        temp[1] = temp[1] <= 0 ? 0 : temp[1];
        temp[1] = _toolLoaderPC2.default.toMoney(temp[1]);

        panicPrice = temp[0] + separator + temp[1];
    } else {
        panicPrice = _toolLoaderPC2.default.toNumber(price) - _toolLoaderPC2.default.toNumber(vmodel.panic.discount);
        panicPrice = _toolLoaderPC2.default.toMoney(panicPrice);
    }

    vmodel.panic.panicPrice = panicPrice;
}

// 把秒转换为时间对象
function timeFormat() {
    var time = Math.floor((vmodel.panic.endTime - new Date().getTime()) / 1000);
    if (time <= 0) {
        return {
            day: 0,
            hour: 0,
            minute: 0,
            second: 0
        };
    }

    var day = Math.floor(time / (24 * 60 * 60));
    time = time - day * 24 * 60 * 60;
    var hour = Math.floor(time / (60 * 60));
    time = time - hour * 60 * 60;
    var minute = Math.floor(time / 60);
    time = time - minute * 60;
    var second = time;

    return {
        day: day,
        hour: hour >= 10 ? hour : '0' + hour,
        minute: minute >= 10 ? minute : '0' + minute,
        second: second >= 10 ? second : '0' + second
    };
}

// 给评价数据增加参数
function evaluateAdd(arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i].openMoreMessage = 0;
    }
    return arr;
}

exports.default = {
    init: function init() {
        // 设置顶部提示为显示 点击后隐藏
        (0, _jquery2.default)('body').css('min-width', '1540px');
        (0, _jquery2.default)('.shangou-remind').show();
        (0, _jquery2.default)('.shangou-remind .know').click(function () {
            (0, _jquery2.default)('.shangou-remind').hide();
        });

        hiddenValues = _toolLoaderPC2.default.getHiddenValues('#js-local-hiddens');
        // console.log(hiddenValues.promotion)

        sliderInstance = _slider2.default.init({
            selector: '#js-slider',
            imgs: hiddenValues.defaultImg,
            pagination: {
                selector: '#js-slider-pagination',
                render: function render(item) {
                    return item.html();
                }
            }
        });

        consultListUrl = hiddenValues.outPage.url;
        evaluateListUrl = hiddenValues.get_evaluate;
        hiddenValues.evaluate.list.evaluates = evaluateAdd(hiddenValues.evaluate.list.evaluates);

        if (hiddenValues.attributes && hiddenValues.attributes.length) {
            _hash2.default.initData(hiddenValues.attributes);
            groups = _hash2.default.toGroups();
            var hint = hiddenValues.shoppingLimit.hint; // 限购

            // hiddenValues.options.voucher.max_voucher = tool.toNumber(hiddenValues.options.voucher.max_voucher);
            hiddenValues.options.voucher.presented_voucher = _toolLoaderPC2.default.toNumber(hiddenValues.options.voucher.presented_voucher);

            // 运费初始化
            hiddenValues.freight.fee = _toolLoaderPC2.default.toMoney(hiddenValues.freight.fee);

            _toolLoaderPC2.default.setVMValues(vmodel, {
                attributes: groups,
                // 获取咨询列表
                consultlist: hiddenValues.outPage.data,
                consultPagination: _pagination2.default.init(hiddenValues.outPage.total, hiddenValues.outPage.page, hiddenValues.outPage.count),
                // 获取评价列表
                evaluatelist: hiddenValues.evaluate.list.evaluates,
                evaluatePagination: _pagination2.default.init(hiddenValues.evaluate.list.total, hiddenValues.evaluate.list.page, hiddenValues.evaluate.list.count),
                // 获取商品属性
                marketPrice: _hash2.default.getMarketPriceRange(),
                price: _hash2.default.getPriceRange(),
                stock: _hash2.default.getTotalStock(),
                cut: _hash2.default.getCutRange(),
                limitLabel: hint === -1 ? '本件商品不限购' : hint,
                canbuy: hiddenValues.shoppingLimit.can_buy,
                followed: _toolLoaderPC2.default.toNumber(hiddenValues.options.concern) === 1, // 关注
                freight: hiddenValues.freight,
                sell_total: hiddenValues.options.sell_total,
                // max_voucher: 						hiddenValues.options.voucher.max_voucher,
                presented_voucher: hiddenValues.options.voucher.presented_voucher,
                current_price: _hash2.default.minPrice,
                mark_tags: hiddenValues.mark_tags,
                star_tags: hiddenValues.star_tags,
                evaluate: hiddenValues.evaluate
            });
            _hash2.default.replaceAttrs(groups);
            updateCountAndAddToCart();

            // 异步获取地址信息
            _ajax2.default.getJSON('/goods/default/get-city-freight.html', {
                goods_id: hiddenValues.options.goods_id
            }).done(function (response) {
                if (response.type === 'success' || response.type === 'succ') {
                    _toolLoaderPC2.default.setVMValues(vmodel, {
                        freight: response.msg
                    });
                }
            });

            // 区分所有属性是否可选
            _jquery2.default.each(groups, function (i, group) {
                _hash2.default.disable(group.list);
                _selected2.default.enable(group.list, group.key, i, groups.length);
            });

            // 计时器
            timeOper.start();

            // 商品TAB标签随屏幕滚动
            var $tabs = (0, _jquery2.default)('#js-fixed-tabs'),
                offset = $tabs.offset();
            _toolLoaderPC2.default.onWindowScroll.on(function (e, top) {
                if (top === 0) {
                    vmodel.toTopVisible = false;
                } else {
                    vmodel.toTopVisible = true;
                }

                var clientHeight = _toolLoaderPC2.default.getClientHeight(),
                    scrollHeight = _toolLoaderPC2.default.getScrollHeight();

                if (scrollHeight - clientHeight - top < 335) {
                    vmodel.toTopPositionBottom = 335 - (scrollHeight - clientHeight - top);
                } else {
                    vmodel.toTopPositionBottom = 20;
                }

                if (top > offset.top) {
                    if (!$tabs.hasClass('fixed')) {
                        $tabs.addClass('fixed');
                        $tabs.parent().addClass('haspad');
                        setTimeout(function () {
                            $tabs.css({ top: 0 });
                        }, 0);
                    }
                } else {
                    if ($tabs.hasClass('fixed')) {
                        $tabs.parent().removeClass('haspad');
                        $tabs.removeClass('fixed').css({ top: -55 });
                    }
                }
            });

            _toolLoaderPC2.default.onWindowScroll.trigger();

            window._bd_share_config.common.bdPic = hiddenValues.defaultImg[0];

            // 初始化百度分享
            if (window._bd_share_main) {
                window._bd_share_main.init();
            } else {
                var script = document.createElement('script');
                script.src = '//bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5);
                document.getElementsByTagName('head')[0].appendChild(script);
            }

            // 有秒杀活动就执行
            hiddenValues.panic && hiddenValues.panic.panic_mark && initPanic();
            // 子标题
            vmodel.subtitle = hiddenValues.panic && hiddenValues.panic.panic_mark ? hiddenValues.panic.panic_title : hiddenValues.promotion && hiddenValues.promotion.show_mark ? hiddenValues.promotion.panic_title : hiddenValues.goodsProvider.subtitle;

            // 存在秒杀就更新一下秒杀价格
            // 购物车展示的价格 存在秒杀进行时 就减秒杀价， 不存在就直接是商品价格
            if (hiddenValues.panic && hiddenValues.panic.panic_mark) {
                updatePanicPrice();
            }

            // 促销信息
            if (hiddenValues.promotion && hiddenValues.promotion.show_mark) {
                vmodel.promotion = hiddenValues.promotion.active_info;
                vmodel.isShowPromotionMask = hiddenValues.promotion.show_mark == 'Y';
            }
        }

        vmodel.sendEventTracking(10201, {
            goodsid: hiddenValues.options.goods_id
        });

        (0, _jquery2.default)('img[data-original]').lazyload({
            effect: 'fadeIn'
        });
        vmodel.imgRendered();

        _piczoom2.default.init();
    },
    clear: function clear() {
        timeOper.stop();
        _selected2.default.clear();
        _hash2.default.clear();
        _toolLoaderPC2.default.onWindowScroll.clear();

        _toolLoaderPC2.default.setVMValues(vmodel, {
            consultContent: '',
            submitConsultLoading: false,
            addToCartLoading: false,
            addToCartDisable: false,
            stockVisible: false,
            count: 1,
            sell_total: 0
        });
        (0, _jquery2.default)('body').children('[id^=bdshare_],[class^=bdshare_],[class^=bd_]').hide();
        (0, _jquery2.default)('.shangou-remind').hide();

        // 取消秒杀定时器
        if (vmodel.fanic && vmodel.fanic.formatTimeInterval) {
            clearInterval(vmodel.fanic.formatTimeInterval);
        }
    }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        tool = __webpack_require__(1),
        hiddenValues = null;

    avalon.define({
        $id: 'errorController'
    });

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');

            var isSucceed = hiddenValues['is_pay_succeed'];
            if (isSucceed == 1) {
                tool.sendEventTracking('pc', '11400');
            }
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        tool = __webpack_require__(1),
        $ = __webpack_require__(3),
        piczoom = __webpack_require__(36),
        WebUploader = __webpack_require__(38),
        saveUrl,
        _csrf;

    var hiddenValues, globleValues;

    var vmodel = avalon.define({
        $id: 'evaluateController',

        type: '', // Y => 评价， N => 查看评价
        goods: [],

        anonymous: [], // 匿名

        changeScore: function changeScore(el, i) {
            if (vmodel.type == 'N') {
                return;
            }
            el.score = i;
        },

        checkTag: function checkTag(el, tagId) {
            var tags = el.tags,
                isTag = false;
            for (var i = 0; i < tags.length; i++) {
                if (tags[i] == tagId) {
                    isTag = true;
                    break;
                }
            }
            return isTag;
        },

        selectTag: function selectTag(el, tagId) {
            if (vmodel.type == 'N') {
                return;
            }
            var tags = el.tags,
                isTag = false;
            for (var i = 0; i < tags.length; i++) {
                if (tags[i] == tagId) {
                    isTag = true;
                    break;
                }
            }
            if (isTag) {
                el.tags.remove(tagId);
            } else {
                el.tags.push(tagId);
            }
        },

        initUpload: function initUpload() {
            var fileMaxSize = 1024 * 1024 * 2;
            // 扩展webupload对象
            $.extend(WebUploader.Uploader.options, {
                // 选完文件后，是否自动上传。
                auto: true,
                swf: globleValues.frontUrl + '/frontcommon_assets/swf/Uploader.swf',
                server: hiddenValues.upload,
                accept: {
                    title: 'Images',
                    extensions: 'gif,jpg,jpeg,bmp,png',
                    mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png'
                },
                fileVal: 'thefile',
                fileSingleSizeLimit: fileMaxSize,
                duplicate: true
            });
            for (var i = 0; i < vmodel.goods.length; i++) {
                // 初始化Web Uploader
                (function (i) {
                    var uploader = WebUploader.create({
                        pick: '.filePicker' + vmodel.goods[i].goods_id
                    });
                    uploader.on('uploadSuccess', function (file, response) {
                        if (response.type === 'succ') {
                            vmodel.goods[i].album.push(response.msg.fileurl);
                        } else {
                            dialog.alert(response.msg);
                        }
                    });
                    uploader.on('beforeFileQueued', function (file) {
                        if (file.size > fileMaxSize) {
                            dialog.alert('文件大小超过2M限制');
                            return false;
                        } else if (vmodel.goods[i].album.length >= 5) {
                            dialog.alert('最多上传5张图片');
                            return false;
                        }
                    });
                })(i);
            }
        },

        openImg: function openImg(el, index) {
            piczoom.show(el, index);
        },

        submitClick: function submitClick() {
            var sendData = {
                order_id: hiddenValues.order_id,
                anonymous: vmodel.anonymous.indexOf('1') != -1 ? 1 : 0,
                _csrf: _csrf,
                evaluate: []
            };

            for (var i = 0; i < vmodel.goods.length; i++) {
                if (vmodel.goods[i].score <= 0) {
                    return dialog.alert('还有商品没有评分哦！');
                } else {
                    sendData.evaluate.push({
                        GoodsEvaluate: {
                            sku_id: vmodel.goods[i].sku_id,
                            score: vmodel.goods[i].score,
                            content: vmodel.goods[i].content,
                            album: vmodel.goods[i].album,
                            tags: vmodel.goods[i].tags
                        }
                    });
                }
            }

            tool.singleWay('mall-evaluate', function (key) {
                var kit = this;
                ajax.postWithFail(saveUrl, sendData).done(function (response) {
                    kit.resolve(key);
                    if (response.type === 'succ') {
                        ajax.pjax(response.url);
                    }
                }).fail(function () {
                    kit.resolve(key);
                });
            });
        },

        deleteImagesClick: function deleteImagesClick(el, img) {
            el.album.remove(img);
        }
    });

    function buildGoods(arr) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].evaluate && arr[i].evaluate.score) {
                arr[i].tags = [];
                for (var j = 0; j < arr[i].tag_list.length; j++) {
                    if (arr[i].tag_list[j].selected == 1) {
                        arr[i].tags.push(arr[i].tag_list[j].tag_id);
                    }
                }
                arr[i].score = parseInt(arr[i].evaluate.score);
                arr[i].album = arr[i].evaluate.album;
                arr[i].content = arr[i].evaluate.content;
            } else {
                arr[i].tags = [];
                arr[i].score = 0;
                arr[i].album = [];
                arr[i].content = [];
            }
        }
        return arr;
    }

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            globleValues = tool.getHiddenValues('#js-hiddens');

            vmodel.goods = buildGoods(hiddenValues.orders.data);
            vmodel.type = hiddenValues.orders.type;
            saveUrl = hiddenValues.url;
            _csrf = hiddenValues._csrf;

            piczoom.init();
        },
        clear: function clear() {}
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _avalon = __webpack_require__(0);

var _avalon2 = _interopRequireDefault(_avalon);

var _slider = __webpack_require__(37);

var _slider2 = _interopRequireDefault(_slider);

var _tool = __webpack_require__(16);

var _tool2 = _interopRequireDefault(_tool);

var _ajax = __webpack_require__(2);

var _ajax2 = _interopRequireDefault(_ajax);

var _pagination = __webpack_require__(15);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hiddenValues = null,
    localHiddensGlobal,
    pages,
    urlParam,
    vmodel = _avalon2.default.define({
    $id: 'indexController',
    list: [],
    isAjaxGetData: false,
    consultPagination: _pagination2.default.init(0, 0, 0),
    index_title: '进行中',
    consultGoPage: function consultGoPage(page) {
        if (page.disable) {
            return;
        }
        // console.log(page)
        _ajax2.default.pjax('?page=' + page.target + '&' + urlParam);
    },

    sendEventTracking: function sendEventTracking(n) {
        _tool2.default.sendEventTracking('pc', n);
    },

    toTopVisible: true,
    toTopPositionBottom: 335,
    toTop: function toTop() {
        _tool2.default.scrollTo((0, _jquery2.default)('#header'));
    },
    rendered: function rendered() {
        (0, _jquery2.default)('img[data-original]').lazyload({
            effect: 'fadeIn',
            placeholder: localHiddensGlobal.frontUrl + 'dest/shangou/images/placeholder.jpg',
            threshold: 300
        });
    },
    getPanicPrice: function getPanicPrice(el) {
        var price = _tool2.default.toNumber(el.min_price) - _tool2.default.toNumber(el.panic_discount);
        price = price <= 0 ? 0 : price;
        price = _tool2.default.toMoney(price);
        return Number(price);
    }
});

exports.default = {
    init: function init() {
        hiddenValues = _tool2.default.getHiddenValues('#js-local-hiddens');
        localHiddensGlobal = _tool2.default.getHiddenValues('#js-hiddens');

        console.log(localHiddensGlobal);

        if (localHiddensGlobal.skin_on_off === '1') {
            var index_title = localHiddensGlobal.skin_config.index_title;
            if (index_title.indexOf('http://') === -1) {
                vmodel['index_title'] = index_title;
            }
        }

        var imgs = [];
        _jquery2.default.each(hiddenValues.ad_list, function (i, img) {
            imgs.push(img.img);
        });

        _slider2.default.init({
            selector: '#js-slider',
            height: 480,
            width: '100%',
            auto: true,
            forBg: true,
            imgs: imgs,
            onClick: function onClick(index) {
                index = _tool2.default.toNumber(index);
                _ajax2.default.pjax(hiddenValues.ad_list[index - 1].url);
            },
            pagination: {
                selector: '#js-slider-pagination',
                width: '100%',
                height: 10,
                itemWidth: 10,
                maxItemLength: 100,
                render: function render(item) {
                    return item.html();
                }
            }
        });

        var goodsList = hiddenValues.goods_list.data;
        for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].sell_total = null;
            goodsList[i].sku_total = null;
        }
        vmodel.list = goodsList;
        // console.log(vmodel.list.$model)

        pages = hiddenValues.goods_list.pages;
        urlParam = hiddenValues.url_param;

        vmodel.consultPagination = _pagination2.default.init(pages.total, pages.curpage, pages.pageSize);

        _tool2.default.onWindowScroll.on(function (e, top) {
            if (top === 0) {
                vmodel.toTopVisible = false;
            } else {
                vmodel.toTopVisible = true;
            }

            var clientHeight = _tool2.default.getClientHeight(),
                scrollHeight = _tool2.default.getScrollHeight();

            if (scrollHeight - clientHeight - top < 335) {
                vmodel.toTopPositionBottom = 335 - (scrollHeight - clientHeight - top);
            } else {
                vmodel.toTopPositionBottom = 20;
            }
        });

        // 动态获取销量数据
        var multiId = [];
        for (var i = 0; i < goodsList.length; i++) {
            multiId.push(goodsList[i].id);
        }
        _ajax2.default.postWithFail('/goods/default/goods-sale.html', {
            multi_id: multiId.join(',')
        }).done(function (response) {
            for (var i = 0; i < goodsList.length; i++) {
                vmodel.list[i].sell_total = response.msg[goodsList[i].id].sell_total;
                vmodel.list[i].sku_total = response.msg[goodsList[i].id].sku_total;
            }
            vmodel.isAjaxGetData = true;
        });

        vmodel.sendEventTracking(10100);
    },
    clear: function clear() {}
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    $('.overlay, .mask').fadeOut();
    $('#app-content').css('visibility', 'visible');
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toolLoaderPC = __webpack_require__(1);

var _toolLoaderPC2 = _interopRequireDefault(_toolLoaderPC);

var _validate = __webpack_require__(55);

var _validate2 = _interopRequireDefault(_validate);

var _dialog = __webpack_require__(4);

var _dialog2 = _interopRequireDefault(_dialog);

var _ajax = __webpack_require__(2);

var _ajax2 = _interopRequireDefault(_ajax);

var _avalon = __webpack_require__(0);

var _avalon2 = _interopRequireDefault(_avalon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hiddenValues; // 本页面隐藏域
var addressUnWatch; // 地址监控
var currentEditingAddress;
var location = window.GLOBAL_LOCATION;
var countFinalPriceDeffered = null;

function _resetAddress() {
    if (currentEditingAddress) {
        vmodel.recieveName = currentEditingAddress.name;
        vmodel.recievePhone = currentEditingAddress.mobile;
        vmodel.recieveAddress = currentEditingAddress.address;
        vmodel.recieveProvince = currentEditingAddress.province_id;
        vmodel.recieveCity = currentEditingAddress.city_id;
        vmodel.recieveArea = currentEditingAddress.district_id;
    } else {
        vmodel.provinces = location;
        vmodel.recieveProvince = location[0].id;
        vmodel.recieveName = ''; // 收货人姓名
        vmodel.recieveNameTips = ''; // 收货人姓名错误提示
        vmodel.recievePhone = ''; // 收货人手机号码
        vmodel.recievePhoneTips = ''; // 收货人手机号码错误提示
        vmodel.recieveAddress = ''; // 收货人详细信息
        vmodel.recieveAddressTips = ''; // 收货人详细信息错误提示
    }
    vmodel.recieveNameTips = '';
    vmodel.recievePhoneTips = '';
    vmodel.recieveAddressTips = '';
}

var vmodel = _avalon2.default.define({
    $id: 'orderConfirmController',
    list: [], // 商品信息
    allMoney: '', // 总金额
    allFreight: '', // 总运费
    finalFreight: '', // 优惠后最终运费
    cut_money: '0.00', // 优惠的金额
    usable_voucher: 0, // 可以使用的代金券金额
    finalMoney: '', // 优惠后最终金额
    remark: '', // 订单备注
    remarkPlaceholder: '', // 新加的备注输入框的placeholder
    promotiong: '', // 促销金额
    cod_promotiong: '', // 促销金额 返现

    canUseVoucher: false, // 是否可以使用代金券
    usedVoucher: [], // 是否使用了代金券，avalon的CheckBox必须是数组

    isCod: false, // 是否支持货到付款
    payOption: 'online', // 收货方式 'online' 在线付款 'cod' 货到付款

    member_address: [], // 收货信息列表
    choosedAddress: '', // 选择的地址的id

    addressAdder: false, // 地址编辑框是否显示
    recieveName: '', // 收货人姓名
    recieveNameTips: '', // 收货人姓名错误提示
    recievePhone: '', // 收货人手机号码
    recievePhoneTips: '', // 收货人手机号码错误提示
    recieveAddress: '', // 收货人详细信息
    recieveAddressTips: '', // 收货人详细信息错误提示
    recieveProvince: '', // 收货人所在省
    provinces: [], // 所有省
    recieveCity: '', // 收货人所在城市
    citys: [], // 所有市
    recieveArea: '', // 收货人所在区域
    areas: [], // 所有区
    saveRecieveLoading: false, // 保存收货人地址中...

    /**
     * 埋点数据统计
     */
    sendEventTracking: function sendEventTracking(n, param) {
        _toolLoaderPC2.default.sendEventTracking('pc', n, param);
    },

    /**
     * 选择收货地址
     */
    changeAddress: function changeAddress() {
        vmodel.countFinalPrice();
    },

    /**
     * 新增收货地址
     */
    addAddress: function addAddress() {
        currentEditingAddress = null;
        _resetAddress();
        vmodel.addressAdder = true;
    },

    /**
     * 编辑收货地址
     */
    editAddress: function editAddress(address) {
        currentEditingAddress = address;
        _resetAddress();
        vmodel.addressAdder = true;
    },

    /**
     * 删除收货地址
     */
    deleteAddress: function deleteAddress(address) {
        _dialog2.default.confirm('删除不能恢复，确认删除吗？', function () {
            vmodel.member_address.remove(address);
            _ajax2.default.getWithFail('delete_address.html', { id: address.id });
            if (vmodel.choosedAddress === address.id) {
                if (vmodel.member_address.length) {
                    vmodel.choosedAddress = vmodel.member_address[0].id;
                } else {
                    vmodel.choosedAddress = '';
                }
            }
            vmodel.countFinalPrice();
        });
    },

    /**
     * 关闭地址编辑框
     */
    returnToList: function returnToList() {
        vmodel.addressAdder = false;
        currentEditingAddress = null;
    },

    /**
     * 省市区编辑器 省级输入框改变
     */
    proinceChange: function proinceChange(id) {
        var provinces = vmodel.provinces;

        $.each(provinces, function (index, province) {
            if (id === province.id) {
                vmodel.citys = province.city;
                vmodel.recieveCity = province.city[0].id;
                return false;
            }
        });

        // if (currentEditingAddress) {
        //     vmodel.recieveCity = currentEditingAddress.city_id;
        // }
    },

    /**
     * 省市区编辑器 市级输入框改变
     */
    cityChange: function cityChange(id) {
        var citys = vmodel.citys;

        $.each(citys, function (index, city) {
            if (id === city.id) {
                vmodel.areas = city.area;
                vmodel.recieveArea = city.area[0].id;
                return false;
            }
        });

        // if (currentEditingAddress) {
        //     vmodel.recieveArea = currentEditingAddress.district_id;
        // }
    },

    /**
     * 保存收货人地址
     */
    saveRecieve: function saveRecieve() {
        var recieveNameValid = _validate2.default.valid(vmodel.recieveName, {
            required: { error: '收货人姓名不能为空' }
        });
        var recievePhoneValid = _validate2.default.valid(vmodel.recievePhone, {
            required: { error: '收货人手机号码不能为空' },
            mobilephohe: { error: '收货人手机格式不对' }
        });
        var recieveAddressValid = _validate2.default.valid(vmodel.recieveAddress, {
            required: { error: '收货人详细地址不能为空' },
            lengthMaxEqual: {
                value: 100,
                error: '您输入的字数已超过限制'
            }
        });
        if (recieveNameValid === true && recievePhoneValid === true && recieveAddressValid === true) {
            vmodel.saveRecieveLoading = true;
            var postData = {
                name: vmodel.recieveName,
                province: vmodel.recieveProvince,
                city: vmodel.recieveCity,
                district: vmodel.recieveArea,
                address: vmodel.recieveAddress,
                tel: vmodel.recievePhone
            };
            if (currentEditingAddress) {
                postData.id = currentEditingAddress.id;
                _ajax2.default.postWithFail('/update_address.html', postData).done(function (response) {
                    $.extend(currentEditingAddress, response.msg[postData.id]);
                    vmodel.saveRecieveLoading = false;
                    vmodel.addressAdder = false;
                    currentEditingAddress = null;
                }).fail(function () {
                    vmodel.saveRecieveLoading = false;
                });
            } else {
                _ajax2.default.postWithFail('/add_address.html', postData).done(function (response) {
                    vmodel.member_address.removeAll();
                    for (var i in response.msg) {
                        vmodel.member_address.push(response.msg[i]);
                    }
                    vmodel.saveRecieveLoading = false;
                    vmodel.addressAdder = false;
                }).fail(function () {
                    vmodel.saveRecieveLoading = false;
                });
            }
        } else {
            vmodel.recieveNameTips = recieveNameValid === true ? '' : recieveNameValid;
            vmodel.recievePhoneTips = recievePhoneValid === true ? '' : recievePhoneValid;
            vmodel.recieveAddressTips = recieveAddressValid === true ? '' : recieveAddressValid;
        }
        vmodel.countFinalPrice();
    },

    /**
     * 根据所选条件，结算价格
     */
    countFinalPrice: function countFinalPrice() {
        var isUse = vmodel.usedVoucher.length;
        var skus = hiddenValues.skus.join('_');
        countFinalPriceDeffered && countFinalPriceDeffered.request.abort();
        countFinalPriceDeffered = _ajax2.default.getWithFail('/order/default/use-voucher.html', {
            skus: skus,
            isUse: isUse,
            is_cod: vmodel.payOption === 'cod' ? 1 : 0,
            address_id: vmodel.choosedAddress
        }).done(function (response) {
            if (response.type == 'succ') {
                vmodel.promotiong = response.msg.promotion_amount;
                vmodel.real_amount = response.msg.real_amount;
                vmodel.finalFreight = response.msg.delivery_amount;
                vmodel.finalMoney = vmodel.real_amount;
            } else {
                _dialog2.default.alert('提示', response.msg);
            }
        });
    },

    /**
     * 切换支付方式
     */
    selectPayOption: function selectPayOption(type) {
        vmodel.payOption = type;
        if (type === 'cod') {
            // 货到付款
            vmodel.usedVoucher = [];
            _dialog2.default.alert('货到付款将无法使用代金券，且不参与任何线上优惠活动哦~', '是否选择货到付款？');
        } else {
            // 如果可使用代金券 默认勾选上使用
            if (vmodel.canUseVoucher) {
                vmodel.usedVoucher = ['1'];
            }
        }
        vmodel.countFinalPrice();
    },

    pay: function pay() {
        if (vmodel.choosedAddress === '') {
            vmodel.sendEventTracking(10901);
            _dialog2.default.alert('请选择收货人信息');
            _toolLoaderPC2.default.scrollTo($('#order-confirm .locations').parent());
        } else {
            _toolLoaderPC2.default.singleWay('order-confirm-pay', function (key) {
                var kit = this;
                vmodel.sendEventTracking(10900, {
                    goodslist: hiddenValues.skus.join('_')
                });
                _ajax2.default.post('order_create.html', {
                    address_id: vmodel.choosedAddress,
                    skus: hiddenValues.skus.join('_'),
                    vouchers: vmodel.usedVoucher.length ? 1 : 0,
                    channel_id: vmodel.payType,
                    remark: vmodel.remark,
                    is_cod: vmodel.payOption === 'cod' ? 1 : 0
                }).done(function (response) {
                    if (response.type == 'err') {
                        return _dialog2.default.confirm(response.msg, function () {
                            _ajax2.default.pjax('/cart_list.html');
                        }, function () {
                            _ajax2.default.pjax('/cart_list.html');
                        });
                    }
                    _ajax2.default.pjax(response.url);
                }).fail(function () {
                    kit.resolve(key);
                });
            });
        }
    }
});

window.vmodel = vmodel;

exports.default = {
    init: function init() {
        console.log(_dialog2.default);
        hiddenValues = _toolLoaderPC2.default.getHiddenValues('#js-local-hiddens');
        console.log(hiddenValues);
        // 是否支持货到付款
        vmodel.isCod = hiddenValues.isCod === '1';

        hiddenValues.fee.usable_voucher = _toolLoaderPC2.default.toNumber(hiddenValues.fee.usable_voucher);
        $.each(hiddenValues.cart_list, function (i, group) {
            group.restrict = !(_toolLoaderPC2.default.toNumber(group.time_restrict) === 0 && _toolLoaderPC2.default.toNumber(group.ip_restrict) === 0); // 组商品是否限购
            group.count = 0; // 组商品所购数量
            group.count2 = 0;
            //				group.max_voucher = tool.toNumber(group.max_voucher);			// 该组商品最多能使用多少优惠券
            //				group.min_voucher = tool.toNumber(group.min_voucher);			// 该组商品最少能使用多少优惠券
            //				group.useVouchers = false;										// 该组商品是否使用了优惠券
            //				group.canUseVouchers = group.max_voucher > 0 && hiddenValues.fee.usable_voucher > 0;	// 该组商品是否可使用优惠券
            //				group.usedVouchers = 0;											// 该组商品使用的优惠券
            //				group.usedVouchersForMoney = tool.toMoney(0);					// 该组商品使用优惠券抵用的金额

            var _groupMoney = 0; // 组总金额
            var _noDiscountGroupMoney = 0; // 不享受优惠的价格
            $.each(group.sku, function (j, goods) {
                var _nums = _toolLoaderPC2.default.toNumber(goods.buy_num);
                var _price = _toolLoaderPC2.default.toNumber(goods.shop_price);
                group.count += _nums;
                goods.total = _toolLoaderPC2.default.toMoney(_nums * _price);
                _groupMoney += parseFloat(goods.total);
            });
            $.each(group.sku, function (j, goods) {
                var _nums = _toolLoaderPC2.default.toNumber(goods.buy_num);
                var _price = _toolLoaderPC2.default.toNumber(goods.shop_origin_price);
                group.count2 += _nums;
                goods.total2 = _toolLoaderPC2.default.toMoney(_nums * _price);
                _noDiscountGroupMoney += parseFloat(goods.total2);
            });
            group.total = _toolLoaderPC2.default.toMoney(_groupMoney);
            group.total2 = _toolLoaderPC2.default.toMoney(_noDiscountGroupMoney);
        });

        currentEditingAddress = null;
        _resetAddress(); // 重置收货人信息输入框

        var fee = hiddenValues.fee;
        _toolLoaderPC2.default.setVMValues(vmodel, {
            allMoney: fee.sku_amount, // 商品总价
            finalMoney: fee.real_amount, // 合计最终支付价格
            finalFreight: fee.delivery_amount, // 运费合计
            cut_money: fee.favorable_amount, // 优惠合计
            list: hiddenValues.cart_list, // 绑定商品信息
            canUseVoucher: fee.usable_voucher > 0,
            usable_voucher: _toolLoaderPC2.default.toNumber(fee.usable_voucher).toFixed(2), // 拥有的优惠券
            member_address: hiddenValues.member_address, // 地址列表
            promotiong: fee.promotion_amount, // 促销金额,
            remarkPlaceholder: hiddenValues.remark || '还想对商家叮嘱什么..'
        });

        // 如果可使用代金券 默认勾选上使用
        if (vmodel.canUseVoucher) {
            vmodel.usedVoucher[0] = '1';
        }

        addressUnWatch = vmodel.$watch('recieveAddress', function (address) {
            var l = address.length;
            if (l <= 100) {
                vmodel.recieveAddressTips = '您还能输入' + (100 - l) + '个字';
            } else {
                vmodel.recieveAddressTips = '您输入的字数已超过限制';
            }
        });

        // 获取一次价格
        vmodel.countFinalPrice();
    },
    clear: function clear() {
        addressUnWatch && addressUnWatch();
        vmodel.choosedAddress = '';
        vmodel.choosedCoupon = '';
        vmodel.cut_money = '0.00';
    }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var $ = __webpack_require__(3),
        avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        tool = __webpack_require__(1),
        cancleDialog = null,
        receiptDialog = null,
        selectValue,
        showTime,
        timeInterval,
        nowTime,
        finishTime;

    function unixToDate(num) {
        var unixTimestamp = new Date(num * 1000);
        return {
            days: Math.floor(unixTimestamp / 86400000),
            hours: (unixTimestamp.getHours() - 8 + 24) % 24,
            minutes: unixTimestamp.getMinutes(),
            seconds: unixTimestamp.getSeconds()
        };
    }

    var hiddenValues,
    // logis = {},
    orderdetail;
    var vmodel = avalon.define({
        $id: 'orderDetailController',
        select: 0,
        data: {},
        payCountdown: {
            hours: 0,
            minutes: 0,
            seconds: 0,
            status: 0
        },
        receiptCountdown: {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            status: 0
        },

        // 埋点数据统计
        sendEventTracking: function sendEventTracking(n) {
            tool.sendEventTracking('pc', n);
        },

        payCountdownChange: function payCountdownChange() {
            nowTime = parseInt(new Date().getTime() / 1000);
            showTime = finishTime - nowTime;
            if (showTime <= 0) {
                return clearInterval(timeInterval);
            }
            var nowCountdown = unixToDate(showTime);
            vmodel.payCountdown = {
                hours: nowCountdown.hours,
                minutes: nowCountdown.minutes,
                seconds: nowCountdown.seconds,
                status: 1
            };
        },
        receiptCountdownChange: function receiptCountdownChange() {
            nowTime = parseInt(new Date().getTime() / 1000);
            showTime = finishTime - nowTime;
            if (showTime <= 0) {
                return clearInterval(timeInterval);
            }
            var nowCountdown = unixToDate(showTime);
            vmodel.receiptCountdown = {
                days: nowCountdown.days,
                hours: nowCountdown.hours,
                minutes: nowCountdown.minutes,
                seconds: nowCountdown.seconds,
                status: 1
            };
        },
        cancel: function cancel() {
            var selectHtml = '';
            for (var i = 0; i < selectValue.length; i++) {
                selectHtml += '<option value="' + i + '">' + selectValue[i] + '</option>';
            }

            var tmpl = ["<div class='d-b-prompt cancel-order-dialog'>", "<div class='d-form form-small'>", "<p class='label'>请选择取消订单的原因：</p>", "<div class='select-wrap'><select class='text-overflow reason'>" + selectHtml + '</select></div>', "<p class='label'>请留下你的宝贵建议</p>", "<div class='text-wrap'><textarea class='suggest' type='text' class='d-b-prompt-input' placeholder='留下你的宝贵建议'></textarea></div>", "<div class='row'><p class='error'></p></div>", '</div>', "<div class='d-operate'>", "<a href='javascript:void(0)' class='btn d-custom-cancel'>取消</a>", "<a href='javascript:void(0)' class='btn red d-custom-ok'>确定</a>", '</div>', '</div>'].join('');

            if (cancleDialog === null || cancleDialog.isDetroyed === true) {
                cancleDialog = dialog.init({
                    width: 500,
                    height: 370,
                    title: '取消订单',
                    onClose: function onClose(dialog, body) {
                        if (typeof dialog.cache.onCancel === 'function' && dialog.cache.onCancel.call(dialog, dialog, body) === false) {}
                    },
                    onInit: function onInit(dialog, body) {
                        body.on('click', '.d-custom-ok', function () {
                            if (typeof dialog.cache.onConfirmOK === 'function' && dialog.cache.onConfirmOK.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                        body.on('click', '.d-custom-cancel', function () {
                            if (typeof dialog.cache.onConfirmCancel === 'function' && dialog.cache.onConfirmCancel.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                    }
                });
            }

            cancleDialog.cache.onConfirmOK = function (__dialog, body) {
                var digDom = body.find('.btn.d-custom-ok');
                digDom.addClass('disable');
                ajax.getWithFail('/order_cancel.html', {
                    order_id: vmodel.data.order_id,
                    reasonKey: body.find('.reason').val(),
                    reason: body.find('.suggest').val()
                }).done(function (data) {
                    digDom.removeClass('disable');
                    if (data.type == 'succ') {
                        __dialog.close();
                        dialog.alert(data.msg);
                        vmodel.data.order_status = 5;
                    }
                }).fail(function () {
                    digDom.removeClass('disable');
                });
                return false;
            };
            cancleDialog.cache.onConfirmCancel = undefined;
            cancleDialog.setHtml(tmpl);
            cancleDialog.open();
        },
        receipt: function receipt() {
            var tmpl = ['<div class="d-b-confirm"><div class="d-text"><p>请确认你已经收到商品，并且同意支付给商家相应的款项。</p></div><div class="d-operate"><a href="javascript:void(0)" class="btn middle-btn red d-custom-ok">我已收到</a><a href="javascript:void(0)" class="btn middle-btn gray d-custom-cancel">我还没收到</a></div></div>'].join('');

            if (receiptDialog === null || receiptDialog.isDetroyed === true) {
                receiptDialog = dialog.init({
                    width: 420,
                    height: 245,
                    title: '确定收货',
                    onClose: function onClose(dialog, body) {
                        if (typeof dialog.cache.onCancel === 'function' && dialog.cache.onCancel.call(dialog, dialog, body) === false) {}
                    },
                    onInit: function onInit(dialog, body) {
                        body.on('click', '.d-custom-ok', function () {
                            if (typeof dialog.cache.onConfirmOK === 'function' && dialog.cache.onConfirmOK.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                        body.on('click', '.d-custom-cancel', function () {
                            if (typeof dialog.cache.onConfirmCancel === 'function' && dialog.cache.onConfirmCancel.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                    }
                });
            }

            receiptDialog.cache.onConfirmOK = function (__dialog, body) {
                var digDom = body.find('.btn.d-custom-ok');
                digDom.addClass('disable');
                ajax.getWithFail('/order_confirm.html', {
                    order_id: vmodel.data.order_id
                }, function (data) {
                    digDom.removeClass('disable');
                    if (data.type == 'succ') {
                        __dialog.close();
                        dialog.alert('确认收货成功！');
                        vmodel.data.order_status = 4;
                    }
                });
                return false;
            };
            receiptDialog.cache.onConfirmCancel = undefined;
            receiptDialog.setHtml(tmpl);
            receiptDialog.open();
        }
    });

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            console.log(hiddenValues);
            orderdetail = hiddenValues.order_detail;
            selectValue = hiddenValues.cancel_reason.order_reason;
            vmodel.select = hiddenValues.type;
            vmodel.data = orderdetail;

            // 判断是否显示倒计时
            nowTime = parseInt(new Date().getTime() / 1000);
            if (vmodel.data.order_status == 1 && orderdetail.default_cancel_time - nowTime > 0) {
                finishTime = orderdetail.default_cancel_time;
                showTime = finishTime - nowTime;
                vmodel.payCountdownChange();
                timeInterval = setInterval(function () {
                    vmodel.payCountdownChange();
                }, 1000);
            }
            if (vmodel.data.order_status == 3 && orderdetail.default_finnshed_time > 0) {
                finishTime = orderdetail.default_finnshed_time;
                showTime = finishTime - nowTime;
                vmodel.receiptCountdownChange();
                timeInterval = setInterval(function () {
                    vmodel.receiptCountdownChange();
                }, 1000);
            }

            vmodel.sendEventTracking(10701);
            // 进入购物车统计
            $('.go-to-cart').click(function () {
                vmodel.sendEventTracking(10500);
            });
        },
        clear: function clear() {
            clearInterval(timeInterval);
            vmodel.payCountdown = {
                hours: 0,
                minutes: 0,
                seconds: 0,
                status: 0
            };
            vmodel.receiptCountdown = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                status: 0
            };
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var $ = __webpack_require__(3),
        avalon = __webpack_require__(0),
        ajax = __webpack_require__(2),
        dialog = __webpack_require__(4),
        pagination = __webpack_require__(15),
        cancleDialog = null,
        receiptDialog = null,
        selectValue,
        tool = __webpack_require__(1);

    var hiddenValues, list, unwatch;

    var vmodel = avalon.define({
        $id: 'orderListController',
        date: parseInt(new Date().getTime() / 1000),
        data: [],

        // 埋点数据统计
        sendEventTracking: function sendEventTracking(n) {
            tool.sendEventTracking('pc', n);
        },

        select: 0,
        filter: {},
        type: 0,
        cancel: function cancel(order) {
            var selectHtml = '';
            for (var i = 0; i < selectValue.length; i++) {
                selectHtml += '<option value="' + i + '">' + selectValue[i] + '</option>';
            }

            var tmpl = ["<div class='d-b-prompt cancel-order-dialog'>", "<div class='d-form form-small'>", "<p class='label'>请选择取消订单的原因：</p>", "<div class='select-wrap'><select class='text-overflow reason'>" + selectHtml + '</select></div>', "<p class='label'>请留下你的宝贵建议</p>", "<div class='text-wrap'><textarea class='suggest' type='text' class='d-b-prompt-input' placeholder='留下你的宝贵建议'></textarea></div>", "<div class='row'><p class='error'></p></div>", '</div>', "<div class='d-operate'>", "<a href='javascript:void(0)' class='btn d-custom-cancel'>取消</a>", "<a href='javascript:void(0)' class='btn red d-custom-ok'>确定</a>", '</div>', '</div>'].join('');

            if (cancleDialog === null || cancleDialog.isDetroyed === true) {
                cancleDialog = dialog.init({
                    width: 500,
                    height: 370,
                    title: '取消订单',
                    onClose: function onClose(dialog, body) {
                        if (typeof dialog.cache.onCancel === 'function' && dialog.cache.onCancel.call(dialog, dialog, body) === false) {}
                    },
                    onInit: function onInit(dialog, body) {
                        body.on('click', '.d-custom-ok', function () {
                            if (typeof dialog.cache.onConfirmOK === 'function' && dialog.cache.onConfirmOK.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                        body.on('click', '.d-custom-cancel', function () {
                            if (typeof dialog.cache.onConfirmCancel === 'function' && dialog.cache.onConfirmCancel.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                    }
                });
            }

            cancleDialog.cache.onConfirmOK = function (__dialog, body) {
                var digDom = body.find('.btn.d-custom-ok');
                digDom.addClass('disable');
                ajax.getWithFail('/order_cancel.html', {
                    order_id: order.order_id,
                    reasonKey: body.find('.reason').val(),
                    reason: body.find('.suggest').val()
                }).done(function (data) {
                    digDom.removeClass('disable');
                    if (data.type == 'succ') {
                        __dialog.close();
                        dialog.alert(data.msg);
                        order.order_status = 5;
                    }
                }).fail(function () {
                    digDom.removeClass('disable');
                });
                return false;
            };
            cancleDialog.cache.onConfirmCancel = function (__dialog) {
                __dialog.onlyClose();
            };
            cancleDialog.setHtml(tmpl);
            cancleDialog.open();
        },
        receipt: function receipt(order) {
            var tmpl = ['<div class="d-b-confirm"><div class="d-text"><p>请确认你已经收到商品，并且同意支付给商家相应的款项。</p></div><div class="d-operate"><a href="javascript:void(0)" class="btn middle-btn red d-custom-ok">我已收到</a><a href="javascript:void(0)" class="btn middle-btn gray d-custom-cancel">我还没收到</a></div></div>'].join('');

            if (receiptDialog === null || receiptDialog.isDetroyed === true) {
                receiptDialog = dialog.init({
                    width: 420,
                    height: 245,
                    title: '确定收货',
                    onClose: function onClose(dialog, body) {
                        if (typeof dialog.cache.onCancel === 'function' && dialog.cache.onCancel.call(dialog, dialog, body) === false) {}
                    },
                    onInit: function onInit(dialog, body) {
                        body.on('click', '.d-custom-ok', function () {
                            if (typeof dialog.cache.onConfirmOK === 'function' && dialog.cache.onConfirmOK.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                        body.on('click', '.d-custom-cancel', function () {
                            if (typeof dialog.cache.onConfirmCancel === 'function' && dialog.cache.onConfirmCancel.call(dialog, dialog, body) === false) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                    }
                });
            }

            receiptDialog.cache.onConfirmOK = function (__dialog, body) {
                var digDom = body.find('.btn.d-custom-ok');
                digDom.addClass('disable');
                ajax.getWithFail('/order_confirm.html', {
                    order_id: order.order_id
                }, function (data) {
                    digDom.removeClass('disable');
                    if (data.type == 'succ') {
                        __dialog.close();
                        dialog.alert('确认收货成功！');
                        order.order_status = 4;
                    }
                });
                return false;
            };
            receiptDialog.cache.onConfirmCancel = function (__dialog) {
                __dialog.onlyClose();
            };
            receiptDialog.setHtml(tmpl);
            receiptDialog.open();
        },
        consultPagination: pagination.init(0, 0, 0),
        consultGoPage: function consultGoPage(page) {
            if (page.disable) {
                return;
            }
            ajax.pjax('?page=' + page.target + '&type=' + vmodel.select);
        }
    });

    window.avalon = avalon;

    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            selectValue = hiddenValues.cancel_reason.order_reason;
            list = hiddenValues.order_list;

            vmodel.data = list.order_list;
            vmodel.filter = list.filter.types;
            vmodel.select = list.filter.type;
            vmodel.consultPagination = pagination.init(list.page_list.total_count, list.page_list.page, list.page_list.page_size);
            unwatch = vmodel.$watch('select', function () {
                ajax.pjax('?type=' + vmodel.select);
            });

            setTimeout(function () {
                $('#pjax-container .personal-aside').css('height', 'auto');
                tool.fixHeight($('#pjax-container .container'), $('#pjax-container .personal-aside'));
            }, 0);
            vmodel.sendEventTracking(10700);
            // 进入购物车统计
            $('.go-to-cart').click(function () {
                vmodel.sendEventTracking(10500);
            });
        },
        clear: function clear() {
            unwatch();
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
    var $ = __webpack_require__(3),
        avalon = __webpack_require__(0),
        tool = __webpack_require__(1),
        ajax = __webpack_require__(2),
        pagination = __webpack_require__(15),
        hiddenValues = null,
        localHiddensGlobal,
        pages,
        urlParam,
        vmodel = avalon.define({
        $id: 'searchController',

        list: [],
        recoList: [],
        isAjaxGetData: false,
        consultPagination: pagination.init(0, 0, 0),
        brand: [],
        searchByMoney: [],
        filterMin: '',
        filterMax: '',
        state: '',
        keywords: $('#keywords') ? $('#keywords').val() : '',
        consultGoPage: function consultGoPage(page) {
            if (page.disable) {
                return;
            }
            var urlParams = tool.getUrlParams();
            urlParams.page = page.target;
            var url = tool.addParamToUrl('', urlParams);
            ajax.pjax(url);
        },

        sendEventTracking: function sendEventTracking(n) {
            // console.log(n)
            tool.sendEventTracking('pc', n);
        },

        toTopVisible: true,
        toTopPositionBottom: 335,
        toTop: function toTop() {
            tool.scrollTo($('#header'));
        },
        rendered: function rendered() {
            $('img[data-original]').lazyload({
                effect: 'fadeIn',
                placeholder: localHiddensGlobal.frontUrl + 'dest/shangou/images/placeholder.jpg',
                threshold: 300
            });
        },
        getPanicPrice: function getPanicPrice(el) {
            var price = tool.toNumber(el.min_price) - tool.toNumber(el.panic_discount);
            price = price <= 0 ? 0 : price;
            price = tool.toMoney(price);
            return Number(price);
        },
        filterSelect: function filterSelect(type, index) {
            if (vmodel[type][index].selected) {
                vmodel[type][index].selected = false;
            } else {
                vmodel[type].forEach(function (e) {
                    e.selected = false;
                });
                vmodel[type][index].selected = true;
            }
            if (type === 'searchByMoney') {
                vmodel.filterMax = '';
                vmodel.filterMin = '';
            }
        },
        filterConfirm: function filterConfirm() {
            var min, max;
            max = vmodel.filterMax;
            min = vmodel.filterMin;
            var brand = vmodel.brand.filter(function (el) {
                return el.selected;
            })[0];
            var minMax = vmodel.searchByMoney.filter(function (el) {
                return el.selected;
            })[0];
            if (minMax) {
                min = minMax.min;
                max = minMax.max;
            }
            vmodel.list = [];
            var urlParams = tool.getUrlParams();
            if (min) {
                urlParams.min = min;
            } else {
                delete urlParams.min;
            }
            if (max) {
                urlParams.max = max || '';
            } else {
                delete urlParams.max;
            }
            urlParams.brand_id = brand && brand.id;
            var url = tool.addParamToUrl(window.location.host + window.location.pathname, urlParams);
            vmodel.state = 'pending';
            ajax.pjax(tool.addParamToUrl('', delUndefined(urlParams)));
        },
        filterReset: function filterReset() {
            window.jump();
        },
        onMoneyInput: function onMoneyInput() {
            var max = vmodel.filterMax;
            var min = vmodel.filterMin;
            if (isNaN(min) || min < 0) vmodel.filterMin = 0;
            if (isNaN(max)) vmodel.filterMax = 0;
            if (min > 10000) vmodel.filterMin = 10000;
            if (max > 10000) vmodel.filterMax = 10000;
            addProp(vmodel.searchByMoney, 'selected', false);
        },
        sortByPrice: '', //价格排序类型 up 升序， down 降序
        sortBySell: '', //销量排序类型 up 升序， down 降序
        sortByReco: '', //推荐排序类型 up 升序， down 降序
        SORT_WAY: ['price', 'sell', 'reco'],
        sortClick: function sortClick(type) {
            vmodel.SORT_WAY.forEach(function (el) {
                var sort_way_key = 'sortBy' + el[0].toUpperCase() + el.slice(1);
                if (type !== el) {
                    vmodel[sort_way_key] = '';
                }
            });
            var urlParams = tool.getUrlParams();
            var sort_type = urlParams.sort_type;
            if (sort_type == 'down') {
                urlParams.sort_type = 'up';
            } else if (sort_type === 'up') {
                urlParams.sort_type = 'down';
            } else {
                urlParams.sort_type = 'down';
            }
            urlParams.sort_way = type;
            var url = tool.addParamToUrl('', urlParams);
            // location.href = location.protocol + '//' + url
            ajax.pjax(url);
        }
    });

    window.vm = vmodel;
    return {
        init: function init() {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            var brandSelected = vmodel.brand.filter(function (el) {
                return el.selected;
            });
            var searchByMoneySelected = vmodel.searchByMoney.filter(function (el) {
                return el.selected;
            });
            vmodel.recoList = hiddenValues.searchRecommend || [];
            if (!brandSelected.length && !searchByMoneySelected.length) {
                vmodel.searchByMoney = addProp(hiddenValues.searchByMoney, 'selected', false);
                vmodel.brand = addProp(hiddenValues.brand, 'selected', false);
            }

            // 从url参数获取搜索条件
            readFromUrl();

            localHiddensGlobal = tool.getHiddenValues('#js-hiddens');

            var goodsList = hiddenValues.goods_list.data || [];
            for (var i = 0; i < goodsList.length; i++) {
                goodsList[i].sell_total = null;
                goodsList[i].sku_total = null;
            }
            vmodel.list = goodsList;

            pages = hiddenValues.goods_list.pages;
            urlParam = hiddenValues.url_param;
            window.hiddenValues = hiddenValues;
            console.log(pages);
            vmodel.consultPagination = pagination.init(pages.total, pages.curpage, pages.pageSize);
            console.log(vmodel.consultPagination);

            tool.onWindowScroll.on(function (e, top) {
                if (top === 0) {
                    vmodel.toTopVisible = false;
                } else {
                    vmodel.toTopVisible = true;
                }

                var clientHeight = tool.getClientHeight(),
                    scrollHeight = tool.getScrollHeight();

                if (scrollHeight - clientHeight - top < 335) {
                    vmodel.toTopPositionBottom = 335 - (scrollHeight - clientHeight - top);
                } else {
                    vmodel.toTopPositionBottom = 20;
                }
            });

            //动态获取销量数据
            var multiId = [];
            for (var i = 0; i < goodsList.length; i++) {
                multiId.push(goodsList[i].id);
            }
            if (multiId.length) {
                ajax.postWithFail('/goods/default/goods-sale.html', {
                    multi_id: multiId.join(',')
                }).done(function (response) {
                    for (var i = 0; i < goodsList.length; i++) {
                        vmodel.list[i].sell_total = response.msg[goodsList[i].id].sell_total;
                        vmodel.list[i].sku_total = response.msg[goodsList[i].id].sku_total;
                    }
                    vmodel.isAjaxGetData = true;
                });
            }

            vmodel.sendEventTracking(10100);

            // 更改标题
            if (/search\.html/.test(location.href)) {
                $('title').text('搜索-爱羽客正品羽毛球装备购物商城');
            }

            $(document).on('pjax:complete', function () {
                // 重新初始化导航栏
                window.navInit && window.navInit();
                // 更新搜索关键字
                vmodel.keywords = $('#keywords') ? $('#keywords').val() : '';
                // 根据url参数显示隐藏搜索条件
                var urlParams = tool.getUrlParams();
                if (!urlParams['brand_id']) {
                    addProp(vmodel.brand, 'selected', false);
                }
                if (!urlParams['min']) {
                    addProp(vmodel.searchByMoney, 'selected', false);
                }
                if (!urlParams['sort_way']) {
                    ['sortByPrice', 'sortBySell', 'sortByReco'].forEach(function (el) {
                        vmodel[el] = '';
                    });
                }

                vmodel.state = '';
            });
        },
        clear: function clear() {}
    };

    function addProp(arr, prop, val) {
        return arr.map(function (el) {
            // if (!el[prop]) {
            el[prop] = val;
            // }
            return el;
        });
    }

    function delUndefined(obj) {
        for (var p in obj) {
            if (typeof obj[p] === 'undefined') {
                delete obj[p];
            }
        }
        return obj;
    }

    function readFromUrl() {
        var urlParams = tool.getUrlParams();
        if (urlParams.sort_way) {
            var sort_way_key = 'sortBy' + urlParams.sort_way[0].toUpperCase() + urlParams.sort_way.slice(1);
            vmodel[sort_way_key] = urlParams.sort_type || 'down';
        }
        if (urlParams.brand_id) {
            vmodel.brand.forEach(function (el, i) {
                if (urlParams.brand_id === el.id) {
                    el.selected = true;
                }
            });
        }
        var isSearchByMoneyLabel;
        vmodel.searchByMoney.forEach(function (el, i) {
            if (urlParams.min == el.min && urlParams.max == el.max || urlParams.min == el.min && !urlParams.max || urlParams.max == el.max && !urlParams.min) {
                el.selected = true;
                isSearchByMoneyLabel = true;
            }
        });
        if (!isSearchByMoneyLabel) {
            vmodel.filterMin = urlParams.min || '';
            vmodel.filterMax = urlParams.max || '';
        } else {
            vmodel.filterMin = '';
            vmodel.filterMax = '';
        }
    }
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(122);

var _vue2 = _interopRequireDefault(_vue);

var _groupBuyingJump = __webpack_require__(118);

var _groupBuyingJump2 = _interopRequireDefault(_groupBuyingJump);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    new _vue2.default({
        el: '#app-content',
        components: {
            'group-buying-jump': _groupBuyingJump2.default
        },
        data: {},
        methods: {}
    });
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            qrcode: window.server.url
        };
    },

    components: {}
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(85), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88), __esModule: true };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(80);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(6);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
var $Object = __webpack_require__(6).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
var $Object = __webpack_require__(6).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113);
__webpack_require__(111);
__webpack_require__(114);
__webpack_require__(115);
module.exports = __webpack_require__(6).Symbol;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112);
__webpack_require__(116);
module.exports = __webpack_require__(35).f('iterator');


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(11);
var toLength = __webpack_require__(106);
var toAbsoluteIndex = __webpack_require__(105);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(89);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(45);
var pIE = __webpack_require__(28);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(40);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(40);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(26);
var descriptor = __webpack_require__(21);
var setToStringTag = __webpack_require__(29);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(10)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(22)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(8);
var setDesc = __webpack_require__(9).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var anObject = __webpack_require__(17);
var getKeys = __webpack_require__(27);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(28);
var createDesc = __webpack_require__(21);
var toIObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(33);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(42);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(11);
var gOPN = __webpack_require__(44).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(107);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(23);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(32);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(23);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(90);
var step = __webpack_require__(98);
var Iterators = __webpack_require__(25);
var toIObject = __webpack_require__(11);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(43)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(26) });


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperty: __webpack_require__(9).f });


/***/ }),
/* 111 */
/***/ (function(module, exports) {



/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(104)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(43)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(47);
var META = __webpack_require__(99).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(31);
var setToStringTag = __webpack_require__(29);
var uid = __webpack_require__(22);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(35);
var wksDefine = __webpack_require__(34);
var enumKeys = __webpack_require__(93);
var isArray = __webpack_require__(96);
var anObject = __webpack_require__(17);
var isObject = __webpack_require__(14);
var toIObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(33);
var createDesc = __webpack_require__(21);
var _create = __webpack_require__(26);
var gOPNExt = __webpack_require__(102);
var $GOPD = __webpack_require__(101);
var $DP = __webpack_require__(9);
var $keys = __webpack_require__(27);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(44).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(28).f = $propertyIsEnumerable;
  __webpack_require__(45).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(20)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('asyncIterator');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('observable');


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
var global = __webpack_require__(5);
var hide = __webpack_require__(10);
var Iterators = __webpack_require__(25);
var TO_STRING_TAG = __webpack_require__(12)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(119)
/* script */
var __vue_script__ = __webpack_require__(77)
/* template */
var __vue_template__ = __webpack_require__(120)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0927e94c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',[_c('div',{staticClass:"title"}),_c('div',{staticClass:"p1"},[_vm._v("仅通过移动手机端购买")]),_c('div',{staticClass:"p2"},[_vm._v("请使用爱羽客app或者微信等扫一扫购买")]),_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.qrcode}})]),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-row"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("我知道啦")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/app.js